(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
},{}],2:[function(require,module,exports){
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
},{}],3:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
},{"./arrayLikeToArray":1}],4:[function(require,module,exports){
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
},{}],5:[function(require,module,exports){
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
},{}],6:[function(require,module,exports){
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
},{}],7:[function(require,module,exports){
var superPropBase = require("./superPropBase");

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

module.exports = _get;
},{"./superPropBase":18}],8:[function(require,module,exports){
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
},{}],9:[function(require,module,exports){
var setPrototypeOf = require("./setPrototypeOf");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
},{"./setPrototypeOf":16}],10:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
},{}],11:[function(require,module,exports){
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;
},{}],12:[function(require,module,exports){
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
},{}],13:[function(require,module,exports){
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
},{}],14:[function(require,module,exports){
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
},{}],15:[function(require,module,exports){
var _typeof = require("@babel/runtime/helpers/typeof");

var assertThisInitialized = require("./assertThisInitialized");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
},{"./assertThisInitialized":4,"@babel/runtime/helpers/typeof":20}],16:[function(require,module,exports){
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
},{}],17:[function(require,module,exports){
var arrayWithHoles = require("./arrayWithHoles");

var iterableToArrayLimit = require("./iterableToArrayLimit");

var unsupportedIterableToArray = require("./unsupportedIterableToArray");

var nonIterableRest = require("./nonIterableRest");

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
},{"./arrayWithHoles":2,"./iterableToArrayLimit":12,"./nonIterableRest":13,"./unsupportedIterableToArray":21}],18:[function(require,module,exports){
var getPrototypeOf = require("./getPrototypeOf");

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

module.exports = _superPropBase;
},{"./getPrototypeOf":8}],19:[function(require,module,exports){
var arrayWithoutHoles = require("./arrayWithoutHoles");

var iterableToArray = require("./iterableToArray");

var unsupportedIterableToArray = require("./unsupportedIterableToArray");

var nonIterableSpread = require("./nonIterableSpread");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
},{"./arrayWithoutHoles":3,"./iterableToArray":11,"./nonIterableSpread":14,"./unsupportedIterableToArray":21}],20:[function(require,module,exports){
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
},{}],21:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
},{"./arrayLikeToArray":1}],22:[function(require,module,exports){
module.exports = require("regenerator-runtime");

},{"regenerator-runtime":24}],23:[function(require,module,exports){
/*
 * anime.js v3.2.1
 * (c) 2020 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */

'use strict';

// Defaults

var defaultInstanceSettings = {
  update: null,
  begin: null,
  loopBegin: null,
  changeBegin: null,
  change: null,
  changeComplete: null,
  loopComplete: null,
  complete: null,
  loop: 1,
  direction: 'normal',
  autoplay: true,
  timelineOffset: 0
};

var defaultTweenSettings = {
  duration: 1000,
  delay: 0,
  endDelay: 0,
  easing: 'easeOutElastic(1, .5)',
  round: 0
};

var validTransforms = ['translateX', 'translateY', 'translateZ', 'rotate', 'rotateX', 'rotateY', 'rotateZ', 'scale', 'scaleX', 'scaleY', 'scaleZ', 'skew', 'skewX', 'skewY', 'perspective', 'matrix', 'matrix3d'];

// Caching

var cache = {
  CSS: {},
  springs: {}
};

// Utils

function minMax(val, min, max) {
  return Math.min(Math.max(val, min), max);
}

function stringContains(str, text) {
  return str.indexOf(text) > -1;
}

function applyArguments(func, args) {
  return func.apply(null, args);
}

var is = {
  arr: function (a) { return Array.isArray(a); },
  obj: function (a) { return stringContains(Object.prototype.toString.call(a), 'Object'); },
  pth: function (a) { return is.obj(a) && a.hasOwnProperty('totalLength'); },
  svg: function (a) { return a instanceof SVGElement; },
  inp: function (a) { return a instanceof HTMLInputElement; },
  dom: function (a) { return a.nodeType || is.svg(a); },
  str: function (a) { return typeof a === 'string'; },
  fnc: function (a) { return typeof a === 'function'; },
  und: function (a) { return typeof a === 'undefined'; },
  nil: function (a) { return is.und(a) || a === null; },
  hex: function (a) { return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a); },
  rgb: function (a) { return /^rgb/.test(a); },
  hsl: function (a) { return /^hsl/.test(a); },
  col: function (a) { return (is.hex(a) || is.rgb(a) || is.hsl(a)); },
  key: function (a) { return !defaultInstanceSettings.hasOwnProperty(a) && !defaultTweenSettings.hasOwnProperty(a) && a !== 'targets' && a !== 'keyframes'; },
};

// Easings

function parseEasingParameters(string) {
  var match = /\(([^)]+)\)/.exec(string);
  return match ? match[1].split(',').map(function (p) { return parseFloat(p); }) : [];
}

// Spring solver inspired by Webkit Copyright © 2016 Apple Inc. All rights reserved. https://webkit.org/demos/spring/spring.js

function spring(string, duration) {

  var params = parseEasingParameters(string);
  var mass = minMax(is.und(params[0]) ? 1 : params[0], .1, 100);
  var stiffness = minMax(is.und(params[1]) ? 100 : params[1], .1, 100);
  var damping = minMax(is.und(params[2]) ? 10 : params[2], .1, 100);
  var velocity =  minMax(is.und(params[3]) ? 0 : params[3], .1, 100);
  var w0 = Math.sqrt(stiffness / mass);
  var zeta = damping / (2 * Math.sqrt(stiffness * mass));
  var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
  var a = 1;
  var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;

  function solver(t) {
    var progress = duration ? (duration * t) / 1000 : t;
    if (zeta < 1) {
      progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
    } else {
      progress = (a + b * progress) * Math.exp(-progress * w0);
    }
    if (t === 0 || t === 1) { return t; }
    return 1 - progress;
  }

  function getDuration() {
    var cached = cache.springs[string];
    if (cached) { return cached; }
    var frame = 1/6;
    var elapsed = 0;
    var rest = 0;
    while(true) {
      elapsed += frame;
      if (solver(elapsed) === 1) {
        rest++;
        if (rest >= 16) { break; }
      } else {
        rest = 0;
      }
    }
    var duration = elapsed * frame * 1000;
    cache.springs[string] = duration;
    return duration;
  }

  return duration ? solver : getDuration;

}

// Basic steps easing implementation https://developer.mozilla.org/fr/docs/Web/CSS/transition-timing-function

function steps(steps) {
  if ( steps === void 0 ) steps = 10;

  return function (t) { return Math.ceil((minMax(t, 0.000001, 1)) * steps) * (1 / steps); };
}

// BezierEasing https://github.com/gre/bezier-easing

var bezier = (function () {

  var kSplineTableSize = 11;
  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

  function A(aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1 }
  function B(aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1 }
  function C(aA1)      { return 3.0 * aA1 }

  function calcBezier(aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT }
  function getSlope(aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1) }

  function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX, currentT, i = 0;
    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;
      if (currentX > 0.0) { aB = currentT; } else { aA = currentT; }
    } while (Math.abs(currentX) > 0.0000001 && ++i < 10);
    return currentT;
  }

  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (var i = 0; i < 4; ++i) {
      var currentSlope = getSlope(aGuessT, mX1, mX2);
      if (currentSlope === 0.0) { return aGuessT; }
      var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
  }

  function bezier(mX1, mY1, mX2, mY2) {

    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) { return; }
    var sampleValues = new Float32Array(kSplineTableSize);

    if (mX1 !== mY1 || mX2 !== mY2) {
      for (var i = 0; i < kSplineTableSize; ++i) {
        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
      }
    }

    function getTForX(aX) {

      var intervalStart = 0;
      var currentSample = 1;
      var lastSample = kSplineTableSize - 1;

      for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += kSampleStepSize;
      }

      --currentSample;

      var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
      var guessForT = intervalStart + dist * kSampleStepSize;
      var initialSlope = getSlope(guessForT, mX1, mX2);

      if (initialSlope >= 0.001) {
        return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
      } else if (initialSlope === 0.0) {
        return guessForT;
      } else {
        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }

    }

    return function (x) {
      if (mX1 === mY1 && mX2 === mY2) { return x; }
      if (x === 0 || x === 1) { return x; }
      return calcBezier(getTForX(x), mY1, mY2);
    }

  }

  return bezier;

})();

var penner = (function () {

  // Based on jQuery UI's implemenation of easing equations from Robert Penner (http://www.robertpenner.com/easing)

  var eases = { linear: function () { return function (t) { return t; }; } };

  var functionEasings = {
    Sine: function () { return function (t) { return 1 - Math.cos(t * Math.PI / 2); }; },
    Circ: function () { return function (t) { return 1 - Math.sqrt(1 - t * t); }; },
    Back: function () { return function (t) { return t * t * (3 * t - 2); }; },
    Bounce: function () { return function (t) {
      var pow2, b = 4;
      while (t < (( pow2 = Math.pow(2, --b)) - 1) / 11) {}
      return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow(( pow2 * 3 - 2 ) / 22 - t, 2)
    }; },
    Elastic: function (amplitude, period) {
      if ( amplitude === void 0 ) amplitude = 1;
      if ( period === void 0 ) period = .5;

      var a = minMax(amplitude, 1, 10);
      var p = minMax(period, .1, 2);
      return function (t) {
        return (t === 0 || t === 1) ? t : 
          -a * Math.pow(2, 10 * (t - 1)) * Math.sin((((t - 1) - (p / (Math.PI * 2) * Math.asin(1 / a))) * (Math.PI * 2)) / p);
      }
    }
  };

  var baseEasings = ['Quad', 'Cubic', 'Quart', 'Quint', 'Expo'];

  baseEasings.forEach(function (name, i) {
    functionEasings[name] = function () { return function (t) { return Math.pow(t, i + 2); }; };
  });

  Object.keys(functionEasings).forEach(function (name) {
    var easeIn = functionEasings[name];
    eases['easeIn' + name] = easeIn;
    eases['easeOut' + name] = function (a, b) { return function (t) { return 1 - easeIn(a, b)(1 - t); }; };
    eases['easeInOut' + name] = function (a, b) { return function (t) { return t < 0.5 ? easeIn(a, b)(t * 2) / 2 : 
      1 - easeIn(a, b)(t * -2 + 2) / 2; }; };
    eases['easeOutIn' + name] = function (a, b) { return function (t) { return t < 0.5 ? (1 - easeIn(a, b)(1 - t * 2)) / 2 : 
      (easeIn(a, b)(t * 2 - 1) + 1) / 2; }; };
  });

  return eases;

})();

function parseEasings(easing, duration) {
  if (is.fnc(easing)) { return easing; }
  var name = easing.split('(')[0];
  var ease = penner[name];
  var args = parseEasingParameters(easing);
  switch (name) {
    case 'spring' : return spring(easing, duration);
    case 'cubicBezier' : return applyArguments(bezier, args);
    case 'steps' : return applyArguments(steps, args);
    default : return applyArguments(ease, args);
  }
}

// Strings

function selectString(str) {
  try {
    var nodes = document.querySelectorAll(str);
    return nodes;
  } catch(e) {
    return;
  }
}

// Arrays

function filterArray(arr, callback) {
  var len = arr.length;
  var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
  var result = [];
  for (var i = 0; i < len; i++) {
    if (i in arr) {
      var val = arr[i];
      if (callback.call(thisArg, val, i, arr)) {
        result.push(val);
      }
    }
  }
  return result;
}

function flattenArray(arr) {
  return arr.reduce(function (a, b) { return a.concat(is.arr(b) ? flattenArray(b) : b); }, []);
}

function toArray(o) {
  if (is.arr(o)) { return o; }
  if (is.str(o)) { o = selectString(o) || o; }
  if (o instanceof NodeList || o instanceof HTMLCollection) { return [].slice.call(o); }
  return [o];
}

function arrayContains(arr, val) {
  return arr.some(function (a) { return a === val; });
}

// Objects

function cloneObject(o) {
  var clone = {};
  for (var p in o) { clone[p] = o[p]; }
  return clone;
}

function replaceObjectProps(o1, o2) {
  var o = cloneObject(o1);
  for (var p in o1) { o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p]; }
  return o;
}

function mergeObjects(o1, o2) {
  var o = cloneObject(o1);
  for (var p in o2) { o[p] = is.und(o1[p]) ? o2[p] : o1[p]; }
  return o;
}

// Colors

function rgbToRgba(rgbValue) {
  var rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
  return rgb ? ("rgba(" + (rgb[1]) + ",1)") : rgbValue;
}

function hexToRgba(hexValue) {
  var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  var hex = hexValue.replace(rgx, function (m, r, g, b) { return r + r + g + g + b + b; } );
  var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  var r = parseInt(rgb[1], 16);
  var g = parseInt(rgb[2], 16);
  var b = parseInt(rgb[3], 16);
  return ("rgba(" + r + "," + g + "," + b + ",1)");
}

function hslToRgba(hslValue) {
  var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
  var h = parseInt(hsl[1], 10) / 360;
  var s = parseInt(hsl[2], 10) / 100;
  var l = parseInt(hsl[3], 10) / 100;
  var a = hsl[4] || 1;
  function hue2rgb(p, q, t) {
    if (t < 0) { t += 1; }
    if (t > 1) { t -= 1; }
    if (t < 1/6) { return p + (q - p) * 6 * t; }
    if (t < 1/2) { return q; }
    if (t < 2/3) { return p + (q - p) * (2/3 - t) * 6; }
    return p;
  }
  var r, g, b;
  if (s == 0) {
    r = g = b = l;
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1/3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1/3);
  }
  return ("rgba(" + (r * 255) + "," + (g * 255) + "," + (b * 255) + "," + a + ")");
}

function colorToRgb(val) {
  if (is.rgb(val)) { return rgbToRgba(val); }
  if (is.hex(val)) { return hexToRgba(val); }
  if (is.hsl(val)) { return hslToRgba(val); }
}

// Units

function getUnit(val) {
  var split = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);
  if (split) { return split[1]; }
}

function getTransformUnit(propName) {
  if (stringContains(propName, 'translate') || propName === 'perspective') { return 'px'; }
  if (stringContains(propName, 'rotate') || stringContains(propName, 'skew')) { return 'deg'; }
}

// Values

function getFunctionValue(val, animatable) {
  if (!is.fnc(val)) { return val; }
  return val(animatable.target, animatable.id, animatable.total);
}

function getAttribute(el, prop) {
  return el.getAttribute(prop);
}

function convertPxToUnit(el, value, unit) {
  var valueUnit = getUnit(value);
  if (arrayContains([unit, 'deg', 'rad', 'turn'], valueUnit)) { return value; }
  var cached = cache.CSS[value + unit];
  if (!is.und(cached)) { return cached; }
  var baseline = 100;
  var tempEl = document.createElement(el.tagName);
  var parentEl = (el.parentNode && (el.parentNode !== document)) ? el.parentNode : document.body;
  parentEl.appendChild(tempEl);
  tempEl.style.position = 'absolute';
  tempEl.style.width = baseline + unit;
  var factor = baseline / tempEl.offsetWidth;
  parentEl.removeChild(tempEl);
  var convertedUnit = factor * parseFloat(value);
  cache.CSS[value + unit] = convertedUnit;
  return convertedUnit;
}

function getCSSValue(el, prop, unit) {
  if (prop in el.style) {
    var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || '0';
    return unit ? convertPxToUnit(el, value, unit) : value;
  }
}

function getAnimationType(el, prop) {
  if (is.dom(el) && !is.inp(el) && (!is.nil(getAttribute(el, prop)) || (is.svg(el) && el[prop]))) { return 'attribute'; }
  if (is.dom(el) && arrayContains(validTransforms, prop)) { return 'transform'; }
  if (is.dom(el) && (prop !== 'transform' && getCSSValue(el, prop))) { return 'css'; }
  if (el[prop] != null) { return 'object'; }
}

function getElementTransforms(el) {
  if (!is.dom(el)) { return; }
  var str = el.style.transform || '';
  var reg  = /(\w+)\(([^)]*)\)/g;
  var transforms = new Map();
  var m; while (m = reg.exec(str)) { transforms.set(m[1], m[2]); }
  return transforms;
}

function getTransformValue(el, propName, animatable, unit) {
  var defaultVal = stringContains(propName, 'scale') ? 1 : 0 + getTransformUnit(propName);
  var value = getElementTransforms(el).get(propName) || defaultVal;
  if (animatable) {
    animatable.transforms.list.set(propName, value);
    animatable.transforms['last'] = propName;
  }
  return unit ? convertPxToUnit(el, value, unit) : value;
}

function getOriginalTargetValue(target, propName, unit, animatable) {
  switch (getAnimationType(target, propName)) {
    case 'transform': return getTransformValue(target, propName, animatable, unit);
    case 'css': return getCSSValue(target, propName, unit);
    case 'attribute': return getAttribute(target, propName);
    default: return target[propName] || 0;
  }
}

function getRelativeValue(to, from) {
  var operator = /^(\*=|\+=|-=)/.exec(to);
  if (!operator) { return to; }
  var u = getUnit(to) || 0;
  var x = parseFloat(from);
  var y = parseFloat(to.replace(operator[0], ''));
  switch (operator[0][0]) {
    case '+': return x + y + u;
    case '-': return x - y + u;
    case '*': return x * y + u;
  }
}

function validateValue(val, unit) {
  if (is.col(val)) { return colorToRgb(val); }
  if (/\s/g.test(val)) { return val; }
  var originalUnit = getUnit(val);
  var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
  if (unit) { return unitLess + unit; }
  return unitLess;
}

// getTotalLength() equivalent for circle, rect, polyline, polygon and line shapes
// adapted from https://gist.github.com/SebLambla/3e0550c496c236709744

function getDistance(p1, p2) {
  return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}

function getCircleLength(el) {
  return Math.PI * 2 * getAttribute(el, 'r');
}

function getRectLength(el) {
  return (getAttribute(el, 'width') * 2) + (getAttribute(el, 'height') * 2);
}

function getLineLength(el) {
  return getDistance(
    {x: getAttribute(el, 'x1'), y: getAttribute(el, 'y1')}, 
    {x: getAttribute(el, 'x2'), y: getAttribute(el, 'y2')}
  );
}

function getPolylineLength(el) {
  var points = el.points;
  var totalLength = 0;
  var previousPos;
  for (var i = 0 ; i < points.numberOfItems; i++) {
    var currentPos = points.getItem(i);
    if (i > 0) { totalLength += getDistance(previousPos, currentPos); }
    previousPos = currentPos;
  }
  return totalLength;
}

function getPolygonLength(el) {
  var points = el.points;
  return getPolylineLength(el) + getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
}

// Path animation

function getTotalLength(el) {
  if (el.getTotalLength) { return el.getTotalLength(); }
  switch(el.tagName.toLowerCase()) {
    case 'circle': return getCircleLength(el);
    case 'rect': return getRectLength(el);
    case 'line': return getLineLength(el);
    case 'polyline': return getPolylineLength(el);
    case 'polygon': return getPolygonLength(el);
  }
}

function setDashoffset(el) {
  var pathLength = getTotalLength(el);
  el.setAttribute('stroke-dasharray', pathLength);
  return pathLength;
}

// Motion path

function getParentSvgEl(el) {
  var parentEl = el.parentNode;
  while (is.svg(parentEl)) {
    if (!is.svg(parentEl.parentNode)) { break; }
    parentEl = parentEl.parentNode;
  }
  return parentEl;
}

function getParentSvg(pathEl, svgData) {
  var svg = svgData || {};
  var parentSvgEl = svg.el || getParentSvgEl(pathEl);
  var rect = parentSvgEl.getBoundingClientRect();
  var viewBoxAttr = getAttribute(parentSvgEl, 'viewBox');
  var width = rect.width;
  var height = rect.height;
  var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(' ') : [0, 0, width, height]);
  return {
    el: parentSvgEl,
    viewBox: viewBox,
    x: viewBox[0] / 1,
    y: viewBox[1] / 1,
    w: width,
    h: height,
    vW: viewBox[2],
    vH: viewBox[3]
  }
}

function getPath(path, percent) {
  var pathEl = is.str(path) ? selectString(path)[0] : path;
  var p = percent || 100;
  return function(property) {
    return {
      property: property,
      el: pathEl,
      svg: getParentSvg(pathEl),
      totalLength: getTotalLength(pathEl) * (p / 100)
    }
  }
}

function getPathProgress(path, progress, isPathTargetInsideSVG) {
  function point(offset) {
    if ( offset === void 0 ) offset = 0;

    var l = progress + offset >= 1 ? progress + offset : 0;
    return path.el.getPointAtLength(l);
  }
  var svg = getParentSvg(path.el, path.svg);
  var p = point();
  var p0 = point(-1);
  var p1 = point(+1);
  var scaleX = isPathTargetInsideSVG ? 1 : svg.w / svg.vW;
  var scaleY = isPathTargetInsideSVG ? 1 : svg.h / svg.vH;
  switch (path.property) {
    case 'x': return (p.x - svg.x) * scaleX;
    case 'y': return (p.y - svg.y) * scaleY;
    case 'angle': return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
  }
}

// Decompose value

function decomposeValue(val, unit) {
  // const rgx = /-?\d*\.?\d+/g; // handles basic numbers
  // const rgx = /[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
  var rgx = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
  var value = validateValue((is.pth(val) ? val.totalLength : val), unit) + '';
  return {
    original: value,
    numbers: value.match(rgx) ? value.match(rgx).map(Number) : [0],
    strings: (is.str(val) || unit) ? value.split(rgx) : []
  }
}

// Animatables

function parseTargets(targets) {
  var targetsArray = targets ? (flattenArray(is.arr(targets) ? targets.map(toArray) : toArray(targets))) : [];
  return filterArray(targetsArray, function (item, pos, self) { return self.indexOf(item) === pos; });
}

function getAnimatables(targets) {
  var parsed = parseTargets(targets);
  return parsed.map(function (t, i) {
    return {target: t, id: i, total: parsed.length, transforms: { list: getElementTransforms(t) } };
  });
}

// Properties

function normalizePropertyTweens(prop, tweenSettings) {
  var settings = cloneObject(tweenSettings);
  // Override duration if easing is a spring
  if (/^spring/.test(settings.easing)) { settings.duration = spring(settings.easing); }
  if (is.arr(prop)) {
    var l = prop.length;
    var isFromTo = (l === 2 && !is.obj(prop[0]));
    if (!isFromTo) {
      // Duration divided by the number of tweens
      if (!is.fnc(tweenSettings.duration)) { settings.duration = tweenSettings.duration / l; }
    } else {
      // Transform [from, to] values shorthand to a valid tween value
      prop = {value: prop};
    }
  }
  var propArray = is.arr(prop) ? prop : [prop];
  return propArray.map(function (v, i) {
    var obj = (is.obj(v) && !is.pth(v)) ? v : {value: v};
    // Default delay value should only be applied to the first tween
    if (is.und(obj.delay)) { obj.delay = !i ? tweenSettings.delay : 0; }
    // Default endDelay value should only be applied to the last tween
    if (is.und(obj.endDelay)) { obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0; }
    return obj;
  }).map(function (k) { return mergeObjects(k, settings); });
}


function flattenKeyframes(keyframes) {
  var propertyNames = filterArray(flattenArray(keyframes.map(function (key) { return Object.keys(key); })), function (p) { return is.key(p); })
  .reduce(function (a,b) { if (a.indexOf(b) < 0) { a.push(b); } return a; }, []);
  var properties = {};
  var loop = function ( i ) {
    var propName = propertyNames[i];
    properties[propName] = keyframes.map(function (key) {
      var newKey = {};
      for (var p in key) {
        if (is.key(p)) {
          if (p == propName) { newKey.value = key[p]; }
        } else {
          newKey[p] = key[p];
        }
      }
      return newKey;
    });
  };

  for (var i = 0; i < propertyNames.length; i++) loop( i );
  return properties;
}

function getProperties(tweenSettings, params) {
  var properties = [];
  var keyframes = params.keyframes;
  if (keyframes) { params = mergeObjects(flattenKeyframes(keyframes), params); }
  for (var p in params) {
    if (is.key(p)) {
      properties.push({
        name: p,
        tweens: normalizePropertyTweens(params[p], tweenSettings)
      });
    }
  }
  return properties;
}

// Tweens

function normalizeTweenValues(tween, animatable) {
  var t = {};
  for (var p in tween) {
    var value = getFunctionValue(tween[p], animatable);
    if (is.arr(value)) {
      value = value.map(function (v) { return getFunctionValue(v, animatable); });
      if (value.length === 1) { value = value[0]; }
    }
    t[p] = value;
  }
  t.duration = parseFloat(t.duration);
  t.delay = parseFloat(t.delay);
  return t;
}

function normalizeTweens(prop, animatable) {
  var previousTween;
  return prop.tweens.map(function (t) {
    var tween = normalizeTweenValues(t, animatable);
    var tweenValue = tween.value;
    var to = is.arr(tweenValue) ? tweenValue[1] : tweenValue;
    var toUnit = getUnit(to);
    var originalValue = getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
    var previousValue = previousTween ? previousTween.to.original : originalValue;
    var from = is.arr(tweenValue) ? tweenValue[0] : previousValue;
    var fromUnit = getUnit(from) || getUnit(originalValue);
    var unit = toUnit || fromUnit;
    if (is.und(to)) { to = previousValue; }
    tween.from = decomposeValue(from, unit);
    tween.to = decomposeValue(getRelativeValue(to, from), unit);
    tween.start = previousTween ? previousTween.end : 0;
    tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
    tween.easing = parseEasings(tween.easing, tween.duration);
    tween.isPath = is.pth(tweenValue);
    tween.isPathTargetInsideSVG = tween.isPath && is.svg(animatable.target);
    tween.isColor = is.col(tween.from.original);
    if (tween.isColor) { tween.round = 1; }
    previousTween = tween;
    return tween;
  });
}

// Tween progress

var setProgressValue = {
  css: function (t, p, v) { return t.style[p] = v; },
  attribute: function (t, p, v) { return t.setAttribute(p, v); },
  object: function (t, p, v) { return t[p] = v; },
  transform: function (t, p, v, transforms, manual) {
    transforms.list.set(p, v);
    if (p === transforms.last || manual) {
      var str = '';
      transforms.list.forEach(function (value, prop) { str += prop + "(" + value + ") "; });
      t.style.transform = str;
    }
  }
};

// Set Value helper

function setTargetsValue(targets, properties) {
  var animatables = getAnimatables(targets);
  animatables.forEach(function (animatable) {
    for (var property in properties) {
      var value = getFunctionValue(properties[property], animatable);
      var target = animatable.target;
      var valueUnit = getUnit(value);
      var originalValue = getOriginalTargetValue(target, property, valueUnit, animatable);
      var unit = valueUnit || getUnit(originalValue);
      var to = getRelativeValue(validateValue(value, unit), originalValue);
      var animType = getAnimationType(target, property);
      setProgressValue[animType](target, property, to, animatable.transforms, true);
    }
  });
}

// Animations

function createAnimation(animatable, prop) {
  var animType = getAnimationType(animatable.target, prop.name);
  if (animType) {
    var tweens = normalizeTweens(prop, animatable);
    var lastTween = tweens[tweens.length - 1];
    return {
      type: animType,
      property: prop.name,
      animatable: animatable,
      tweens: tweens,
      duration: lastTween.end,
      delay: tweens[0].delay,
      endDelay: lastTween.endDelay
    }
  }
}

function getAnimations(animatables, properties) {
  return filterArray(flattenArray(animatables.map(function (animatable) {
    return properties.map(function (prop) {
      return createAnimation(animatable, prop);
    });
  })), function (a) { return !is.und(a); });
}

// Create Instance

function getInstanceTimings(animations, tweenSettings) {
  var animLength = animations.length;
  var getTlOffset = function (anim) { return anim.timelineOffset ? anim.timelineOffset : 0; };
  var timings = {};
  timings.duration = animLength ? Math.max.apply(Math, animations.map(function (anim) { return getTlOffset(anim) + anim.duration; })) : tweenSettings.duration;
  timings.delay = animLength ? Math.min.apply(Math, animations.map(function (anim) { return getTlOffset(anim) + anim.delay; })) : tweenSettings.delay;
  timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function (anim) { return getTlOffset(anim) + anim.duration - anim.endDelay; })) : tweenSettings.endDelay;
  return timings;
}

var instanceID = 0;

function createNewInstance(params) {
  var instanceSettings = replaceObjectProps(defaultInstanceSettings, params);
  var tweenSettings = replaceObjectProps(defaultTweenSettings, params);
  var properties = getProperties(tweenSettings, params);
  var animatables = getAnimatables(params.targets);
  var animations = getAnimations(animatables, properties);
  var timings = getInstanceTimings(animations, tweenSettings);
  var id = instanceID;
  instanceID++;
  return mergeObjects(instanceSettings, {
    id: id,
    children: [],
    animatables: animatables,
    animations: animations,
    duration: timings.duration,
    delay: timings.delay,
    endDelay: timings.endDelay
  });
}

// Core

var activeInstances = [];

var engine = (function () {
  var raf;

  function play() {
    if (!raf && (!isDocumentHidden() || !anime.suspendWhenDocumentHidden) && activeInstances.length > 0) {
      raf = requestAnimationFrame(step);
    }
  }
  function step(t) {
    // memo on algorithm issue:
    // dangerous iteration over mutable `activeInstances`
    // (that collection may be updated from within callbacks of `tick`-ed animation instances)
    var activeInstancesLength = activeInstances.length;
    var i = 0;
    while (i < activeInstancesLength) {
      var activeInstance = activeInstances[i];
      if (!activeInstance.paused) {
        activeInstance.tick(t);
        i++;
      } else {
        activeInstances.splice(i, 1);
        activeInstancesLength--;
      }
    }
    raf = i > 0 ? requestAnimationFrame(step) : undefined;
  }

  function handleVisibilityChange() {
    if (!anime.suspendWhenDocumentHidden) { return; }

    if (isDocumentHidden()) {
      // suspend ticks
      raf = cancelAnimationFrame(raf);
    } else { // is back to active tab
      // first adjust animations to consider the time that ticks were suspended
      activeInstances.forEach(
        function (instance) { return instance ._onDocumentVisibility(); }
      );
      engine();
    }
  }
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', handleVisibilityChange);
  }

  return play;
})();

function isDocumentHidden() {
  return !!document && document.hidden;
}

// Public Instance

function anime(params) {
  if ( params === void 0 ) params = {};


  var startTime = 0, lastTime = 0, now = 0;
  var children, childrenLength = 0;
  var resolve = null;

  function makePromise(instance) {
    var promise = window.Promise && new Promise(function (_resolve) { return resolve = _resolve; });
    instance.finished = promise;
    return promise;
  }

  var instance = createNewInstance(params);
  var promise = makePromise(instance);

  function toggleInstanceDirection() {
    var direction = instance.direction;
    if (direction !== 'alternate') {
      instance.direction = direction !== 'normal' ? 'normal' : 'reverse';
    }
    instance.reversed = !instance.reversed;
    children.forEach(function (child) { return child.reversed = instance.reversed; });
  }

  function adjustTime(time) {
    return instance.reversed ? instance.duration - time : time;
  }

  function resetTime() {
    startTime = 0;
    lastTime = adjustTime(instance.currentTime) * (1 / anime.speed);
  }

  function seekChild(time, child) {
    if (child) { child.seek(time - child.timelineOffset); }
  }

  function syncInstanceChildren(time) {
    if (!instance.reversePlayback) {
      for (var i = 0; i < childrenLength; i++) { seekChild(time, children[i]); }
    } else {
      for (var i$1 = childrenLength; i$1--;) { seekChild(time, children[i$1]); }
    }
  }

  function setAnimationsProgress(insTime) {
    var i = 0;
    var animations = instance.animations;
    var animationsLength = animations.length;
    while (i < animationsLength) {
      var anim = animations[i];
      var animatable = anim.animatable;
      var tweens = anim.tweens;
      var tweenLength = tweens.length - 1;
      var tween = tweens[tweenLength];
      // Only check for keyframes if there is more than one tween
      if (tweenLength) { tween = filterArray(tweens, function (t) { return (insTime < t.end); })[0] || tween; }
      var elapsed = minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
      var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
      var strings = tween.to.strings;
      var round = tween.round;
      var numbers = [];
      var toNumbersLength = tween.to.numbers.length;
      var progress = (void 0);
      for (var n = 0; n < toNumbersLength; n++) {
        var value = (void 0);
        var toNumber = tween.to.numbers[n];
        var fromNumber = tween.from.numbers[n] || 0;
        if (!tween.isPath) {
          value = fromNumber + (eased * (toNumber - fromNumber));
        } else {
          value = getPathProgress(tween.value, eased * toNumber, tween.isPathTargetInsideSVG);
        }
        if (round) {
          if (!(tween.isColor && n > 2)) {
            value = Math.round(value * round) / round;
          }
        }
        numbers.push(value);
      }
      // Manual Array.reduce for better performances
      var stringsLength = strings.length;
      if (!stringsLength) {
        progress = numbers[0];
      } else {
        progress = strings[0];
        for (var s = 0; s < stringsLength; s++) {
          var a = strings[s];
          var b = strings[s + 1];
          var n$1 = numbers[s];
          if (!isNaN(n$1)) {
            if (!b) {
              progress += n$1 + ' ';
            } else {
              progress += n$1 + b;
            }
          }
        }
      }
      setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
      anim.currentValue = progress;
      i++;
    }
  }

  function setCallback(cb) {
    if (instance[cb] && !instance.passThrough) { instance[cb](instance); }
  }

  function countIteration() {
    if (instance.remaining && instance.remaining !== true) {
      instance.remaining--;
    }
  }

  function setInstanceProgress(engineTime) {
    var insDuration = instance.duration;
    var insDelay = instance.delay;
    var insEndDelay = insDuration - instance.endDelay;
    var insTime = adjustTime(engineTime);
    instance.progress = minMax((insTime / insDuration) * 100, 0, 100);
    instance.reversePlayback = insTime < instance.currentTime;
    if (children) { syncInstanceChildren(insTime); }
    if (!instance.began && instance.currentTime > 0) {
      instance.began = true;
      setCallback('begin');
    }
    if (!instance.loopBegan && instance.currentTime > 0) {
      instance.loopBegan = true;
      setCallback('loopBegin');
    }
    if (insTime <= insDelay && instance.currentTime !== 0) {
      setAnimationsProgress(0);
    }
    if ((insTime >= insEndDelay && instance.currentTime !== insDuration) || !insDuration) {
      setAnimationsProgress(insDuration);
    }
    if (insTime > insDelay && insTime < insEndDelay) {
      if (!instance.changeBegan) {
        instance.changeBegan = true;
        instance.changeCompleted = false;
        setCallback('changeBegin');
      }
      setCallback('change');
      setAnimationsProgress(insTime);
    } else {
      if (instance.changeBegan) {
        instance.changeCompleted = true;
        instance.changeBegan = false;
        setCallback('changeComplete');
      }
    }
    instance.currentTime = minMax(insTime, 0, insDuration);
    if (instance.began) { setCallback('update'); }
    if (engineTime >= insDuration) {
      lastTime = 0;
      countIteration();
      if (!instance.remaining) {
        instance.paused = true;
        if (!instance.completed) {
          instance.completed = true;
          setCallback('loopComplete');
          setCallback('complete');
          if (!instance.passThrough && 'Promise' in window) {
            resolve();
            promise = makePromise(instance);
          }
        }
      } else {
        startTime = now;
        setCallback('loopComplete');
        instance.loopBegan = false;
        if (instance.direction === 'alternate') {
          toggleInstanceDirection();
        }
      }
    }
  }

  instance.reset = function() {
    var direction = instance.direction;
    instance.passThrough = false;
    instance.currentTime = 0;
    instance.progress = 0;
    instance.paused = true;
    instance.began = false;
    instance.loopBegan = false;
    instance.changeBegan = false;
    instance.completed = false;
    instance.changeCompleted = false;
    instance.reversePlayback = false;
    instance.reversed = direction === 'reverse';
    instance.remaining = instance.loop;
    children = instance.children;
    childrenLength = children.length;
    for (var i = childrenLength; i--;) { instance.children[i].reset(); }
    if (instance.reversed && instance.loop !== true || (direction === 'alternate' && instance.loop === 1)) { instance.remaining++; }
    setAnimationsProgress(instance.reversed ? instance.duration : 0);
  };

  // internal method (for engine) to adjust animation timings before restoring engine ticks (rAF)
  instance._onDocumentVisibility = resetTime;

  // Set Value helper

  instance.set = function(targets, properties) {
    setTargetsValue(targets, properties);
    return instance;
  };

  instance.tick = function(t) {
    now = t;
    if (!startTime) { startTime = now; }
    setInstanceProgress((now + (lastTime - startTime)) * anime.speed);
  };

  instance.seek = function(time) {
    setInstanceProgress(adjustTime(time));
  };

  instance.pause = function() {
    instance.paused = true;
    resetTime();
  };

  instance.play = function() {
    if (!instance.paused) { return; }
    if (instance.completed) { instance.reset(); }
    instance.paused = false;
    activeInstances.push(instance);
    resetTime();
    engine();
  };

  instance.reverse = function() {
    toggleInstanceDirection();
    instance.completed = instance.reversed ? false : true;
    resetTime();
  };

  instance.restart = function() {
    instance.reset();
    instance.play();
  };

  instance.remove = function(targets) {
    var targetsArray = parseTargets(targets);
    removeTargetsFromInstance(targetsArray, instance);
  };

  instance.reset();

  if (instance.autoplay) { instance.play(); }

  return instance;

}

// Remove targets from animation

function removeTargetsFromAnimations(targetsArray, animations) {
  for (var a = animations.length; a--;) {
    if (arrayContains(targetsArray, animations[a].animatable.target)) {
      animations.splice(a, 1);
    }
  }
}

function removeTargetsFromInstance(targetsArray, instance) {
  var animations = instance.animations;
  var children = instance.children;
  removeTargetsFromAnimations(targetsArray, animations);
  for (var c = children.length; c--;) {
    var child = children[c];
    var childAnimations = child.animations;
    removeTargetsFromAnimations(targetsArray, childAnimations);
    if (!childAnimations.length && !child.children.length) { children.splice(c, 1); }
  }
  if (!animations.length && !children.length) { instance.pause(); }
}

function removeTargetsFromActiveInstances(targets) {
  var targetsArray = parseTargets(targets);
  for (var i = activeInstances.length; i--;) {
    var instance = activeInstances[i];
    removeTargetsFromInstance(targetsArray, instance);
  }
}

// Stagger helpers

function stagger(val, params) {
  if ( params === void 0 ) params = {};

  var direction = params.direction || 'normal';
  var easing = params.easing ? parseEasings(params.easing) : null;
  var grid = params.grid;
  var axis = params.axis;
  var fromIndex = params.from || 0;
  var fromFirst = fromIndex === 'first';
  var fromCenter = fromIndex === 'center';
  var fromLast = fromIndex === 'last';
  var isRange = is.arr(val);
  var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
  var val2 = isRange ? parseFloat(val[1]) : 0;
  var unit = getUnit(isRange ? val[1] : val) || 0;
  var start = params.start || 0 + (isRange ? val1 : 0);
  var values = [];
  var maxValue = 0;
  return function (el, i, t) {
    if (fromFirst) { fromIndex = 0; }
    if (fromCenter) { fromIndex = (t - 1) / 2; }
    if (fromLast) { fromIndex = t - 1; }
    if (!values.length) {
      for (var index = 0; index < t; index++) {
        if (!grid) {
          values.push(Math.abs(fromIndex - index));
        } else {
          var fromX = !fromCenter ? fromIndex%grid[0] : (grid[0]-1)/2;
          var fromY = !fromCenter ? Math.floor(fromIndex/grid[0]) : (grid[1]-1)/2;
          var toX = index%grid[0];
          var toY = Math.floor(index/grid[0]);
          var distanceX = fromX - toX;
          var distanceY = fromY - toY;
          var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
          if (axis === 'x') { value = -distanceX; }
          if (axis === 'y') { value = -distanceY; }
          values.push(value);
        }
        maxValue = Math.max.apply(Math, values);
      }
      if (easing) { values = values.map(function (val) { return easing(val / maxValue) * maxValue; }); }
      if (direction === 'reverse') { values = values.map(function (val) { return axis ? (val < 0) ? val * -1 : -val : Math.abs(maxValue - val); }); }
    }
    var spacing = isRange ? (val2 - val1) / maxValue : val1;
    return start + (spacing * (Math.round(values[i] * 100) / 100)) + unit;
  }
}

// Timeline

function timeline(params) {
  if ( params === void 0 ) params = {};

  var tl = anime(params);
  tl.duration = 0;
  tl.add = function(instanceParams, timelineOffset) {
    var tlIndex = activeInstances.indexOf(tl);
    var children = tl.children;
    if (tlIndex > -1) { activeInstances.splice(tlIndex, 1); }
    function passThrough(ins) { ins.passThrough = true; }
    for (var i = 0; i < children.length; i++) { passThrough(children[i]); }
    var insParams = mergeObjects(instanceParams, replaceObjectProps(defaultTweenSettings, params));
    insParams.targets = insParams.targets || params.targets;
    var tlDuration = tl.duration;
    insParams.autoplay = false;
    insParams.direction = tl.direction;
    insParams.timelineOffset = is.und(timelineOffset) ? tlDuration : getRelativeValue(timelineOffset, tlDuration);
    passThrough(tl);
    tl.seek(insParams.timelineOffset);
    var ins = anime(insParams);
    passThrough(ins);
    children.push(ins);
    var timings = getInstanceTimings(children, params);
    tl.delay = timings.delay;
    tl.endDelay = timings.endDelay;
    tl.duration = timings.duration;
    tl.seek(0);
    tl.reset();
    if (tl.autoplay) { tl.play(); }
    return tl;
  };
  return tl;
}

anime.version = '3.2.1';
anime.speed = 1;
// TODO:#review: naming, documentation
anime.suspendWhenDocumentHidden = true;
anime.running = activeInstances;
anime.remove = removeTargetsFromActiveInstances;
anime.get = getOriginalTargetValue;
anime.set = setTargetsValue;
anime.convertPx = convertPxToUnit;
anime.path = getPath;
anime.setDashoffset = setDashoffset;
anime.stagger = stagger;
anime.timeline = timeline;
anime.easing = parseEasings;
anime.penner = penner;
anime.random = function (min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; };

module.exports = anime;

},{}],24:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  typeof module === "object" ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}

},{}],25:[function(require,module,exports){
/* global window, module */

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            global.Router = factory()
}(this, (function () {

    /**
     * Router
     *
     * @version: 1.2.7
     * @author Graidenix
     *
     * @constructor
     *
     * @param {object} options
     * @returns {Router}
     */
    function Router(options) {
        var settings = this._getSettings(options);


        this.notFoundHandler = settings.page404;
        this.mode = (!window.history || !window.history.pushState) ? "hash" : settings.mode;
        this.root = settings.root === "/" ? "/" : "/" + this._trimSlashes(settings.root) + "/";
        this.beforeHook = settings.hooks.before;
        this.securityHook = settings.hooks.secure;

        this.routes = [];
        if (settings.routes && settings.routes.length > 0) {
            var _this = this;
            settings.routes.forEach(function (route) {
                _this.add(route.rule, route.handler, route.options);
            });
        }

        this._pageState = null;
        this._currentPage = null;
        this._skipCheck = false;
        this._action = null;

        if (this.mode === "hash") {
            this._historyStack = [];
            this._historyIdx = 0;
            this._historyState = "add"
        }

        return this;
    }

    /**
     * Define Router Page
     *
     * @param {string} uri
     * @param {object} query
     * @param {Array} params
     * @param {object} state
     * @param {object} options
     *
     * @constructor
     */
    Router.Page = function (uri, query, params, state, options) {
        this.uri = uri || "";
        this.query = query || {};
        this.params = params || [];
        this.state = state || null;
        this.options = options || {};
    };

    /**
     * Sanitize options and add default values
     *
     * @param {object} options
     * @returns {object}
     * @private
     */
    Router.prototype._getSettings = function (options) {
        var settings = {};
        var defaults = {
            routes: [],
            mode: "history",
            root: "/",
            hooks: {
                "before": function () {
                },
                "secure": function () {
                    return true;
                }
            },
            page404: function (page) {
                console.error({
                    page: page,
                    message: "404. Page not found"
                });
            }
        };

        options = options || {};
        ["routes", "mode", "root", "page404"].forEach(function (key) {
            settings[key] = options[key] || defaults[key];
        });

        settings.hooks = Object.assign({}, defaults.hooks, options.hooks || {});

        return settings;
    };

    /**
     * Get URI for Router "history" mode
     *
     * @private
     * @returns {string}
     */
    Router.prototype._getHistoryFragment = function () {
        var fragment = decodeURI(window.location.pathname);
        if (this.root !== "/") {
            fragment = fragment.replace(this.root, "");
        }
        return this._trimSlashes(fragment);
    };

    /**
     * Get URI for router "hash" mode
     *
     * @private
     * @returns {string}
     */
    Router.prototype._getHashFragment = function () {
        var hash = window.location.hash.substr(1).replace(/(\?.*)$/, "");
        return this._trimSlashes(hash);
    };

    /**
     * Get current URI
     *
     * @private
     * @returns {string}
     */
    Router.prototype._getFragment = function () {
        if (this.mode === "history") {
            return this._getHistoryFragment();
        } else {
            return this._getHashFragment();
        }
    };

    /**
     * Trim slashes for path
     *
     * @private
     * @param {string} path
     * @returns {string}
     */
    Router.prototype._trimSlashes = function (path) {
        if (typeof path !== "string") {
            return "";
        }
        return path.toString().replace(/\/$/, "").replace(/^\//, "");
    };

    /**
     * 404 Page Handler
     *
     * @private
     */
    Router.prototype._page404 = function (path) {
        this._currentPage = new Router.Page(path);
        this.notFoundHandler(path);
    };

    /**
     * Convert the string route rule to RegExp rule
     *
     * @param {string} route
     * @returns {RegExp}
     * @private
     */
    Router.prototype._parseRouteRule = function (route) {
        if (typeof route !== "string") {
            return route;
        }
        var uri = this._trimSlashes(route);
        var rule = uri
            .replace(/([\\\/\-\_\.])/g, "\\$1")
            .replace(/\{[a-zA-Z]+\}/g, "(:any)")
            .replace(/\:any/g, "[\\w\\-\\_\\.]+")
            .replace(/\:word/g, "[a-zA-Z]+")
            .replace(/\:num/g, "\\d+");

        return new RegExp("^" + rule + "$", "i");
    };

    /**
     * Parse query string and return object for it
     *
     * @param {string} query
     * @returns {object}
     * @private
     */
    Router.prototype._parseQuery = function (query) {
        var _query = {};
        if (typeof query !== "string") {
            return _query;
        }

        if (query[0] === "?") {
            query = query.substr(1);
        }

        this._queryString = query;
        query.split("&").forEach(function (row) {
            var parts = row.split("=");
            if (parts[0] !== "") {
                if (parts[1] === undefined) {
                    parts[1] = true;
                }
                _query[decodeURIComponent(parts[0])] = parts[1];
            }
        });
        return _query;
    };

    /**
     * Get query for `history` mode
     *
     * @returns {Object}
     * @private
     */
    Router.prototype._getHistoryQuery = function () {
        return this._parseQuery(window.location.search);
    };

    /**
     * Get query for `hash` mode
     *
     * @returns {Object}
     * @private
     */
    Router.prototype._getHashQuery = function () {
        var index = window.location.hash.indexOf("?");
        var query = (index !== -1) ? window.location.hash.substr(index) : "";
        return this._parseQuery(query);
    };

    /**
     * Get query as object
     *
     * @private
     * @returns {Object}
     */
    Router.prototype._getQuery = function () {
        if (this.mode === "history") {
            return this._getHistoryQuery();
        } else {
            return this._getHashQuery();
        }
    };

    /**
     * Add route to routes list
     *
     * @param {string|RegExp} rule
     * @param {function} handler
     * @param {{}} options
     * @returns {Router}
     */
    Router.prototype.add = function (rule, handler, options) {
        this.routes.push({
            rule: this._parseRouteRule(rule),
            handler: handler,
            options: options
        });
        return this;
    };

    /**
     * Remove a route from routes list
     *
     * @param param
     * @returns {Router}
     */
    Router.prototype.remove = function (param) {
        var _this = this;
        if (typeof param === "string") {
            param = this._parseRouteRule(param).toString();
        }
        this.routes.some(function (route, i) {
            if (route.handler === param || route.rule.toString() === param) {
                _this.routes.splice(i, 1);
                return true;
            }
            return false;
        });

        return this;
    };

    /**
     * Reset the state of Router
     *
     * @returns {Router}
     */
    Router.prototype.reset = function () {
        this.routes = [];
        this.mode = null;
        this.root = "/";
        this._pageState = {};
        this.removeUriListener();

        return this;
    };

    /**
     * Add current page in history stack
     * @private
     */
    Router.prototype._pushHistory = function () {
        var _this = this,
            fragment = this._getFragment();

        if (this.mode === "hash") {
            if (this._historyState === "add") {
                if (this._historyIdx !== this._historyStack.length - 1) {
                    this._historyStack.splice(this._historyIdx + 1);
                }

                this._historyStack.push({
                    path: fragment,
                    state: _this._pageState
                });

                this._historyIdx = this._historyStack.length - 1;
            }
            this._historyState = "add";
        }
    };

    /**
     *
     * @param asyncRequest boolean
     * @returns {PromiseResult<boolean> | boolean}
     * @private
     */
    Router.prototype._unloadCallback = function (asyncRequest) {
        var result;

        if (this._skipCheck) {
            return asyncRequest ? Promise.resolve(true) : true;
        }

        if (this._currentPage && this._currentPage.options && this._currentPage.options.unloadCb) {
            result = this._currentPage.options.unloadCb(this._currentPage, asyncRequest);
            if (!asyncRequest || result instanceof Promise) {
                return result;
            }
            return result ? Promise.resolve(result) : Promise.reject(result);
        } else {
            return asyncRequest ? Promise.resolve(true) : true;
        }
    };

    /**
     * Check if router has the action for current path
     *
     * @returns {boolean}
     * @private
     */
    Router.prototype._findRoute = function () {
        var _this = this,
            fragment = this._getFragment();

        return this.routes.some(function (route) {
            var match = fragment.match(route.rule);
            if (match) {
                match.shift();
                var query = _this._getQuery();
                var page = new Router.Page(fragment, query, match, _this._pageState, route.options);

                if (!_this.securityHook(page)) {
                    return false;
                }

                _this._currentPage = page;
                if (_this._skipCheck) {
                    _this._skipCheck = false;
                    return true;
                }
                _this.beforeHook(page);
                route.handler.apply(page, match);
                _this._pageState = null;

                window.onbeforeunload = function (ev) {
                    if (_this._unloadCallback(false)) {
                        return;
                    }
                    ev.returnValue = true;
                    return true;
                };

                return true;
            }
            return false;
        });
    };

    /**
     *
     */
    Router.prototype._treatAsync = function () {
        var result;

        result = this._currentPage.options.unloadCb(this._currentPage, true);
        if (!(result instanceof Promise)) {
            result = result ? Promise.resolve(result) : Promise.reject(result);
        }

        result
            .then(this._processUri.bind(this))
            .catch(this._resetState.bind(this));
    };

    /**
     *
     * @private
     */
    Router.prototype._resetState = function () {
        this._skipCheck = true;
        this.navigateTo(this._current, this._currentPage.state, true);
    };

    /**
     * Replace current page with new one
     */
    Router.prototype._processUri = function () {
        var fragment = this._getFragment(),
            found;

        this._current = fragment;
        this._pushHistory();

        found = this._findRoute.call(this);
        if (!found) {
            this._page404(fragment);
        }
    };

    /**
     * Check the URL and execute handler for its route
     *
     * @returns {Router}
     */
    Router.prototype.check = function () {
        if (this._skipCheck) return this;

        // if page has unload cb treat as promise
        if (this._currentPage && this._currentPage.options && this._currentPage.options.unloadCb) {
            this._treatAsync();
        } else {
            this._processUri();
        }
        return this;
    };

    /**
     * Add the URI listener
     *
     * @returns {Router}
     */
    Router.prototype.addUriListener = function () {
        if (this.mode === "history") {
            window.onpopstate = this.check.bind(this);
        } else {
            window.onhashchange = this.check.bind(this);
        }

        return this;
    };

    /**
     * Remove the URI listener
     *
     * @returns {Router}
     */
    Router.prototype.removeUriListener = function () {
        window.onpopstate = null;
        window.onhashchange = null;
        return this;
    };

    /**
     * Redirect to a page with replace state
     *
     * @param {string} path
     * @param {object} state
     * @param {boolean} silent
     *
     * @returns {Router}
     */
    Router.prototype.redirectTo = function (path, state, silent) {
        path = this._trimSlashes(path) || "";
        this._pageState = state || null;
        this._skipCheck = !!silent;

        if (this.mode === "history") {
            history.replaceState(state, null, this.root + this._trimSlashes(path));
            return this.check();
        } else {
            this._historyIdx--;
            window.location.hash = path;
        }
        return this;
    };

    /**
     * Navigate to a page
     *
     * @param {string} path
     * @param {object} state
     * @param {boolean} silent
     *
     * @returns {Router}
     */
    Router.prototype.navigateTo = function (path, state, silent) {
        path = this._trimSlashes(path) || "";
        this._pageState = state || null;
        this._skipCheck = !!silent;

        if (this.mode === "history") {
            history.pushState(state, null, this.root + this._trimSlashes(path));
            return this.check();
        } else {
            window.location.hash = path;
        }
        return this;
    };

    /**
     * Refresh page with recall route handler
     * @returns {Router}
     */
    Router.prototype.refresh = function () {
        if (!this._currentPage) {
            return this;
        }
        var path = this._currentPage.uri + "?" + this._queryString;
        return this.navigateTo(path, this._currentPage.state);
    };

    /**
     * Go Back in browser history
     * Simulate "Back" button
     *
     * @returns {Router}
     */
    Router.prototype.back = function () {
        if (this.mode === "history") {
            window.history.back();
            return this;
        }

        return this.go(this._historyIdx - 1);
    };

    /**
     * Go Forward in browser history
     * Simulate "Forward" button
     *
     * @returns {Router}
     */
    Router.prototype.forward = function () {
        if (this.mode === "history") {
            window.history.forward();
            return this;
        }

        return this.go(this._historyIdx + 1);
    };

    /**
     * Go to a specific history page
     *
     * @param {number} count
     * @returns {Router}
     */
    Router.prototype.go = function (count) {
        if (this.mode === "history") {
            window.history.go(count);
            return this;
        }

        var page = this._historyStack[count];
        if (!page) {
            return this;
        }

        this._historyIdx = count;
        this._historyState = "hold";
        return this.navigateTo(page.path, page.state);
    };

    return Router;
})));
},{}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YOIL_CSS = void 0;
exports.YOIL_CSS = {
  yoil_display_hide: 'yoil_display-hide',
  yoil_display_alpha_hide: 'yoil_display-alpha-hide',
  yoil_ani_alpha_up: 'yoil-alpha-up',
  yoil_ani_alpha_down: 'yoil-alpha-down'
};

},{}],27:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YoilEvent = void 0;

var YoilEvent = function YoilEvent() {
  (0, _classCallCheck2["default"])(this, YoilEvent);
};

exports.YoilEvent = YoilEvent;
YoilEvent.SOUND_COMPLETE = 'YOIL_SOUND_COMPLETE';

},{"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/interopRequireDefault":10}],28:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YoilSoundPlayerViewer = void 0;

var media_events_1 = require("../../event/media-events");

var pc_mobile_1 = require("../../pc-mobile");

var sound_player_1 = require("./sound-player");

var YoilSoundPlayerViewer = /*#__PURE__*/function (_sound_player_1$YoilS) {
  (0, _inherits2["default"])(YoilSoundPlayerViewer, _sound_player_1$YoilS);

  var _super = _createSuper(YoilSoundPlayerViewer);

  function YoilSoundPlayerViewer() {
    var _this;

    (0, _classCallCheck2["default"])(this, YoilSoundPlayerViewer);
    _this = _super.apply(this, arguments);
    _this.newSoundBool = false;
    _this.durationTime = 0;
    _this.userRangePress = false;
    return _this;
  }

  (0, _createClass2["default"])(YoilSoundPlayerViewer, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var soundPlayer = document.querySelector('.yoil-sound-player'); // soundPlayer.insertAdjacentHTML('afterbegin', this.getTag());

      soundPlayer.innerHTML = this.getTag();
      this.player.addEventListener('durationchange', function () {
        _this2.durationTime = _this2.player.duration;
      });
      window.addEventListener(media_events_1.YoilEvent.SOUND_COMPLETE, this.setSoundComplete.bind(this));
      this.setPlayPauseButton();
      this.setStopButton();
      this.setReplayButton();
      this.setRange();
      this.setSoundOnOffButton();
    }
  }, {
    key: "getTag",
    value: function getTag() {
      return "\n        <div class=\"yoil-sound_view\">\n            <div class=\"yoil-sound-view_control\">\n                <div class=\"yoil-sound_btn-playPause\"></div>\n                <div class=\"yoil-sound_btn-stop\"></div>\n                <div class=\"yoil-sound_btn-replay\"></div>\n            </div>\n            <div class=\"yoil-sound-view_range\">\n                <input type=\"range\" id=\"playRange\" min=\"0\" max=\"1000\" value=\"0\" step=\"0.1\"/>\n            </div>\n            <div class=\"yoil-sound-view_soundOnOff\"></div>\n        </div>\n        ";
    }
  }, {
    key: "setSoundComplete",
    value: function setSoundComplete() {
      var btnReplay = document.querySelector('.yoil-sound_btn-replay');
      this.resetBtns();

      if (btnReplay.classList.contains('off') === false) {
        var btnPlayPause = document.querySelector('.yoil-sound_btn-playPause');
        btnPlayPause.dispatchEvent(new Event(pc_mobile_1.StaticData.CLICK));
      }
    }
  }, {
    key: "setPlayPauseButton",
    value: function setPlayPauseButton() {
      var _this3 = this;

      var btnPlayPause = document.querySelector('.yoil-sound_btn-playPause');
      btnPlayPause.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        if (btnPlayPause.classList.contains('pause')) {
          _this3.resetBtns();
        } else {
          btnPlayPause.classList.add('pause');

          _this3.play();
        }
      });
    }
  }, {
    key: "play",
    value: function play() {
      if (this.newSoundBool === true) {
        this.soundPlay(this.soundPath);
        this.newSoundBool = false;
      } else {
        this.player.play();
      }
    }
  }, {
    key: "resetBtns",
    value: function resetBtns() {
      var btnPlayPause = document.querySelector('.yoil-sound_btn-playPause');
      btnPlayPause.classList.remove('pause');
      this.player.pause();
    }
  }, {
    key: "setStopButton",
    value: function setStopButton() {
      var _this4 = this;

      var btnStop = document.querySelector('.yoil-sound_btn-stop');
      btnStop.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this4.resetBtns();

        _this4.player.currentTime = 0;
      });
    }
  }, {
    key: "setReplayButton",
    value: function setReplayButton() {
      var btnReplay = document.querySelector('.yoil-sound_btn-replay');
      btnReplay.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        if (btnReplay.classList.contains('off')) {
          btnReplay.classList.remove('off');
        } else {
          btnReplay.classList.add('off');
        }
      });
    }
  }, {
    key: "setRange",
    value: function setRange() {
      var _this5 = this;

      var rangeBar = document.querySelector('#playRange');
      rangeBar.addEventListener(pc_mobile_1.StaticData.PRESS, function () {
        _this5.userRangePress = true;
      });
      rangeBar.addEventListener(pc_mobile_1.StaticData.UP, function () {
        _this5.userRangePress = false;
        var currentTime = _this5.durationTime * +rangeBar.value / 1000.0;
        _this5.player.currentTime = currentTime;
      });
      this.player.addEventListener('timeupdate', function () {
        if (_this5.durationTime === 0) return;
        if (_this5.userRangePress === true) return;
        var currentValue = 1000 * _this5.player.currentTime / _this5.durationTime;
        rangeBar.value = currentValue + '';
      });
    }
  }, {
    key: "setSoundOnOffButton",
    value: function setSoundOnOffButton() {
      var _this6 = this;

      var btnSoundOnOff = document.querySelector('.yoil-sound-view_soundOnOff');
      btnSoundOnOff.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        if (btnSoundOnOff.classList.contains('off')) {
          btnSoundOnOff.classList.remove('off');
          _this6.player.muted = false;
        } else {
          btnSoundOnOff.classList.add('off');
          _this6.player.muted = true;
        }
      });
    }
  }, {
    key: "setSound",
    value: function setSound(soundPath) {
      this.durationTime = 0;
      this.soundStop();
      this.soundPath = soundPath;
      this.newSoundBool = true;
      this.resetBtns();
      var rangeBar = document.querySelector('#playRange');
      rangeBar.value = '0';
    }
  }, {
    key: "addTag",
    value: function addTag(tagStr, className) {
      var tagNode = document.createElement(tagStr);
      tagNode.className = className;
      var viewer = document.querySelector('.yoil-sound_view');
      viewer.appendChild(tagNode);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.soundStop();
      this.player = null;
      window.removeEventListener(media_events_1.YoilEvent.SOUND_COMPLETE, this.setSoundComplete.bind(this));
    }
  }]);
  return YoilSoundPlayerViewer;
}(sound_player_1.YoilSoundPlayer);

exports.YoilSoundPlayerViewer = YoilSoundPlayerViewer;

},{"../../event/media-events":27,"../../pc-mobile":31,"./sound-player":29,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/getPrototypeOf":8,"@babel/runtime/helpers/inherits":9,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/possibleConstructorReturn":15}],29:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YoilSoundPlayer = void 0;

var media_events_1 = require("../../event/media-events");

var YoilSoundPlayer = /*#__PURE__*/function () {
  function YoilSoundPlayer() {
    (0, _classCallCheck2["default"])(this, YoilSoundPlayer);
    this.player = new Audio();
  }

  (0, _createClass2["default"])(YoilSoundPlayer, [{
    key: "soundPlay",
    value: function soundPlay(sndPath) {
      if (this.player.src) {
        this.player.pause();
        this.player.removeEventListener('ended', this.soundPlayComplete);
      }

      this.player.addEventListener('ended', this.soundPlayComplete);
      this.player.src = sndPath;
      this.player.play();
    }
  }, {
    key: "soundPlayComplete",
    value: function soundPlayComplete() {
      window.dispatchEvent(new Event(media_events_1.YoilEvent.SOUND_COMPLETE));
    }
  }, {
    key: "soundStop",
    value: function soundStop() {
      if (this.player.src) {
        this.player.pause();
      }

      this.player.src = '';
    }
  }]);
  return YoilSoundPlayer;
}();

exports.YoilSoundPlayer = YoilSoundPlayer;

},{"../../event/media-events":27,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],30:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YoilVideoPlayer = void 0;

var pc_mobile_1 = require("../../pc-mobile");

var css_name_1 = require("../../css-name");

var YoilVideoPlayer = /*#__PURE__*/function () {
  function YoilVideoPlayer() {
    (0, _classCallCheck2["default"])(this, YoilVideoPlayer);
    this.isBallPress = false;
  }

  (0, _createClass2["default"])(YoilVideoPlayer, [{
    key: "init",
    value: function init(videoInfo) {
      var videoPlayer = document.querySelector('.yoil-video-player');
      videoPlayer.innerHTML = this.getTag(videoInfo.width, videoInfo.height);
      this.videoViewer = document.querySelector('.yoil-video');
      this.videoViewer.loop = true;
      this.controlBar = document.querySelector('.control_bar');

      if (videoInfo.controlBool === false) {
        var controls = document.querySelector('.yoil-video_control');
        controls.style.display = 'none';
      }

      var videoCover = document.querySelector('.video-cover');
      videoCover.style.width = "".concat(videoInfo.width + 10, "px");
      videoCover.style.height = "".concat(videoInfo.height + 10, "px");
    }
  }, {
    key: "getVideoViewer",
    value: function getVideoViewer() {
      return this.videoViewer;
    }
  }, {
    key: "getTag",
    value: function getTag(width, height) {
      return "\n        <div class=\"yoil-video_view\">\n            <video class='yoil-video' width=\"".concat(width, "\" height=\"").concat(height, "\">\n                <source src=\"\" type=\"video/mp4\">\n            </video>\n            <div class=\"video-cover\"></div>\n        </div>\n        <div class=\"yoil-video_control\"> \n            <div class=\"control_play yoil-video-controler\"></div>\n            <div class=\"control_stop yoil-video-controler\"></div>\n            <div class=\"control_replay yoil-video-controler\"></div>\n            <div class=\"control_bar\">\n                <input type=\"range\" id=\"playRange\" min=\"0\" max=\"1000\" value=\"0\" step=\"0.1\"/>\n            </div>\n            <div class=\"control_caption yoil-video-controler\"></div>\n            <div class=\"control_fulltoggle yoil-video-controler\"></div>\n            <div class=\"control_sound yoil-video-controler\"></div>\n        </div>\n        ");
    } //<div class="bar_ball"></div>

  }, {
    key: "startComponent",
    value: function startComponent() {
      this.setPlayer();
      this.setVideoCheck();

      if (!(0, pc_mobile_1.isIphone)() && !(0, pc_mobile_1.isIpad)()) {
        this.videoViewer.requestFullscreen();
      }
    }
  }, {
    key: "setPlayer",
    value: function setPlayer() {
      var _this = this;

      var playAndPauseBtn = 'control_play';
      var stopBtn = 'control_stop';
      var replayBtn = 'control_replay';
      var captionBtn = 'control_caption';
      var fullScreenBtn = 'control_fulltoggle';
      var soundBtn = 'control_sound';
      var controls = document.querySelectorAll('.yoil-video-controler');
      controls.forEach(function (el) {
        el.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          var playerBtn = el.className.split(' ')[0];

          switch (playerBtn) {
            case playAndPauseBtn:
              _this.playAndPause();

              break;

            case stopBtn:
              _this.videoStop();

              break;

            case replayBtn:
              _this.setReplay();

              break;

            case captionBtn:
              break;

            case fullScreenBtn:
              _this.setFullScreenToggle();

              break;

            case soundBtn:
              _this.setSoundMute();

              break;
          }
        });
      });
    }
  }, {
    key: "playAndPause",
    value: function playAndPause() {
      var playPauseBtn = document.querySelector('.control_play');

      if (this.videoViewer.paused) {
        this.videoViewer.play();
        playPauseBtn.classList.add('control_play-pause');
      } else {
        this.setPauseStatus();
      }
    }
  }, {
    key: "setPauseStatus",
    value: function setPauseStatus() {
      var playPauseBtn = document.querySelector('.control_play');
      this.videoViewer.pause();
      playPauseBtn.classList.remove('control_play-pause');
    }
  }, {
    key: "videoStop",
    value: function videoStop() {
      this.setPauseStatus();
      this.videoViewer.currentTime = 0;
    }
  }, {
    key: "setReplay",
    value: function setReplay() {
      this.videoViewer.loop = !this.videoViewer.loop;
      var replay = document.querySelector('.control_replay');

      if (this.videoViewer.loop) {
        replay.classList.remove('control_replay-off');
      } else {
        replay.classList.add('control_replay-off');
      }
    }
  }, {
    key: "setVideoCheck",
    value: function setVideoCheck() {
      var _this2 = this;

      var rangeBar = document.querySelector('#playRange');
      rangeBar.addEventListener(pc_mobile_1.StaticData.PRESS, function () {
        _this2.isBallPress = true;
      });
      rangeBar.addEventListener(pc_mobile_1.StaticData.UP, function () {
        _this2.isBallPress = false;
        var currentTime = _this2.videoViewer.duration * +rangeBar.value / 1000.0;
        _this2.videoViewer.currentTime = currentTime;
      });
      this.videoViewer.addEventListener('timeupdate', function () {
        if (_this2.videoViewer.duration) {
          if (_this2.isBallPress === true) return;
          var currentValue = 1000 * _this2.videoViewer.currentTime / _this2.videoViewer.duration;
          rangeBar.value = currentValue + '';
        }
      });
      this.videoViewer.addEventListener('ended', function () {
        var playPauseBtn = document.querySelector('.control_play');
        playPauseBtn.classList.remove('control_play-pause');
      });
    }
  }, {
    key: "setFullScreenToggle",
    value: function setFullScreenToggle() {
      this.videoViewer.requestFullscreen();
    }
  }, {
    key: "setSoundMute",
    value: function setSoundMute() {
      this.videoViewer.muted = !this.videoViewer.muted;
      var soundBtn = document.querySelector('.control_sound');

      if (this.videoViewer.muted) {
        soundBtn.classList.add('control_sound-off');
      } else {
        soundBtn.classList.remove('control_sound-off');
      }
    }
  }, {
    key: "changeVideo",
    value: function changeVideo(videoUrl) {
      var source = this.videoViewer.querySelector('source');
      source.setAttribute('src', videoUrl);
      this.videoViewer.load();
    }
  }, {
    key: "captionHide",
    value: function captionHide() {
      var controls = document.querySelector('.yoil-video_control');
      var captionBtn = controls.querySelector('.control_caption');
      captionBtn.classList.add(css_name_1.YOIL_CSS.yoil_display_hide);
    }
  }]);
  return YoilVideoPlayer;
}();

exports.YoilVideoPlayer = YoilVideoPlayer;

},{"../../css-name":26,"../../pc-mobile":31,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticData = exports.isIpad = exports.isHeightSize = exports.isIphone = exports.pcOrMobile = void 0;

var pcOrMobile = function pcOrMobile() {
  var filter = 'win16|win32|win64|mac';
  var vWebType = '';

  if (navigator.platform) {
    if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
      vWebType = 'MOBILE';
    } else {
      vWebType = 'PC';
    }
  }

  return vWebType;
};

exports.pcOrMobile = pcOrMobile;

var isIphone = function isIphone() {
  return navigator.platform === 'iPhone';
};

exports.isIphone = isIphone;

var isHeightSize = function isHeightSize() {
  return window.innerHeight < 1200;
};

exports.isHeightSize = isHeightSize;

var isIpad = function isIpad() {
  var userAgent = navigator.userAgent;
  var platform = navigator.platform;
  return platform === 'iPad' || platform === 'MacIntel';
};

exports.isIpad = isIpad;
exports.StaticData = {
  CLICK: (0, exports.pcOrMobile)() == 'PC' ? 'click' : 'touchend',
  PRESS: (0, exports.pcOrMobile)() == 'PC' ? 'mousedown' : 'touchstart',
  UP: (0, exports.pcOrMobile)() == 'PC' ? 'mouseup' : 'touchend',
  MOVE: (0, exports.pcOrMobile)() == 'PC' ? 'mousemove' : 'touchmove',
  LEAVE: (0, exports.pcOrMobile)() == 'PC' ? 'mouseleave' : 'touchcancel'
};

},{}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Quitloading = exports.ViewLoading = exports.getRandomNum = exports.get10Check = void 0;

var get10Check = function get10Check(num) {
  if (num < 10) {
    return '0' + num;
  }

  return num + '';
};

exports.get10Check = get10Check;

var getRandomNum = function getRandomNum(startNum, endNum) {
  return Math.floor(Math.random() * (startNum - endNum + 1)) + endNum;
};

exports.getRandomNum = getRandomNum;

var ViewLoading = function ViewLoading() {
  var loading = document.createElement('div');
  loading.className = 'lds-dual-ring';
  var loadingPage = document.createElement('div');
  loadingPage.className = 'yoil-loading';
  loadingPage.appendChild(loading);
  var contents = document.querySelector('.contents');
  contents.append(loadingPage);
};

exports.ViewLoading = ViewLoading;

var Quitloading = function Quitloading() {
  var contents = document.querySelector('.contents');
  var loadingPage = document.querySelector('.yoil-loading');
  contents.removeChild(loadingPage);
};

exports.Quitloading = Quitloading;

},{}],33:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentStarter = void 0;

var bww_main_1 = require("./contents/bww/bww-main");

var content_select_1 = require("./contents/content-select");

var audio_common_1 = require("./contents/contents-common/audio-common");

var comic_common_1 = require("./contents/contents-common/comic-common");

var ebook_common_1 = require("./contents/contents-common/ebook-common");

var video_common_1 = require("./contents/contents-common/video-common");

var contents_index_1 = require("./contents/contents-index");

var ContentWftaCharacter_1 = require("./contents/wfta/character/ContentWftaCharacter");

var ContentWftaDictionary_1 = require("./contents/wfta/dictionary/ContentWftaDictionary");

var ContentWftaMap_1 = require("./contents/wfta/map/ContentWftaMap");

var ContentWftaPhonics_1 = require("./contents/wfta/phonics/ContentWftaPhonics");

var wfta_main_1 = require("./contents/wfta/wfta-main");

var ww_buildingWord_1 = require("./contents/ww/building-word/ww-buildingWord");

var ww_quiz_1 = require("./contents/ww/quiz/ww-quiz");

var ww_write_1 = require("./contents/ww/write/ww-write");

var ww_main_1 = require("./contents/ww/ww-main");

var data_interface_1 = require("./info/data-interface");

var ContentStarter = /*#__PURE__*/function () {
  function ContentStarter() {
    (0, _classCallCheck2["default"])(this, ContentStarter);
  }

  (0, _createClass2["default"])(ContentStarter, [{
    key: "getContentObject",
    value: function getContentObject(contentNameStr) {
      var splitLst = contentNameStr.split('-');
      var typeStr = splitLst[0];
      var content = splitLst[1] === undefined ? typeStr : splitLst[1];

      switch (typeStr) {
        case 'content':
          return new content_select_1.ContentSelect();

        case 'video':
          return new video_common_1.VideoCommon();

        case 'ebook':
          return new ebook_common_1.EbookCommon();

        case 'comic':
          return new comic_common_1.ComicCommon();

        case 'audio':
          return new audio_common_1.AudioCommon();

        case 'wfta':
          return this.getWftaContent(content);

        case 'ww':
          return this.getWwContent(content);

        case 'bww':
          return this.getBwwContent(content);
      }
    }
  }, {
    key: "getWftaContent",
    value: function getWftaContent(contnetName) {
      switch (contnetName) {
        case 'wfta':
          return new contents_index_1.ContentsIndex();

        case 'main':
          return new wfta_main_1.ContentWftaMain();

        case data_interface_1.WftaContents.Phonics:
          return new ContentWftaPhonics_1.ContentWftaPhonics();

        case data_interface_1.WftaContents.Dictionary:
          return new ContentWftaDictionary_1.ContentWftaDictionary();

        case data_interface_1.WftaContents.Character:
          return new ContentWftaCharacter_1.ContentWftaCharacter();

        case data_interface_1.WftaContents.Map:
          return new ContentWftaMap_1.ContentWftaMap();
      }
    }
  }, {
    key: "getWwContent",
    value: function getWwContent(contentName) {
      switch (contentName) {
        case 'ww':
          return new contents_index_1.ContentsIndex();

        case 'main':
          return new ww_main_1.ContentWwMain();

        case data_interface_1.WwContents.Buildingword:
          return new ww_buildingWord_1.ContentWwBuildingWord();

        case data_interface_1.WwContents.Quiz:
          return new ww_quiz_1.ContentWwQuiz();

        case data_interface_1.WwContents.Write:
          return new ww_write_1.ContentWwWrite();
      }
    }
  }, {
    key: "getBwwContent",
    value: function getBwwContent(contentName) {
      switch (contentName) {
        case 'bww':
          return new contents_index_1.ContentsIndex();

        case 'main':
          return new bww_main_1.ContentBwwMain();
      }
    }
  }]);
  return ContentStarter;
}();

exports.ContentStarter = ContentStarter;

},{"./contents/bww/bww-main":34,"./contents/content-select":35,"./contents/contents-common/audio-common":37,"./contents/contents-common/comic-common":38,"./contents/contents-common/ebook-common":40,"./contents/contents-common/video-common":42,"./contents/contents-index":43,"./contents/wfta/character/ContentWftaCharacter":44,"./contents/wfta/dictionary/ContentWftaDictionary":46,"./contents/wfta/map/ContentWftaMap":47,"./contents/wfta/phonics/ContentWftaPhonics":51,"./contents/wfta/wfta-main":52,"./contents/ww/building-word/ww-buildingWord":54,"./contents/ww/quiz/ww-quiz":56,"./contents/ww/write/ww-write":57,"./contents/ww/ww-main":58,"./info/data-interface":65,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],34:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentBwwMain = void 0;

var pc_mobile_1 = require("../../common/pc-mobile");

var util_1 = require("../../common/util/util");

var info_routerPath_1 = require("../../router/info-routerPath");

var program_info_1 = require("../../info/program-info");

var router_1 = require("../../router/router");

var content_common_1 = require("../contents-common/content-common");

var ContentBwwMain = /*#__PURE__*/function () {
  function ContentBwwMain() {
    (0, _classCallCheck2["default"])(this, ContentBwwMain);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
  }

  (0, _createClass2["default"])(ContentBwwMain, [{
    key: "init",
    value: function init() {
      this.setBackImg();
      (0, content_common_1.setExitBtn)('bww?first=false');
    }
  }, {
    key: "setBackImg",
    value: function setBackImg() {
      var _this = this;

      var bookNum = this.infoObj.getBookNumber();
      var contentsBtns = document.querySelectorAll('.main_content');
      contentsBtns.forEach(function (el, key) {
        var btnStr = (0, util_1.get10Check)(key + 1);
        el.style.backgroundImage = "url(\"./images/bww/main/".concat((0, util_1.get10Check)(bookNum), "/btn_").concat(btnStr, ".png\")");

        _this.setBtnMove(el);
      });
    }
  }, {
    key: "setBtnMove",
    value: function setBtnMove(el) {
      var _this2 = this;

      el.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        var router = router_1["default"].getInstance();
        var content = el.getAttribute('value');
        var videoName = content;

        if (videoName === 'storybook') {
          videoName = 'storybook_AR';
        }

        var videoUrl = "./video/bww/content".concat(_this2.infoObj.getBookNumber(), "/").concat(videoName, ".mp4");

        _this2.infoObj.setVideoUrl(videoUrl);

        router.moveContent("".concat(info_routerPath_1.routerPath.bww, "/").concat(_this2.infoObj.getBookNumber(), "/").concat(content));
      });
    }
  }, {
    key: "destory",
    value: function destory() {}
  }]);
  return ContentBwwMain;
}();

exports.ContentBwwMain = ContentBwwMain;

},{"../../common/pc-mobile":31,"../../common/util/util":32,"../../info/program-info":66,"../../router/info-routerPath":67,"../../router/router":71,"../contents-common/content-common":39,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],35:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentSelect = void 0;

var pc_mobile_1 = require("../common/pc-mobile");

var util_1 = require("../common/util/util");

var data_interface_1 = require("../info/data-interface");

var program_info_1 = require("../info/program-info");

var ReactCommnunication_1 = require("../info/ReactCommnunication");

var router_1 = require("../router/router");

var ContentSelect = /*#__PURE__*/function () {
  function ContentSelect() {
    (0, _classCallCheck2["default"])(this, ContentSelect);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
    this.reactObj = ReactCommnunication_1.ReactCommunication.getInstance();
    this.reactObj.setReflashObj(this);
  }

  (0, _createClass2["default"])(ContentSelect, [{
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var books;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, util_1.ViewLoading)();

                if (!(window['testMode'] === true)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 8;
                break;

              case 4:
                _context.next = 6;
                return this.reactObj.getBooks();

              case 6:
                books = _context.sent;
                this.infoObj.setUserBooks(books);

              case 8:
                this.setTopButton();
                this.setBigButton();
                (0, util_1.Quitloading)();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setTopButton",
    value: function setTopButton() {
      var _this = this;

      var qrCodeBtn = document.querySelector('.right_qrcode');

      if (qrCodeBtn.getAttribute('addEvent')) {} else {
        qrCodeBtn.setAttribute('addEvent', 'click');
        qrCodeBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          _this.reactObj.insertUserBook();
        });
      }
    }
  }, {
    key: "setBigButton",
    value: function setBigButton() {
      var _this2 = this;

      var elementLst = document.querySelectorAll('.selectBig_btn');
      var bookTypes = [data_interface_1.BookType.WFTA, data_interface_1.BookType.WW, data_interface_1.BookType.BWW];
      elementLst.forEach(function (el, value) {
        var books = _this2.infoObj.getUserBooks(bookTypes[value]);

        if (books.length > 0) {
          el.classList.remove('yoil_button-disable');
        }

        if (window['testMode'] === true) {
          el.classList.remove('yoil_button-disable');
        }

        if (el.getAttribute('addEvent')) {} else {
          el.setAttribute('addEvent', 'click');
          el.addEventListener(pc_mobile_1.StaticData.CLICK, _this2.moveMainContent);
        }
      });
    }
  }, {
    key: "moveMainContent",
    value: function moveMainContent(event) {
      var target = event.currentTarget;
      var pathStr = target.getAttribute('name');
      var router = router_1["default"].getInstance();
      router.moveContent(pathStr);
    }
  }, {
    key: "destory",
    value: function destory() {}
  }]);
  return ContentSelect;
}();

exports.ContentSelect = ContentSelect;

},{"../common/pc-mobile":31,"../common/util/util":32,"../info/ReactCommnunication":64,"../info/data-interface":65,"../info/program-info":66,"../router/router":71,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/regenerator":22}],36:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractEbook = void 0;

var media_events_1 = require("../../common/event/media-events");

var sound_player_1 = require("../../common/media/sound/sound-player");

var pc_mobile_1 = require("../../common/pc-mobile");

var util_1 = require("../../common/util/util");

var get_data_1 = require("../../data/get-data");

var data_interface_1 = require("../../info/data-interface");

var program_info_1 = require("../../info/program-info");

var content_common_1 = require("./content-common");

var AbstractEbook = /*#__PURE__*/function () {
  function AbstractEbook() {
    (0, _classCallCheck2["default"])(this, AbstractEbook);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
    this.soundPlayer = new sound_player_1.YoilSoundPlayer();
  }

  (0, _createClass2["default"])(AbstractEbook, [{
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var dataInfo;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataInfo = new get_data_1.BookData();
                _context.next = 3;
                return dataInfo.getContentData();

              case 3:
                this.currentBookData = _context.sent;
                this.pageLst = Object.keys(this.currentBookData).reverse();
                this.totalPageNum = this.pageLst.length - 1;
                this.setBookTitle();
                this.setContentTypeData();
                this.addPages();
                this.setSideBtns();
                (0, content_common_1.setExitBtn)();
                window.addEventListener(media_events_1.YoilEvent.SOUND_COMPLETE, this.soundBtnStyleReset);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setBookTitle",
    value: function setBookTitle() {
      var titleDiv = document.querySelector('.top_title');
      titleDiv.innerHTML = this.infoObj.getBookTitle();
    }
  }, {
    key: "soundBtnStyleReset",
    value: function soundBtnStyleReset() {
      var ebookBtns = document.querySelectorAll('.ebook_sound');
      var comicBtns = document.querySelectorAll('.comic_sound');
      var sndBtns = [].concat((0, _toConsumableArray2["default"])(ebookBtns), (0, _toConsumableArray2["default"])(comicBtns));
      sndBtns.forEach(function (sndEl) {
        sndEl.classList.remove('playing');
      });
    }
  }, {
    key: "setContentTypeData",
    value: function setContentTypeData() {
      var contentType = this.infoObj.getContentType();
      var addTypes = document.querySelectorAll('.add_type');
      (0, content_common_1.addElementClass)(addTypes, contentType);
    }
  }, {
    key: "addPages",
    value: function addPages() {
      var _this = this;

      var contentType = this.infoObj.getContentType();
      this.pageLst.forEach(function (str, key) {
        var pageEl = document.createElement('div');
        pageEl.className = "".concat(_this.getCurrentContent(), "_") + str;
        pageEl.classList.add("".concat(_this.getCurrentContent(), "_page"));
        pageEl.classList.add(contentType);
        var subImgNum = +str.substr(4, 2);
        var pageStr = (0, util_1.get10Check)(subImgNum);
        pageEl.style.backgroundImage = _this.getEbookUrl(pageStr);

        _this.addSoundButtons(subImgNum, pageEl);
      });
    }
  }, {
    key: "getCurrentContent",
    value: function getCurrentContent() {
      var currentContent = this.infoObj.getCurrentContent();

      switch (currentContent) {
        case data_interface_1.WftaContents.Act:
        case data_interface_1.WwContents.ComicBook:
          currentContent = 'comic';
          break;
      }

      return currentContent;
    }
  }, {
    key: "getEbookUrl",
    value: function getEbookUrl(pageStr) {
      return "url(\"./images/".concat(this.infoObj.getContentType(), "/").concat(this.getCurrentContent(), "/").concat((0, util_1.get10Check)(this.infoObj.getBookNumber()), "/S").concat(this.infoObj.getContentInnerNumber(), "/img_").concat(pageStr, ".jpg\")");
    } // 사운드 버튼 삽입

  }, {
    key: "addSoundButtons",
    value: function addSoundButtons(subImgNum, pageEl) {
      var _this2 = this;

      var bookPageEl = document.querySelector('.content_pages');
      var pageStr = 'page' + subImgNum;
      var sndPlayList = [];
      Object.keys(this.currentBookData[pageStr]).forEach(function (sndObj, key) {
        if (sndObj === 'mp3') {
          sndPlayList = _this2.currentBookData[pageStr][sndObj];
          return;
        }

        var _this2$currentBookDat = _this2.currentBookData[pageStr][sndObj],
            x = _this2$currentBookDat.x,
            y = _this2$currentBookDat.y;
        var sndEl = document.createElement('div');
        sndEl.className = "".concat(_this2.getCurrentContent(), "_sound");
        sndEl.classList.add("".concat(_this2.getCurrentContent(), "_sound_") + key);
        sndEl.style.left = "".concat(x, "px");
        sndEl.style.top = "".concat(y, "px");
        sndEl.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          var sndNameLst = sndEl.className.split('_');
          var sndNum = sndNameLst[sndNameLst.length - 1];

          var sndPath = _this2.getSoundPath(sndPlayList[sndNum]);

          _this2.soundBtnStyleReset();

          sndEl.classList.add('playing');

          _this2.soundPlayer.soundPlay(sndPath);
        });
        pageEl.appendChild(sndEl);
      });
      bookPageEl.appendChild(pageEl);
    }
  }, {
    key: "getSoundPath",
    value: function getSoundPath(sndName) {
      return "./sound/".concat(this.infoObj.getContentType(), "/").concat(this.infoObj.getCurrentContent(), "/").concat((0, util_1.get10Check)(this.infoObj.getBookNumber()), "/S").concat(this.infoObj.getContentInnerNumber(), "/").concat(sndName);
    }
  }, {
    key: "setSideBtns",
    value: function setSideBtns() {}
  }, {
    key: "destory",
    value: function destory() {
      window.removeEventListener(media_events_1.YoilEvent.SOUND_COMPLETE, this.soundBtnStyleReset);
    }
  }]);
  return AbstractEbook;
}();

exports.AbstractEbook = AbstractEbook;

},{"../../common/event/media-events":27,"../../common/media/sound/sound-player":29,"../../common/pc-mobile":31,"../../common/util/util":32,"../../data/get-data":62,"../../info/data-interface":65,"../../info/program-info":66,"./content-common":39,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/toConsumableArray":19,"@babel/runtime/regenerator":22}],37:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioCommon = void 0;

var sound_player_viewer_1 = require("../../common/media/sound/sound-player-viewer");

var pc_mobile_1 = require("../../common/pc-mobile");

var util_1 = require("../../common/util/util");

var get_data_1 = require("../../data/get-data");

var data_interface_1 = require("../../info/data-interface");

var program_info_1 = require("../../info/program-info");

var content_common_1 = require("./content-common");

var AudioCommon = /*#__PURE__*/function () {
  function AudioCommon() {
    (0, _classCallCheck2["default"])(this, AudioCommon);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
  }

  (0, _createClass2["default"])(AudioCommon, [{
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var textBoard, firstItem;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.bookNumber = this.infoObj.getBookNumber();
                this.innerNumber = this.infoObj.getContentInnerNumber();
                this.contentType = this.infoObj.getContentType();
                this.bookData = new get_data_1.BookData();
                this.bookData.setContentType(this.contentType);
                this.soundPlayerViewer = new sound_player_viewer_1.YoilSoundPlayerViewer();
                this.soundPlayerViewer.init();
                this.setImg();
                this.setBoard();
                _context.next = 11;
                return this.setTextBoard();

              case 11:
                (0, content_common_1.setExitBtn)();
                textBoard = document.querySelector('.back_textBoard');
                firstItem = textBoard.querySelector('.textBoard_item');
                firstItem.dispatchEvent(new Event(pc_mobile_1.StaticData.CLICK));

                if (window['isNativeApp'] === true) {
                  textBoard.classList.add('native');
                }

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setImg",
    value: function setImg() {
      var contentEl = document.querySelector('.content-audio');
      var logo = document.querySelector('.content_top');
      contentEl.classList.add("content-".concat(this.contentType));
      logo.classList.add(this.contentType);
    }
  }, {
    key: "setBoard",
    value: function setBoard() {
      var monthImg = document.querySelector('.cover_month');
      var coverImg = document.querySelector('.cover_img');
      var coverTitle = document.querySelector('.cover_title');
      monthImg.style.backgroundImage = "url(\"".concat(this.getMonthPath(), "\")");
      coverImg.style.backgroundImage = "url(\"./images/".concat(this.contentType, "/list/cover/btn_").concat(this.getInnerContentPath(), ".jpg\")");
      var bookNumber = this.bookNumber - 1;
      var innerNumber = this.innerNumber - 1;
      var bookStr = this.bookData.getList()[bookNumber][innerNumber];
      coverTitle.innerText = bookStr;
    }
  }, {
    key: "getMonthPath",
    value: function getMonthPath() {
      return this.infoObj.getMonthImgPath(this.bookNumber);
    }
  }, {
    key: "getInnerContentPath",
    value: function getInnerContentPath() {
      var dividNum = this.contentType === data_interface_1.BookType.WFTA ? 3 : 4;
      var bookCoverNum = this.bookNumber * dividNum + (this.innerNumber - dividNum);
      return (0, util_1.get10Check)(bookCoverNum);
    }
  }, {
    key: "setTextBoard",
    value: function setTextBoard() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this = this;

        var borderDiv;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getBoardData();

              case 2:
                this.textData = _context2.sent;
                borderDiv = document.querySelector('.back_textBoard');
                this.textData.forEach(function (dataStr, value) {
                  var itemDiv = _this.createTextItem(dataStr);

                  itemDiv['mp3'] = value;
                  itemDiv.addEventListener(pc_mobile_1.StaticData.CLICK, _this.itemClick.bind(_this));
                  borderDiv.appendChild(itemDiv);
                });
                return _context2.abrupt("return", new Promise(function (resolve) {
                  resolve(true);
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getBoardData",
    value: function getBoardData() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var jsonPath, jsonData, start, end, returnData, targetContent;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                jsonPath = "./json/".concat(this.contentType, "/audio/").concat(this.contentType, "-audio.json");
                _context3.next = 3;
                return this.bookData.getNormalContentData(jsonPath);

              case 3:
                jsonData = _context3.sent;
                start = jsonData.start;
                end = jsonData.end;

                if (this.contentType === data_interface_1.BookType.WFTA) {
                  targetContent = jsonData["book".concat(this.bookNumber)]["S".concat(this.innerNumber)];
                  returnData = [].concat((0, _toConsumableArray2["default"])(start), (0, _toConsumableArray2["default"])(targetContent), [end]);
                } else if (this.contentType === data_interface_1.BookType.WW) {
                  returnData = jsonData['books'];
                }

                return _context3.abrupt("return", returnData);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "createTextItem",
    value: function createTextItem(dataStr) {
      var iconDiv = document.createElement('div');
      iconDiv.className = 'item_icon';
      var itemText = document.createElement('div');
      itemText.className = 'item_text';
      itemText.innerText = dataStr;
      var itemDiv = document.createElement('div');
      itemDiv.className = 'textBoard_item';
      itemDiv.appendChild(iconDiv);
      itemDiv.appendChild(itemText);
      return itemDiv;
    }
  }, {
    key: "itemClick",
    value: function itemClick(event) {
      document.querySelectorAll('.textBoard_item').forEach(function (target) {
        target.classList.remove('select');
      });
      var clkTarget = event.currentTarget;
      clkTarget.classList.add('select');
      var selectMonth = (0, util_1.get10Check)(this.bookNumber);
      var audioName = (0, util_1.get10Check)(clkTarget['mp3'] + 1);
      var soundPath = "./sound/".concat(this.contentType, "/audio/").concat(selectMonth, "/S").concat(this.innerNumber, "/audio").concat(audioName, ".mp3");
      this.soundPlayerViewer.setSound(soundPath);
    }
  }, {
    key: "destory",
    value: function destory() {
      this.soundPlayerViewer.destroy();
      this.soundPlayerViewer = null;
    }
  }]);
  return AudioCommon;
}();

exports.AudioCommon = AudioCommon;

},{"../../common/media/sound/sound-player-viewer":28,"../../common/pc-mobile":31,"../../common/util/util":32,"../../data/get-data":62,"../../info/data-interface":65,"../../info/program-info":66,"./content-common":39,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/toConsumableArray":19,"@babel/runtime/regenerator":22}],38:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComicCommon = void 0;

var css_name_1 = require("../../common/css-name");

var pc_mobile_1 = require("../../common/pc-mobile");

var abstract_ebook_1 = require("./abstract-ebook");

var ComicCommon = /*#__PURE__*/function (_abstract_ebook_1$Abs) {
  (0, _inherits2["default"])(ComicCommon, _abstract_ebook_1$Abs);

  var _super2 = _createSuper(ComicCommon);

  function ComicCommon() {
    var _this;

    (0, _classCallCheck2["default"])(this, ComicCommon);
    _this = _super2.apply(this, arguments);
    _this.comicPages = [];
    return _this;
  }

  (0, _createClass2["default"])(ComicCommon, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var _super = Object.create(null, {
        init: {
          get: function get() {
            return (0, _get2["default"])((0, _getPrototypeOf2["default"])(ComicCommon.prototype), "init", _this2);
          }
        }
      });

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _super.init.call(this);

                this.sideBtns = document.querySelectorAll('.content_side > div');

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setSideBtns",
    value: function setSideBtns() {
      var _this3 = this;

      this.pageLst.forEach(function (_key, value) {
        var targetEl = _this3.sideBtns[value];
        targetEl.classList.remove(css_name_1.YOIL_CSS.yoil_display_hide);
        targetEl.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          _this3.sideClickRemove();

          targetEl.classList.add('side_click');

          _this3.pageAllHide();

          _this3.showPages(value);

          _this3.soundPlayer.soundStop();

          _this3.soundBtnStyleReset();
        });
      });
      var el = this.sideBtns[0];
      el.dispatchEvent(new Event(pc_mobile_1.StaticData.CLICK));
    }
  }, {
    key: "sideClickRemove",
    value: function sideClickRemove() {
      this.sideBtns.forEach(function (el) {
        el.classList.remove('side_click');
      });
    }
  }, {
    key: "pageAllHide",
    value: function pageAllHide() {
      if (this.comicPages.length === 0) {
        this.setPages();
      }

      this.comicPages.forEach(function (el) {
        el.classList.add(css_name_1.YOIL_CSS.yoil_display_hide);
      });
    }
  }, {
    key: "setPages",
    value: function setPages() {
      var nodes = document.querySelectorAll('.content_pages>div');
      this.comicPages = Array.from(nodes).reverse();
    }
  }, {
    key: "showPages",
    value: function showPages(pageNum) {
      var targetPage = this.comicPages[pageNum];
      if (targetPage === undefined) return;
      targetPage.classList.remove(css_name_1.YOIL_CSS.yoil_display_hide);
    }
  }, {
    key: "destory",
    value: function destory() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(ComicCommon.prototype), "destory", this).call(this);
    }
  }]);
  return ComicCommon;
}(abstract_ebook_1.AbstractEbook);

exports.ComicCommon = ComicCommon;

},{"../../common/css-name":26,"../../common/pc-mobile":31,"./abstract-ebook":36,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/get":7,"@babel/runtime/helpers/getPrototypeOf":8,"@babel/runtime/helpers/inherits":9,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/possibleConstructorReturn":15,"@babel/runtime/regenerator":22}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addElementClass = exports.setExitBtn = void 0;

var pc_mobile_1 = require("../../common/pc-mobile");

var program_info_1 = require("../../info/program-info");

var router_1 = require("../../router/router");

var infoObj = program_info_1.ProgramInfo.getInstance(); // 나가기 버튼 설정

var setExitBtn = function setExitBtn() {
  var pathStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : infoObj.getBackUrl();
  var exitBtn = document.querySelector('.top_exit');
  exitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
    var router = router_1["default"].getInstance();
    router.moveContent(pathStr);
  });
};

exports.setExitBtn = setExitBtn;

var addElementClass = function addElementClass(elements, clssName) {
  elements.forEach(function (el) {
    el.classList.add(clssName);
  });
};

exports.addElementClass = addElementClass;

},{"../../common/pc-mobile":31,"../../info/program-info":66,"../../router/router":71}],40:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EbookCommon = void 0;

var pc_mobile_1 = require("../../common/pc-mobile");

var abstract_ebook_1 = require("./abstract-ebook");

var EbookCommon = /*#__PURE__*/function (_abstract_ebook_1$Abs) {
  (0, _inherits2["default"])(EbookCommon, _abstract_ebook_1$Abs);

  var _super2 = _createSuper(EbookCommon);

  function EbookCommon() {
    var _this;

    (0, _classCallCheck2["default"])(this, EbookCommon);
    _this = _super2.apply(this, arguments);
    _this.currentPageNum = 0;
    _this.YOIL_ALPHA_HIDE = 'yoil_display-alpha-hide';
    return _this;
  }

  (0, _createClass2["default"])(EbookCommon, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var _super = Object.create(null, {
        init: {
          get: function get() {
            return (0, _get2["default"])((0, _getPrototypeOf2["default"])(EbookCommon.prototype), "init", _this2);
          }
        }
      });

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _super.init.call(this);

                this.leftBtn = document.querySelector('.content_left');
                this.rightBtn = document.querySelector('.content_right');
                this.setArrow();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    } // 화살표 체크

  }, {
    key: "setArrow",
    value: function setArrow() {
      var _this3 = this;

      this.leftBtn.classList.add(this.YOIL_ALPHA_HIDE);
      this.leftBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this3.currentPageNum--;

        _this3.getCurrentPage().classList.remove(_this3.YOIL_ALPHA_HIDE);

        _this3.checkContentArrow();

        _this3.soundBtnStyleReset();

        _this3.soundPlayer.soundStop();
      });
      this.rightBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this3.getCurrentPage().classList.add(_this3.YOIL_ALPHA_HIDE);

        _this3.currentPageNum++;

        _this3.checkContentArrow();

        _this3.soundBtnStyleReset();

        _this3.soundPlayer.soundStop();
      });
    } // 현재 페이지 element를 돌려준다.

  }, {
    key: "getCurrentPage",
    value: function getCurrentPage() {
      return document.querySelector('.ebook_page' + this.currentPageNum);
    } // 화살표 체크

  }, {
    key: "checkContentArrow",
    value: function checkContentArrow() {
      this.leftBtn.classList.remove(this.YOIL_ALPHA_HIDE);
      this.rightBtn.classList.remove(this.YOIL_ALPHA_HIDE);

      if (this.currentPageNum === 0) {
        this.leftBtn.classList.add(this.YOIL_ALPHA_HIDE);
      } else if (this.currentPageNum === this.totalPageNum) {
        this.rightBtn.classList.add(this.YOIL_ALPHA_HIDE);
      }
    }
  }, {
    key: "destory",
    value: function destory() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(EbookCommon.prototype), "destory", this).call(this);
      this.soundPlayer.soundStop();
    }
  }]);
  return EbookCommon;
}(abstract_ebook_1.AbstractEbook);

exports.EbookCommon = EbookCommon;

},{"../../common/pc-mobile":31,"./abstract-ebook":36,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/get":7,"@babel/runtime/helpers/getPrototypeOf":8,"@babel/runtime/helpers/inherits":9,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/possibleConstructorReturn":15,"@babel/runtime/regenerator":22}],41:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainSideSection = void 0;

var pc_mobile_1 = require("../../common/pc-mobile");

var util_1 = require("../../common/util/util");

var data_interface_1 = require("../../info/data-interface");

var program_info_1 = require("../../info/program-info");

var MainSideSection = /*#__PURE__*/function () {
  function MainSideSection(listData) {
    (0, _classCallCheck2["default"])(this, MainSideSection);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
    this.stageNum = 1;
    this.listData = listData;
    this.setSideBtns();
  }

  (0, _createClass2["default"])(MainSideSection, [{
    key: "setSideBtns",
    value: function setSideBtns() {
      var _this = this;

      this.infoObj.setBookNumber(1);
      var btns = document.querySelectorAll('.section_btn');
      btns.forEach(function (el, key) {
        el.addEventListener(pc_mobile_1.StaticData.CLICK, function (event) {
          _this.stageNum = key + 1;

          _this.changeMonthText(key);

          _this.changeBorderColor(key);

          _this.changeBookCover(key);

          _this.inputBookTitle(key);

          _this.infoObj.setBookNumber(_this.stageNum);

          _this.setOpenContents();
        });
      });
      btns[0].dispatchEvent(new Event(pc_mobile_1.StaticData.CLICK));
    }
  }, {
    key: "changeMonthText",
    value: function changeMonthText(key) {
      var monthImg = document.querySelector('.title_image');
      this.removeClassPosition(monthImg);
      var titleUrl;

      if (this.infoObj.getContentType() == data_interface_1.BookType.BWW) {
        this.bwwContentCheck(monthImg);
        titleUrl = "url('./images/bww/list/vol_".concat((0, util_1.get10Check)(++key), ".png')");
      } else {
        titleUrl = "url(\"".concat(this.infoObj.getMonthImgPath(++key), "\")");
      }

      monthImg.style.backgroundImage = titleUrl;
    }
  }, {
    key: "bwwContentCheck",
    value: function bwwContentCheck(monthImg) {
      if (monthImg.classList.contains(data_interface_1.BookType.BWW)) {} else {
        monthImg.classList.add(data_interface_1.BookType.BWW);
      }
    }
  }, {
    key: "changeBorderColor",
    value: function changeBorderColor(key) {
      var border = document.querySelector('.index_board');
      var btnChar = String.fromCharCode(97 + key);
      this.removeClassPosition(border);
      border.classList.add(btnChar);
    } // 책 표지 교체

  }, {
    key: "changeBookCover",
    value: function changeBookCover(key) {
      var _this2 = this;

      var items = document.querySelectorAll('.contents_item');
      items.forEach(function (el, innerKey) {
        if (window['testMode'] === true) {
          el.classList.remove('yoil_button-disable');
        } else {
          if (el.classList.contains('yoil_button-disable')) {} else {
            el.classList.add('yoil_button-disable');
          }
        }

        _this2.removeItem(el);

        el.classList.add('item' + (key + 1));
      });
    } // 책 제목 넣기

  }, {
    key: "inputBookTitle",
    value: function inputBookTitle(dataNum) {
      var titles = this.listData[dataNum];
      var inputs = document.querySelectorAll('.item_text');
      inputs.forEach(function (el, key) {
        el.innerHTML = titles[key];
      });
    } // 보드 색 제거

  }, {
    key: "removeClassPosition",
    value: function removeClassPosition(border) {
      var positionNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (border.classList.length === 1) {
        return;
      }

      var removeClass = border.classList[positionNum];
      border.classList.remove(removeClass);
    }
  }, {
    key: "removeItem",
    value: function removeItem(el) {
      var itemNum = 1;

      while (itemNum <= 12) {
        el.classList.remove("item".concat(itemNum));
        itemNum++;
      }
    }
  }, {
    key: "setOpenContents",
    value: function setOpenContents() {
      var books = this.infoObj.getUserBooks();
      var volumNum = this.infoObj.getBookNumber();
      books.forEach(function (data) {
        if (data.vol === volumNum) {
          var items = Array.from(document.querySelectorAll('.contents_item'));
          var targetItem = items[data.number - 1];
          targetItem.classList.remove('yoil_button-disable');
        }
      });
    }
  }]);
  return MainSideSection;
}();

exports.MainSideSection = MainSideSection;

},{"../../common/pc-mobile":31,"../../common/util/util":32,"../../info/data-interface":65,"../../info/program-info":66,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],42:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoCommon = void 0;

var video_player_1 = require("../../common/media/video/video-player");

var pc_mobile_1 = require("../../common/pc-mobile");

var data_interface_1 = require("../../info/data-interface");

var program_info_1 = require("../../info/program-info");

var router_1 = require("../../router/router");

var VideoCommon = /*#__PURE__*/function () {
  function VideoCommon() {
    (0, _classCallCheck2["default"])(this, VideoCommon);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
  }

  (0, _createClass2["default"])(VideoCommon, [{
    key: "init",
    value: function init() {
      this.setImg();
      this.setVideo();
      this.changeVideo();
      this.changeTitle();
      this.setExitContent();
    }
  }, {
    key: "setImg",
    value: function setImg() {
      var typeStr = this.infoObj.getContentType();
      var contentEl = document.querySelector('.content-animation');
      var logo = document.querySelector('.content_top');
      contentEl.classList.add(typeStr);
      logo.classList.add(typeStr);
    }
  }, {
    key: "setVideo",
    value: function setVideo() {
      this.videoPlayer = new video_player_1.YoilVideoPlayer();
      this.videoPlayer.init(this.getVideoSize());
      this.videoPlayer.startComponent();
      this.videoPlayer.captionHide();
    }
  }, {
    key: "getVideoSize",
    value: function getVideoSize() {
      switch (this.infoObj.getContentType()) {
        case data_interface_1.BookType.WFTA:
          return {
            width: 1200,
            height: 900
          };

        case data_interface_1.BookType.BWW:
        case data_interface_1.BookType.WW:
          return {
            width: 1760,
            height: 1000
          };
      }
    }
  }, {
    key: "changeVideo",
    value: function changeVideo() {
      var videoUrl = this.infoObj.getVideoUrl();
      this.videoPlayer.changeVideo(videoUrl);
    }
  }, {
    key: "changeTitle",
    value: function changeTitle() {
      var animationName = this.infoObj.getBookName();
      var titleEl = document.querySelector('.top_title');
      titleEl.textContent = animationName;
    }
  }, {
    key: "setExitContent",
    value: function setExitContent() {
      var _this = this;

      var exitBtn = document.querySelector('.top_exit');
      exitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        var router = router_1["default"].getInstance();
        router.moveContent(_this.infoObj.getBackUrl());
      });
    }
  }, {
    key: "destory",
    value: function destory() {}
  }]);
  return VideoCommon;
}();

exports.VideoCommon = VideoCommon;

},{"../../common/media/video/video-player":30,"../../common/pc-mobile":31,"../../info/data-interface":65,"../../info/program-info":66,"../../router/router":71,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],43:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentsIndex = void 0;

var pc_mobile_1 = require("../common/pc-mobile");

var data_interface_1 = require("../info/data-interface");

var program_info_1 = require("../info/program-info");

var router_1 = require("../router/router");

var main_side_section_1 = require("./contents-common/main-side-section");

var ContentsIndex = /*#__PURE__*/function () {
  function ContentsIndex() {
    (0, _classCallCheck2["default"])(this, ContentsIndex);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
    this.allView = false;
  }

  (0, _createClass2["default"])(ContentsIndex, [{
    key: "init",
    value: function init() {
      if (this.infoObj.getVariable('first')) {} else {
        var introEl = document.querySelector('.intro');
        introEl.classList.add('intro_logo');
        introEl.addEventListener('animationend', function () {
          introEl.classList.remove('intro_logo');
        });
      }

      this.infoObj.setContentType();
      this.currentContent = this.infoObj.getContentType();
      this.setCommonBtns();
      this.setMoveContents();
      this.setAllContents();
      this.setViewContents();
      this.setContentExit();
      this.checkOpenAllContents();
      var sideSection = new main_side_section_1.MainSideSection(this.infoObj.getBookList());
    }
  }, {
    key: "setCommonBtns",
    value: function setCommonBtns() {
      this.allBtn = document.querySelector(".".concat(this.currentContent, "All"));
      this.indexBoard = document.querySelector(".".concat(this.currentContent, "Index"));
    } // 컨텐츠로 이동

  }, {
    key: "setMoveContents",
    value: function setMoveContents() {
      var _this = this;

      var contentItems = document.querySelectorAll('.contents_item');
      contentItems.forEach(function (el, key) {
        if (window['testMode'] === true) {} else {
          el.classList.add('yoil_button-disable');
        }

        el.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          var monthNum = _this.infoObj.getBookNumber();

          var innerBookNum = key + 1;
          router_1["default"].getInstance().moveContent(_this.getContentPath(monthNum, innerBookNum));

          _this.infoObj.setContentInnerNumber(innerBookNum);
        });
      });
    }
  }, {
    key: "getContentPath",
    value: function getContentPath(bookNumber, innerContent) {
      var contentType = this.infoObj.getContentType();
      return contentType === data_interface_1.BookType.BWW ? data_interface_1.BookType.BWW + '/' + bookNumber : "".concat(contentType, "/").concat(bookNumber, "/").concat(innerContent);
    } // 전체 컨텐츠 설정

  }, {
    key: "setAllContents",
    value: function setAllContents() {
      var _this2 = this;

      var boxContent = document.querySelectorAll('.box_content');
      boxContent.forEach(function (el, key) {
        if (window['testMode'] === true) {} else {
          el.classList.add('yoil_button-disable');
        }

        el.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          var contentInfo = _this2.getAllContentsNumbers(key);

          if (_this2.currentContent === data_interface_1.BookType.BWW) {// 베이비 워드월드는 따로 설정해주지 않는다.
          } else {
            _this2.infoObj.setBookNumber(contentInfo.bookNumber);

            _this2.infoObj.setContentInnerNumber(contentInfo.innerContent);
          }

          router_1["default"].getInstance().moveContent(contentInfo.movePath);
        });
      });
    }
  }, {
    key: "getAllContentsNumbers",
    value: function getAllContentsNumbers(key) {
      var allContentsInfo = {
        bookNumber: 0,
        innerContent: 0,
        movePath: ''
      };

      switch (this.currentContent) {
        case data_interface_1.BookType.WFTA:
          allContentsInfo = this.getAllInnerData(key, 3);
          break;

        case data_interface_1.BookType.WW:
          allContentsInfo = this.getAllInnerData(key, 4);
          break;

        case data_interface_1.BookType.BWW:
          allContentsInfo.movePath = "".concat(this.currentContent, "/").concat(key + 1);
          break;
      }

      return allContentsInfo;
    }
  }, {
    key: "getAllInnerData",
    value: function getAllInnerData(loopNum, bookLimit) {
      var bookNumber = Math.ceil((loopNum + 1) / bookLimit);
      var innerContent = (loopNum + 1) % bookLimit === 0 ? bookLimit : (loopNum + 1) % bookLimit;
      var movePath = "".concat(this.currentContent, "/").concat(bookNumber, "/").concat(innerContent);
      return {
        bookNumber: bookNumber,
        innerContent: innerContent,
        movePath: movePath
      };
    } // 전체 컨텐츠 보기

  }, {
    key: "setViewContents",
    value: function setViewContents() {
      var _this3 = this;

      var viewAllContent = document.querySelector('.contents_all');
      viewAllContent.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this3.indexBoard.classList.add('yoil_display-hide');

        _this3.allBtn.classList.remove('yoil_display-hide');

        _this3.allView = true;
      });
    }
  }, {
    key: "checkOpenAllContents",
    value: function checkOpenAllContents() {
      if (window['testMode'] === true) {
        return;
      }

      var boxContents = document.querySelectorAll('.box_contents');
      var books = this.infoObj.getUserBooks();
      books.forEach(function (data) {
        var targetBoxContent = boxContents[data.vol - 1];
        var targetBooks = targetBoxContent.querySelectorAll('.box_content');
        var targetBook = targetBooks[data.number - 1];
        targetBook.classList.remove('yoil_button-disable');
      });
    } // main 화면으로 이동

  }, {
    key: "setContentExit",
    value: function setContentExit() {
      var _this4 = this;

      var exitBtn = document.querySelector('.top_exit');
      exitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        if (_this4.allView === true) {
          _this4.allBtn.classList.add('yoil_display-hide');

          _this4.indexBoard.classList.remove('yoil_display-hide');

          _this4.allView = false;
          return;
        }

        var router = router_1["default"].getInstance();
        var infoObj = program_info_1.ProgramInfo.getInstance();
        router.moveContent(infoObj.getBackUrl());
      });
    }
  }, {
    key: "destory",
    value: function destory() {}
  }]);
  return ContentsIndex;
}();

exports.ContentsIndex = ContentsIndex;

},{"../common/pc-mobile":31,"../info/data-interface":65,"../info/program-info":66,"../router/router":71,"./contents-common/main-side-section":41,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],44:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWftaCharacter = void 0;

var pc_mobile_1 = require("../../../common/pc-mobile");

var util_1 = require("../../../common/util/util");

var get_data_1 = require("../../../data/get-data");

var program_info_1 = require("../../../info/program-info");

var router_1 = require("../../../router/router");

var CharacterSong_1 = require("./character-song/CharacterSong");

var ContentWftaCharacter = /*#__PURE__*/function () {
  function ContentWftaCharacter() {
    (0, _classCallCheck2["default"])(this, ContentWftaCharacter);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
    this.cardTotalLst = [];
  }

  (0, _createClass2["default"])(ContentWftaCharacter, [{
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var dataInfo, charData;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataInfo = new get_data_1.BookData();
                _context.next = 3;
                return dataInfo.getNormalContentData('./json/wfta/character/wfta-character.json');

              case 3:
                charData = _context.sent;
                this.bookNumber = this.infoObj.getBookNumber();
                this.innerContent = this.infoObj.getContentInnerNumber();
                this.cardTotalLst = charData["book".concat(this.bookNumber)]["S".concat(this.innerContent)];
                this.characterSong = new CharacterSong_1.ContentSong();
                this.characterSong.init();
                this.contentCard = document.querySelector('.content_card');
                this.contentClip = document.querySelector('.content_clip');
                this.contentSong = document.querySelector('.content_song');
                this.currentStage = 0
                /* STAGE_TYPE.CARD_VIEW */
                ;
                this.backDataCheck();
                this.putCardViewData();
                this.setExitBtn();

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    } // 비디오로 갔다가 되돌아 올 때 화면 처리를 위해서 작성

  }, {
    key: "backDataCheck",
    value: function backDataCheck() {
      var backData = this.infoObj.getContentBackData();
      console.log('backData', backData);

      if (backData) {
        this.putSelectCardData(backData);
        this.turnStage(1
        /* STAGE_TYPE.SELECT_VIEW */
        );
      } else {
        this.userSelectNum = null;
        this.turnStage(0
        /* STAGE_TYPE.CARD_VIEW */
        );
      }
    } // 화면 전환

  }, {
    key: "turnStage",
    value: function turnStage(stageType) {
      this.contentCard.classList.remove('active');
      this.contentClip.classList.remove('active');
      this.contentSong.classList.remove('active');

      switch (stageType) {
        case 0
        /* STAGE_TYPE.CARD_VIEW */
        :
          this.contentCard.classList.add('active');
          break;

        case 1
        /* STAGE_TYPE.SELECT_VIEW */
        :
          this.contentClip.classList.add('active');
          break;

        case 2
        /* STAGE_TYPE.SONG_VIEW */
        :
          this.contentSong.classList.add('active');
          break;
      }

      this.currentStage = stageType;
    } // 첫 화면

  }, {
    key: "putCardViewData",
    value: function putCardViewData() {
      var _this = this;

      var charCards = document.querySelectorAll('.card_cha');
      charCards.forEach(function (cardEl, value) {
        cardEl.style.backgroundImage = "url(".concat(_this.getCardImgPath(value), ")");
        cardEl.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          _this.userSelectNum = value + 1;

          _this.infoObj.setContentBackData(_this.userSelectNum);

          _this.putSelectCardData(_this.userSelectNum);

          _this.turnStage(1
          /* STAGE_TYPE.SELECT_VIEW */
          );
        });
      });
    }
  }, {
    key: "getCardImgPath",
    value: function getCardImgPath(value) {
      return "".concat(this.getImgPath(), "/cha_").concat((0, util_1.get10Check)(value + 1), ".png");
    }
  }, {
    key: "getImgPath",
    value: function getImgPath() {
      var bookNum = (0, util_1.get10Check)(this.bookNumber);
      return "./images/wfta/character/".concat(bookNum, "/S").concat(this.innerContent);
    } // 카드 선택 후 두번째 화면

  }, {
    key: "putSelectCardData",
    value: function putSelectCardData(selectNum) {
      this.userSelectNum = selectNum;
      var cardStr = (0, util_1.get10Check)(selectNum);
      var clipCard = document.querySelector('.clip_card');
      var selectImg = "".concat(this.getImgPath(), "/cha_").concat(cardStr, ".png");
      clipCard.style.backgroundImage = "url(".concat(selectImg, ")");
      var clipsEl = document.querySelector('.clip_videos');
      this.removeAllClipCard(clipsEl);
      var totalNum = this.cardTotalLst[selectNum - 1];
      this.addCardClip({
        totalNum: totalNum,
        cardStr: cardStr,
        clipsEl: clipsEl
      });
      this.replaceSong(clipCard);
    } // 모든 비디오 클립 삭제

  }, {
    key: "removeAllClipCard",
    value: function removeAllClipCard(clipsEl) {
      var videosImgs = document.querySelectorAll('.videos_img');

      if (videosImgs) {
        videosImgs.forEach(function (el) {
          clipsEl.removeChild(el);
        });
      }
    } // 새로운 비디오 클립 삽입

  }, {
    key: "addCardClip",
    value: function addCardClip(_ref) {
      var _this2 = this;

      var totalNum = _ref.totalNum,
          cardStr = _ref.cardStr,
          clipsEl = _ref.clipsEl;

      var _loop = function _loop(imgNum) {
        var clipImgDiv = _this2.getVideoClipDiv({
          cardStr: cardStr,
          imgNum: imgNum
        });

        clipsEl.appendChild(clipImgDiv);
        clipImgDiv.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          var router = router_1["default"].getInstance();
          var movePath = "wfta/".concat(_this2.bookNumber, "/").concat(_this2.innerContent, "/character/video");

          _this2.infoObj.setVideoUrl(_this2.getVideoUrl(imgNum));

          router.moveContent(movePath);
        });
      };

      for (var imgNum = 1; imgNum <= totalNum; imgNum++) {
        _loop(imgNum);
      }
    } // 새로운 비디오 클립 생성

  }, {
    key: "getVideoClipDiv",
    value: function getVideoClipDiv(_ref2) {
      var cardStr = _ref2.cardStr,
          imgNum = _ref2.imgNum;
      var imgPath = "".concat(this.getImgPath(), "/").concat(cardStr, "/cha_").concat(cardStr, "_0").concat(imgNum, ".png");
      var clip = document.createElement('div');
      clip.classList.add('videos_img');
      clip.style.backgroundImage = "url(".concat(imgPath, ")");
      return clip;
    }
  }, {
    key: "getVideoUrl",
    value: function getVideoUrl(videoNum) {
      var book = (0, util_1.get10Check)(this.bookNumber);
      var content = "S".concat(this.innerContent);
      return "./video/wfta/".concat(book, "/").concat(content, "/character").concat(this.infoObj.getContentBackData(), "/character-").concat(videoNum, ".mp4");
    }
  }, {
    key: "replaceSong",
    value: function replaceSong(parentEl) {
      var _this3 = this;

      var songBtn = document.querySelector('.card_audio');
      parentEl.removeChild(songBtn);
      var newSongBtn = document.createElement('div');
      newSongBtn.className = 'card_audio';
      parentEl.appendChild(newSongBtn);
      newSongBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        console.log('this.userSelectNum', _this3.userSelectNum);

        _this3.characterSong.selectCharcter(_this3.userSelectNum);

        _this3.turnStage(2
        /* STAGE_TYPE.SONG_VIEW */
        );
      });
    }
  }, {
    key: "setExitBtn",
    value: function setExitBtn() {
      var _this4 = this;

      var exitBtn = document.querySelector('.top_exit');
      exitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        switch (_this4.currentStage) {
          case 0
          /* STAGE_TYPE.CARD_VIEW */
          :
            var router = router_1["default"].getInstance();
            var infoObj = program_info_1.ProgramInfo.getInstance();

            _this4.infoObj.setContentBackData(null);

            router.moveContent(infoObj.getBackUrl());
            break;

          case 1
          /* STAGE_TYPE.SELECT_VIEW */
          :
            _this4.turnStage(0
            /* STAGE_TYPE.CARD_VIEW */
            );

            break;

          case 2
          /* STAGE_TYPE.SONG_VIEW */
          :
            _this4.characterSong.reset();

            _this4.turnStage(1
            /* STAGE_TYPE.SELECT_VIEW */
            );

            break;
        }
      });
    }
  }, {
    key: "destory",
    value: function destory() {}
  }]);
  return ContentWftaCharacter;
}();

exports.ContentWftaCharacter = ContentWftaCharacter;

},{"../../../common/pc-mobile":31,"../../../common/util/util":32,"../../../data/get-data":62,"../../../info/program-info":66,"../../../router/router":71,"./character-song/CharacterSong":45,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/regenerator":22}],45:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentSong = void 0;

var sound_player_viewer_1 = require("../../../../common/media/sound/sound-player-viewer");

var pc_mobile_1 = require("../../../../common/pc-mobile");

var util_1 = require("../../../../common/util/util");

var get_data_1 = require("../../../../data/get-data");

var program_info_1 = require("../../../../info/program-info");

var ContentSong = /*#__PURE__*/function () {
  function ContentSong() {
    (0, _classCallCheck2["default"])(this, ContentSong);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
    this.bookNumber = this.infoObj.getBookNumber();
    this.innerContent = this.infoObj.getContentInnerNumber();
    this.player = new sound_player_viewer_1.YoilSoundPlayerViewer();
    this.player.init();
    this.player.addTag('div', 'player_mr');
    this.setMrBtn();
  }

  (0, _createClass2["default"])(ContentSong, [{
    key: "setMrBtn",
    value: function setMrBtn() {
      var _this = this;

      var mrBtn = document.querySelector('.player_mr');
      mrBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        var mrArBool;

        if (mrBtn.classList.contains('active')) {
          mrBtn.classList.remove('active');
          mrArBool = false;
        } else {
          mrBtn.classList.add('active');
          mrArBool = true;
        }

        _this.player.setSound(_this.getSoundPath(_this.soundNum, _this.bookNumber, _this.innerContent, mrArBool));
      });
    }
  }, {
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var dataInfo;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataInfo = new get_data_1.BookData();
                _context.next = 3;
                return dataInfo.getNormalContentData('./json/wfta/character/song/wfta-character-song.json');

              case 3:
                this.songData = _context.sent;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "selectCharcter",
    value: function selectCharcter(charNum) {
      var _this2 = this;

      this.charNum = charNum;
      var targetData = this.getTargetData();
      var text = targetData.text,
          sound = targetData.sound;
      this.soundNum = sound;
      var textBoardData = document.querySelector('.textBoard_data');
      this.removeAllLineData(textBoardData);
      text.forEach(function (dataStr, value) {
        if (value === 0) {
          _this2.inputTitle(dataStr);
        } else {
          var dataDiv = _this2.getLineText(dataStr);

          textBoardData.appendChild(dataDiv);
        }
      });
      var sndPath = this.getSoundPath(sound, this.bookNumber, this.innerContent);
      this.player.setSound(sndPath);
    }
  }, {
    key: "getTargetData",
    value: function getTargetData() {
      return this.songData["book".concat(this.bookNumber)]["S".concat(this.innerContent)]["ch".concat(this.charNum)];
    }
  }, {
    key: "removeAllLineData",
    value: function removeAllLineData(textBoardData) {
      var lineDatas = document.querySelectorAll('.data_line');
      lineDatas.forEach(function (target) {
        textBoardData.removeChild(target);
      });
    }
  }, {
    key: "inputTitle",
    value: function inputTitle(titleStr) {
      var titleDiv = document.querySelector('.textBoard_title');
      titleDiv.innerHTML = titleStr;
    }
  }, {
    key: "getLineText",
    value: function getLineText(txt) {
      var dataLine = document.createElement('div');
      dataLine.className = 'data_line';
      var lineText = document.createElement('div');
      lineText.className = 'line_text';
      lineText.innerText = txt;
      var lineBottom = document.createElement('div');
      lineBottom.className = 'line_bottom';
      dataLine.appendChild(lineText);
      dataLine.appendChild(lineBottom);
      return dataLine;
    }
  }, {
    key: "getSoundPath",
    value: function getSoundPath(sound, bookNumber, innerNumber) {
      var mr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var soundNum = sound;
      soundNum = mr ? soundNum + 1 : soundNum;
      return "./sound/wfta/audio/".concat((0, util_1.get10Check)(bookNumber), "/S").concat(innerNumber, "/audio").concat((0, util_1.get10Check)(soundNum), ".mp3");
    }
  }, {
    key: "reset",
    value: function reset() {
      this.player.setSound('');
      var mrBtn = document.querySelector('.player_mr');
      mrBtn.classList.remove('active');
    }
  }]);
  return ContentSong;
}();

exports.ContentSong = ContentSong;

},{"../../../../common/media/sound/sound-player-viewer":28,"../../../../common/pc-mobile":31,"../../../../common/util/util":32,"../../../../data/get-data":62,"../../../../info/program-info":66,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/regenerator":22}],46:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWftaDictionary = void 0;

var video_player_1 = require("../../../common/media/video/video-player");

var pc_mobile_1 = require("../../../common/pc-mobile");

var util_1 = require("../../../common/util/util");

var get_data_1 = require("../../../data/get-data");

var program_info_1 = require("../../../info/program-info");

var router_1 = require("../../../router/router");

var ContentWftaDictionary = /*#__PURE__*/function () {
  function ContentWftaDictionary() {
    (0, _classCallCheck2["default"])(this, ContentWftaDictionary);
    this.currentPage = 0;
    this.infoData = program_info_1.ProgramInfo.getInstance();
  }

  (0, _createClass2["default"])(ContentWftaDictionary, [{
    key: "init",
    value: function init() {
      this.videoPlayer = new video_player_1.YoilVideoPlayer();
      this.videoPlayer.init({
        width: 600,
        height: 400,
        controlBool: false
      });
      this.videoPlayer.getVideoViewer().loop = false;
      this.getData();
      this.setNextPrev();
      this.setVideoPlayBtn();
      this.setExitBtn();
    }
  }, {
    key: "getData",
    value: function getData() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var dataInfo;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataInfo = new get_data_1.BookData();
                _context.next = 3;
                return dataInfo.getNormalContentData('./json/wfta/dictionary/wfta-dictionary.json');

              case 3:
                this.dicData = _context.sent;
                this.bookNumber = this.infoData.getBookNumber();
                this.innerContent = this.infoData.getContentInnerNumber();
                this.dicWords = this.dicData["book".concat(this.bookNumber)]["S".concat(this.innerContent)];
                this.totalPage = this.dicWords.length - 1;
                this.putData();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "putData",
    value: function putData() {
      var panelImg = document.querySelector('.panel_img');
      panelImg.style.backgroundImage = this.getImagePath();
      var textDiv = document.querySelector('.panel_text');
      var stringData = this.dicWords[this.currentPage];
      textDiv.classList.remove('text-small');
      textDiv.classList.remove('text-small2');

      if (stringData.length >= 12) {
        textDiv.classList.add('text-small');
      } else if (stringData.length >= 7) {
        textDiv.classList.add('text-small2');
      }

      textDiv.innerText = stringData;
      this.putVideo();
    }
  }, {
    key: "getImagePath",
    value: function getImagePath() {
      return "url(\"./images/wfta/dictionary/".concat((0, util_1.get10Check)(this.bookNumber), "/S").concat(this.innerContent, "/img_").concat((0, util_1.get10Check)(this.currentPage + 1), ".jpg\")");
    }
  }, {
    key: "setNextPrev",
    value: function setNextPrev() {
      var _this = this;

      var prevBtn = document.querySelector('.board_left');
      var nextBtn = document.querySelector('.board_right');
      [prevBtn, nextBtn].forEach(function (btn, direction) {
        btn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          if (direction === 0) {
            _this.currentPage--;
          } else {
            _this.currentPage++;
          }

          if (_this.currentPage <= 0) {
            // 첫 페이지
            _this.currentPage = 0;
            prevBtn.classList.add('yoil_display-alpha-hide');
          } else if (_this.currentPage >= _this.totalPage) {
            nextBtn.classList.add('yoil_display-alpha-hide');
            _this.currentPage = _this.totalPage;
          } else {
            prevBtn.classList.remove('yoil_display-alpha-hide');
            nextBtn.classList.remove('yoil_display-alpha-hide');
          }

          _this.putData();
        });
      });
    }
  }, {
    key: "putVideo",
    value: function putVideo() {
      this.videoPlayer.changeVideo("./video/wfta/dictionary/".concat((0, util_1.get10Check)(this.bookNumber), "/S").concat(this.innerContent, "/movie (").concat(this.currentPage, ").mp4"));
      this.videoPlayer.getVideoViewer().play();
    }
  }, {
    key: "setVideoPlayBtn",
    value: function setVideoPlayBtn() {
      var _this2 = this;

      var playBtn = document.querySelector('.video_play');
      playBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this2.videoPlayer.getVideoViewer().play();
      });
    }
  }, {
    key: "setExitBtn",
    value: function setExitBtn() {
      var exitBtn = document.querySelector('.top_exit');
      exitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        var router = router_1["default"].getInstance();
        var infoObj = program_info_1.ProgramInfo.getInstance();
        router.moveContent(infoObj.getBackUrl());
      });
    }
  }, {
    key: "destory",
    value: function destory() {}
  }]);
  return ContentWftaDictionary;
}();

exports.ContentWftaDictionary = ContentWftaDictionary;

},{"../../../common/media/video/video-player":30,"../../../common/pc-mobile":31,"../../../common/util/util":32,"../../../data/get-data":62,"../../../info/program-info":66,"../../../router/router":71,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/regenerator":22}],47:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWftaMap = void 0;

var pc_mobile_1 = require("../../../common/pc-mobile");

var get_data_1 = require("../../../data/get-data");

var program_info_1 = require("../../../info/program-info");

var router_1 = require("../../../router/router");

var ContentMapLocal_1 = require("./local/ContentMapLocal");

var MapLocalView_1 = require("./local/MapLocalView");

var ContentWftaMap = /*#__PURE__*/function () {
  function ContentWftaMap() {
    (0, _classCallCheck2["default"])(this, ContentWftaMap);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
  }

  (0, _createClass2["default"])(ContentWftaMap, [{
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var dataInfo, place, contentData;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataInfo = new get_data_1.BookData();
                _context.next = 3;
                return dataInfo.getNormalContentData(dataInfo.getJsonPathUrl());

              case 3:
                this.currentData = _context.sent;
                this.contentNum = this.infoObj.getContentInnerNumber();
                place = this.currentData.place;
                this.targetData = this.currentData["S".concat(this.infoObj.getContentInnerNumber())];
                contentData = {
                  totalData: this.currentData,
                  bookNum: this.infoObj.getBookNumber(),
                  contentNum: this.infoObj.getContentInnerNumber()
                };
                this.wordMap = document.querySelector('.contents_worldMap');
                this.localObject = new ContentMapLocal_1.ContentMapLocal(contentData);
                this.localObject.init();
                this.setTitle();
                this.setBackground();
                this.setCircle();
                this.setExitBtn();

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setTitle",
    value: function setTitle() {
      var title = document.querySelector('.top_title');
      title.innerHTML = this.infoObj.getBookTitle();
    }
  }, {
    key: "setBackground",
    value: function setBackground() {
      this.wordMap.classList.add("S".concat(this.contentNum));
    }
  }, {
    key: "setCircle",
    value: function setCircle() {
      var _this = this;

      var world = this.targetData.world;
      var circle = document.querySelector('.worldMap_circle');
      circle.style.top = "".concat(world.y - 40, "px");
      circle.style.left = "".concat(world.x - 40, "px");
      circle.style.display = 'inline-block';
      circle.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        var localMap = document.querySelector('.contents_local');
        _this.wordMap.style.display = 'none';
        localMap.style.display = 'block';
      });
    }
  }, {
    key: "setExitBtn",
    value: function setExitBtn() {
      var exitBtn = document.querySelector('.top_exit');
      exitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        (0, MapLocalView_1.localSoundStop)();
        var router = router_1["default"].getInstance();
        var infoObj = program_info_1.ProgramInfo.getInstance();
        router.moveContent(infoObj.getBackUrl());
      });
    }
  }, {
    key: "destory",
    value: function destory() {}
  }]);
  return ContentWftaMap;
}();

exports.ContentWftaMap = ContentWftaMap;

},{"../../../common/pc-mobile":31,"../../../data/get-data":62,"../../../info/program-info":66,"../../../router/router":71,"./local/ContentMapLocal":48,"./local/MapLocalView":50,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/regenerator":22}],48:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentMapLocal = void 0;

var util_1 = require("../../../../common/util/util");

var MapLocalBottom_1 = require("./MapLocalBottom");

var MapLocalView_1 = require("./MapLocalView");

var ContentMapLocal = /*#__PURE__*/function () {
  function ContentMapLocal(contentData) {
    (0, _classCallCheck2["default"])(this, ContentMapLocal);
    this.contentData = contentData;
    this.totalData = contentData.totalData;
    this.bookPath = (0, util_1.get10Check)(contentData.bookNum);
    this.contentNum = contentData.contentNum;
    this.contentPath = "S".concat(this.contentNum);
  }

  (0, _createClass2["default"])(ContentMapLocal, [{
    key: "init",
    value: function init() {
      this.bottomArea = new MapLocalBottom_1.MapLocalBottom(this.contentData);
      this.bottomArea.init();
      (0, MapLocalView_1["default"])(this.contentData);
      this.setBackground();
    }
  }, {
    key: "setBackground",
    value: function setBackground() {
      var local = document.querySelector('.contents_local');
      local.style.backgroundImage = "url(\"./images/wfta/map/".concat(this.bookPath, "/").concat(this.contentPath, "/map_story0").concat(this.contentNum, ".png\")");
    }
  }]);
  return ContentMapLocal;
}();

exports.ContentMapLocal = ContentMapLocal;

},{"../../../../common/util/util":32,"./MapLocalBottom":49,"./MapLocalView":50,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],49:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapLocalBottom = void 0;

var pc_mobile_1 = require("../../../../common/pc-mobile");

var MapLocalBottom = /*#__PURE__*/function () {
  function MapLocalBottom(contentData) {
    (0, _classCallCheck2["default"])(this, MapLocalBottom);
    this.contentData = contentData;
    this.ACTIVE = 'active';
    this.totalData = contentData.totalData;
    this.contentPath = "S".concat(contentData.contentNum);
    this.boardText = document.querySelector('.board_text');
  }

  (0, _createClass2["default"])(MapLocalBottom, [{
    key: "init",
    value: function init() {
      this.setBottomBoard();
      this.setBoardExit();
    }
  }, {
    key: "setBottomBoard",
    value: function setBottomBoard() {
      var _this = this;

      var boardBtns = document.querySelectorAll('.text_area');
      boardBtns.forEach(function (btn, value) {
        btn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          _this.setBottomIconsHide();

          _this.setTextContent(value);

          btn.parentElement.classList.add(_this.ACTIVE);
        });
      });
    }
  }, {
    key: "setBottomIconsHide",
    value: function setBottomIconsHide() {
      var _this2 = this;

      var btns = document.querySelectorAll('.btns_text');
      btns.forEach(function (target) {
        target.classList.remove(_this2.ACTIVE);
      });
    }
  }, {
    key: "setTextContent",
    value: function setTextContent(value) {
      var targetData = this.totalData[this.contentPath];
      var targetHtmlTxt;

      switch (value) {
        case 0
        /* BottomType.PLACE */
        :
          targetHtmlTxt = this.totalData['place'];
          break;

        case 1
        /* BottomType.THEME */
        :
          targetHtmlTxt = targetData['theme'];
          break;

        case 2
        /* BottomType.STORY */
        :
          targetHtmlTxt = targetData['story'];
          break;
      }

      var textBoard = document.querySelector('.text_content');
      textBoard.innerHTML = targetHtmlTxt;
      this.fontCheck(textBoard);
      this.boardText.classList.add(this.ACTIVE);
    }
  }, {
    key: "fontCheck",
    value: function fontCheck(textBoard) {
      if (this.contentData.bookNum === 11 && this.contentData.contentNum === 2) {
        textBoard.classList.add('font29');
      }

      if (this.contentData.bookNum === 11 && this.contentData.contentNum === 3) {
        textBoard.classList.add('font31');
      }
    }
  }, {
    key: "setBoardExit",
    value: function setBoardExit() {
      var _this3 = this;

      var textClose = document.querySelector('.text_close');
      textClose.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this3.boardText.classList.remove(_this3.ACTIVE);

        _this3.setBottomIconsHide();
      });
    }
  }]);
  return MapLocalBottom;
}();

exports.MapLocalBottom = MapLocalBottom;

},{"../../../../common/pc-mobile":31,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localSoundStop = void 0;

var sound_player_1 = require("../../../../common/media/sound/sound-player");

var pc_mobile_1 = require("../../../../common/pc-mobile");

var util_1 = require("../../../../common/util/util");

var allData = null;
var soundPlayer = new sound_player_1.YoilSoundPlayer(); // 모든 보드 숨김

var hideAllBoard = function hideAllBoard() {
  var boards = document.querySelectorAll('.view_board ');
  boards.forEach(function (el) {
    el.classList.remove('active');
  });
}; // div 생성


var createDivBox = function createDivBox(clickBox) {
  var clickDiv = document.createElement('div');
  clickDiv.style.width = "".concat(clickBox.width, "px");
  clickDiv.style.height = "".concat(clickBox.height, "px");
  clickDiv.style.top = "".concat(clickBox.y, "px");
  clickDiv.style.left = "".concat(clickBox.x, "px");
  return clickDiv;
}; // 클릭 영역 생성


var getClickBox = function getClickBox(boxData, count) {
  var clickBox = boxData['click'];
  var clickDiv = createDivBox(clickBox);
  var bookStr = (0, util_1.get10Check)(allData.bookNum);
  clickDiv.className = 'view_click';
  clickDiv.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
    hideAllBoard();
    var targetBoard = document.querySelector(".board".concat(count));
    targetBoard.classList.add('active');
    soundPlayer.soundPlay("./sound/wfta/map/".concat(bookStr, "/image").concat(count, ".mp3"));
  });
  return clickDiv;
};

var getBoardData = function getBoardData(boardBox, count, seasonNum) {
  if (boardBox.number) {
    return boardBox;
  } else {
    var local = getSeasonLocal(seasonNum - 1);
    var changeBoxData = local["textBox".concat(count)]['board'];
    return getBoardData(changeBoxData, count, seasonNum - 1);
  }
}; // 화면에 보일 영역 생성


var getBoardBox = function getBoardBox(boxData, count) {
  var boardBox = boxData['board'];
  console.log('boardBox', boardBox);
  var viewBoardDiv = document.createElement('div');
  viewBoardDiv.className = 'view_board';
  viewBoardDiv.style.top = "".concat(boardBox.y, "px");
  viewBoardDiv.style.left = "".concat(boardBox.x, "px");
  boardBox = getBoardData(boardBox, count, allData.contentNum);
  viewBoardDiv.classList.add("box".concat(boardBox.number));
  viewBoardDiv.classList.add("board".concat(count));
  var contentDiv = "\n    <div class = \"board_content\">\n        <div class = \"content_title\">\n            <div class = \"title_icon\"></div>\n            <div class = \"title_text\"></div>\n        </div>\n        <div class = \"content_text\"></div>\n    </div>\n    ";
  viewBoardDiv.innerHTML = contentDiv;
  var titleText = viewBoardDiv.querySelector('.title_text');
  titleText.innerHTML = boardBox.title;
  var contentText = viewBoardDiv.querySelector('.content_text');
  contentText.innerHTML = boardBox.text;
  return viewBoardDiv;
}; // 가운데 글자 선택 박스 생성


var getCenterBox = function getCenterBox(contentData, season) {
  var center = contentData.totalData[season].center;

  if (!center) {
    return;
  }

  var centerBox = createDivBox(center);
  centerBox.className = 'view_center';
  centerBox.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
    var bookStr = (0, util_1.get10Check)(allData.bookNum);
    soundPlayer.soundPlay("./sound/wfta/map/".concat(bookStr, "/name0.mp3"));
  });
  return centerBox;
};

var getSeasonLocal = function getSeasonLocal(seasonNumber) {
  var season = "S".concat(seasonNumber);
  var local = allData.totalData[season].local;
  return local;
};

var localSoundStop = function localSoundStop() {
  soundPlayer.soundStop();
};

exports.localSoundStop = localSoundStop;

var LocalView = function LocalView(contentData) {
  allData = contentData;
  var season = "S".concat(contentData.contentNum);
  var local = getSeasonLocal(contentData.contentNum);
  var count = 1;
  var localView = document.querySelector('.local_view');

  for (var boxName in local) {
    var boxData = local[boxName];
    var clickDiv = getClickBox(boxData, count);
    var boardDiv = getBoardBox(boxData, count);
    localView.appendChild(clickDiv);
    localView.appendChild(boardDiv);
    count++;
  }

  var centerDiv = getCenterBox(contentData, season);

  if (centerDiv) {
    localView.appendChild(centerDiv);
  }
};

exports["default"] = LocalView;

},{"../../../../common/media/sound/sound-player":29,"../../../../common/pc-mobile":31,"../../../../common/util/util":32}],51:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWftaPhonics = void 0;

var video_player_1 = require("../../../common/media/video/video-player");

var pc_mobile_1 = require("../../../common/pc-mobile");

var util_1 = require("../../../common/util/util");

var get_data_1 = require("../../../data/get-data");

var program_info_1 = require("../../../info/program-info");

var router_1 = require("../../../router/router");

var ContentWftaPhonics = /*#__PURE__*/function () {
  function ContentWftaPhonics() {
    (0, _classCallCheck2["default"])(this, ContentWftaPhonics);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
  }

  (0, _createClass2["default"])(ContentWftaPhonics, [{
    key: "init",
    value: function init() {
      this.videoPlayer = new video_player_1.YoilVideoPlayer();
      this.videoPlayer.init({
        width: 822,
        height: 522,
        controlBool: false
      });
      this.inputAlphabet();
      this.setAlphabet();
      this.setExitBtn();
    }
  }, {
    key: "inputAlphabet",
    value: function inputAlphabet() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var dataInfo, counter, plusNum, plusDiv;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataInfo = new get_data_1.BookData();
                _context.next = 3;
                return dataInfo.getNormalContentData('./json/wfta/phonics/wfta-phonics.json');

              case 3:
                this.phonicsData = _context.sent;
                this.bookNum = this.infoObj.getBookNumber();
                this.contentNum = this.infoObj.getContentInnerNumber();
                counter = this.phonicsData["book".concat(this.bookNum)]["S".concat(this.contentNum)];

                for (plusNum = 1; plusNum <= counter; plusNum++) {
                  plusDiv = document.querySelector(".plus_".concat(plusNum));
                  plusDiv.style.backgroundImage = "url(\"./images/wfta/phonics/".concat((0, util_1.get10Check)(this.bookNum), "/S").concat(this.contentNum, "/btn_").concat(26 + plusNum, ".png\")");
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setAlphabet",
    value: function setAlphabet() {
      var _this = this;

      var alphabets = Array.from(document.querySelectorAll("div[class^='img'"));
      var allBtn = document.querySelector('.alphabet-all');
      var plusBtns = document.querySelectorAll("div[class^='plus_']");
      var allBtns = [].concat((0, _toConsumableArray2["default"])(alphabets), [allBtn], (0, _toConsumableArray2["default"])(plusBtns));
      allBtns.forEach(function (btn, index) {
        btn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          var selectDiv = document.querySelector('.select');

          if (selectDiv) {
            selectDiv.classList.remove('select');
          }

          btn.classList.add('select');
          var videoPath = "./video/wfta/phonics/".concat(_this.getVideoPath(index), ".mp4");

          _this.videoPlayer.changeVideo(videoPath);

          var videoViewer = _this.videoPlayer.getVideoViewer();

          videoViewer.play();
        });
      });
    }
  }, {
    key: "getVideoPath",
    value: function getVideoPath(index) {
      var videoPath = '';

      if (index >= 27) {
        videoPath += "".concat((0, util_1.get10Check)(this.bookNum), "/S").concat(this.contentNum, "/txt").concat(index - 27);
        console.log('index', index);
      } else {
        if (this.contentNum === 1) {
          videoPath += 'common/S1/';
        } else {
          videoPath += 'common/S2S3/';
        }

        if (index === 26) {
          videoPath += 'all';
        } else {
          var videoName = String.fromCharCode(97 + index);
          videoPath += videoName;
        }
      }

      return videoPath;
    }
  }, {
    key: "setExitBtn",
    value: function setExitBtn() {
      var exitBtn = document.querySelector('.top_exit');
      exitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        var router = router_1["default"].getInstance();
        var infoObj = program_info_1.ProgramInfo.getInstance();
        router.moveContent(infoObj.getBackUrl());
      });
    }
  }, {
    key: "destory",
    value: function destory() {// throw new Error('Method not implemented.');
    }
  }]);
  return ContentWftaPhonics;
}();

exports.ContentWftaPhonics = ContentWftaPhonics;

},{"../../../common/media/video/video-player":30,"../../../common/pc-mobile":31,"../../../common/util/util":32,"../../../data/get-data":62,"../../../info/program-info":66,"../../../router/router":71,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/toConsumableArray":19,"@babel/runtime/regenerator":22}],52:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWftaMain = void 0;

var pc_mobile_1 = require("../../common/pc-mobile");

var util_1 = require("../../common/util/util");

var info_routerPath_1 = require("../../router/info-routerPath");

var program_info_1 = require("../../info/program-info");

var router_1 = require("../../router/router");

var ContentWftaMain = /*#__PURE__*/function () {
  function ContentWftaMain() {
    (0, _classCallCheck2["default"])(this, ContentWftaMain);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
    this.router = router_1["default"].getInstance();
  }

  (0, _createClass2["default"])(ContentWftaMain, [{
    key: "init",
    value: function init() {
      this.setBackImg();
      this.setExitBtn();
    }
  }, {
    key: "setBackImg",
    value: function setBackImg() {
      var _this = this;

      var btnLst = ['.center_animation', '.center_ebook', '.other_mv', '.other_act', '.bottom_map', '.bottom_character', '.bottom_phonics', '.bottom_dictionary', '.other_sound' // '.bottom_nextbook',
      ];
      btnLst.forEach(function (docStr, key) {
        var targetDoc = document.querySelector(docStr);

        if (docStr === '.other_sound') {// 오디오 예외 적용
        } else {
          targetDoc.innerHTML = _this.getImgHtml(key + 1);
        }

        targetDoc.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          var contentName = targetDoc.getAttribute('value');
          var router = router_1["default"].getInstance();

          var paramLst = _this.infoObj.getParam();

          _this.infoObj.setCurrentContent(contentName);

          _this.infoObj.setVideoUrl(_this.getVideoUrl());

          router.moveContent("wfta/".concat(paramLst[1], "/").concat(paramLst[2], "/").concat(contentName));
        });
      });
    } // 각 버튼에 이미지 삽입

  }, {
    key: "getImgHtml",
    value: function getImgHtml(key) {
      var numStr = (0, util_1.get10Check)(this.infoObj.getBookNumber());
      var contentInnerNumber = this.infoObj.getContentInnerNumber();
      var imgHtml = "<img src=\"./images/wfta/main/".concat(numStr, "/S").concat(contentInnerNumber, "/btn_0").concat(key, ".png\"/>");
      return imgHtml;
    }
  }, {
    key: "getVideoUrl",
    value: function getVideoUrl() {
      var bookNum = this.infoObj.getBookNumber();
      var section = this.infoObj.getContentInnerNumber();
      var content = this.infoObj.getCurrentContent();

      switch (content) {
        case 'animation':
          content = 'animation';
          break;

        case 'mv':
          content = content + '_AR';
          break;
      }

      return "./video/wfta/".concat((0, util_1.get10Check)(bookNum), "/S").concat(section, "/").concat(content, ".mp4");
    }
  }, {
    key: "setExitBtn",
    value: function setExitBtn() {
      var _this2 = this;

      var exitBtn = document.querySelector('.top_exit');
      exitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        console.log('exit');

        _this2.router.moveContent(info_routerPath_1.wftaRouterPath.wfta + '?first=false');
      });
    }
  }, {
    key: "destory",
    value: function destory() {}
  }]);
  return ContentWftaMain;
}();

exports.ContentWftaMain = ContentWftaMain;

},{"../../common/pc-mobile":31,"../../common/util/util":32,"../../info/program-info":66,"../../router/info-routerPath":67,"../../router/router":71,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],53:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BwWordList = void 0;

var css_name_1 = require("../../../common/css-name");

var pc_mobile_1 = require("../../../common/pc-mobile");

var BwWordList = /*#__PURE__*/function () {
  function BwWordList(wordData) {
    (0, _classCallCheck2["default"])(this, BwWordList);
    this.wordList = wordData.word;
  }

  (0, _createClass2["default"])(BwWordList, [{
    key: "init",
    value: function init() {
      this.wordListBtn = document.querySelector('.list_btn');
      this.listBoard = document.querySelector('.list_board');
      this.boardWords = document.querySelector('.board_words');
      var boardExit = document.querySelector('.board_exit');
      boardExit.addEventListener(pc_mobile_1.StaticData.CLICK, function () {});
      this.inputWords();
      this.setBtns();
      this.setBoard();
    }
  }, {
    key: "inputWords",
    value: function inputWords() {
      var _this = this;

      if (this.wordList.length <= 4) {
        this.boardWords.style.overflowY = 'hidden';
      }

      this.wordList.forEach(function (word, value) {
        var divWord = document.createElement('div');
        divWord.textContent = word;
        divWord.classList.add('words_' + value);
        divWord.addEventListener(pc_mobile_1.StaticData.CLICK, _this.wordClick);

        _this.boardWords.appendChild(divWord);
      });
      this.boardWords.scrollTop = 0;
    }
  }, {
    key: "wordClick",
    value: function wordClick(e) {
      var clkDiv = e.target;
      var wordNum = parseInt(clkDiv.classList[0].split('_')[1]);
      dispatchEvent(new CustomEvent('wordChange', {
        detail: wordNum
      }));
    }
  }, {
    key: "setBtns",
    value: function setBtns() {
      var _this2 = this;

      // 보드 보기 버튼 설정
      this.wordListBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        var classList = _this2.wordListBtn.classList;

        if (classList.contains('click')) {
          _this2.returnDefaultBoard();
        } else {
          _this2.wordListBtn.classList.add('click');

          _this2.listBoard.classList.remove(css_name_1.YOIL_CSS.yoil_display_hide);
        }
      }); // 보드에서 나가기 버튼 설정

      var boardExitBtn = document.querySelector('.board_exit');
      boardExitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this2.returnDefaultBoard();
      });
    } // 보드 되돌리기

  }, {
    key: "returnDefaultBoard",
    value: function returnDefaultBoard() {
      this.wordListBtn.classList.remove('click');
      this.listBoard.classList.add(css_name_1.YOIL_CSS.yoil_display_hide);
    }
  }, {
    key: "setBoard",
    value: function setBoard() {}
  }, {
    key: "setCurrentWord",
    value: function setCurrentWord(currentNum) {
      var currentWord = this.boardWords.querySelector('.current');

      if (currentWord) {
        currentWord.classList.remove('current');
      }

      var targetDiv = this.boardWords.querySelectorAll('div')[currentNum];
      targetDiv.classList.add('current');
    }
  }]);
  return BwWordList;
}();

exports.BwWordList = BwWordList;

},{"../../../common/css-name":26,"../../../common/pc-mobile":31,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],54:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWwBuildingWord = void 0;

var css_name_1 = require("../../../common/css-name");

var media_events_1 = require("../../../common/event/media-events");

var sound_player_1 = require("../../../common/media/sound/sound-player");

var pc_mobile_1 = require("../../../common/pc-mobile");

var util_1 = require("../../../common/util/util");

var get_data_1 = require("../../../data/get-data");

var program_info_1 = require("../../../info/program-info");

var router_1 = require("../../../router/router");

var BwWordList_1 = require("./BwWordList");

var ContentWwBuildingWord = /*#__PURE__*/function () {
  function ContentWwBuildingWord() {
    (0, _classCallCheck2["default"])(this, ContentWwBuildingWord);
    this.currentWordNum = 0;
    this.info = program_info_1.ProgramInfo.getInstance();
    this.soundPlayer = new sound_player_1.YoilSoundPlayer();
    this.soundStatus = -1;
  }

  (0, _createClass2["default"])(ContentWwBuildingWord, [{
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var dataInfo;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataInfo = new get_data_1.BookData();
                _context.next = 3;
                return dataInfo.getContentData();

              case 3:
                this.bwData = _context.sent;
                this.textEl = document.querySelector('.text');
                this.textBoard = document.querySelector('.view_text');
                this.currentImg = document.querySelector('.view_image');
                this.currentText = document.querySelector('.view_text');
                this.wordTotal = this.bwData.word.length - 1;
                this.wordList = new BwWordList_1.BwWordList(this.bwData);
                this.wordList.init();
                window.addEventListener('wordChange', this.changeWordList.bind(this));
                window.addEventListener(media_events_1.YoilEvent.SOUND_COMPLETE, this.soundComplete.bind(this));
                this.setArrow();
                this.setImageEvent();
                this.changeStage();
                this.setExitBtn();

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "changeWordList",
    value: function changeWordList(e) {
      this.currentWordNum = e.detail;
      this.changeStage();
    }
  }, {
    key: "soundComplete",
    value: function soundComplete() {
      switch (this.soundStatus) {
        case 0
        /* STATUS_SOUND.ClienImg */
        :
          this.soundStatus = 1
          /* STATUS_SOUND.PutWord */
          ;
          var word = this.bwData.word[this.currentWordNum];
          var path = "./sound/ww/buildingwords/".concat((0, util_1.get10Check)(this.info.getBookNumber()), "/S").concat(this.info.getContentInnerNumber(), "/").concat(word, ".mp3");
          this.soundPlayer.soundPlay(path);
          return;

        case 1
        /* STATUS_SOUND.PutWord */
        :
          if (this.currentWordNum === this.wordTotal) {} else {
            this.arrowRight.dispatchEvent(new Event(pc_mobile_1.StaticData.CLICK));
          }

          return;
      }

      this.soundStatus = -1;
    }
  }, {
    key: "setArrow",
    value: function setArrow() {
      var _this = this;

      this.arrowLeft = document.querySelector('.board_arrow-left');
      this.arrowRight = document.querySelector('.board_arrow-right');
      this.arrowLeft.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this.currentWordNum--;

        _this.changeStage();
      });
      this.arrowRight.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this.currentWordNum++;

        _this.changeStage();
      });
    }
  }, {
    key: "changeStage",
    value: function changeStage() {
      this.textBoard.classList.add(css_name_1.YOIL_CSS.yoil_display_alpha_hide);
      this.textBoard.classList.remove(css_name_1.YOIL_CSS.yoil_ani_alpha_up);
      this.currentImg.classList.remove(css_name_1.YOIL_CSS.yoil_ani_alpha_down);
      this.currentImg.style.pointerEvents = 'auto';
      this.wordList.setCurrentWord(this.currentWordNum);
      this.putWord();
      this.checkArrow();
      this.changeImage();
    }
  }, {
    key: "putWord",
    value: function putWord() {
      var word = this.bwData.word[this.currentWordNum];
      var color = this.bwData.color[this.currentWordNum];
      this.checkWordSize(word);
      this.textEl.innerText = word;
      this.textEl.style.color = "#".concat(color);
    }
  }, {
    key: "checkArrow",
    value: function checkArrow() {
      var HIDE_CL = css_name_1.YOIL_CSS.yoil_display_alpha_hide;

      if (this.currentWordNum === 0) {
        this.arrowLeft.classList.add(HIDE_CL);
        return;
      }

      if (this.currentWordNum === this.wordTotal) {
        this.arrowLeft.classList.remove(HIDE_CL);
        this.arrowRight.classList.add(HIDE_CL);
        return;
      }

      this.arrowLeft.classList.remove(HIDE_CL);
      this.arrowRight.classList.remove(HIDE_CL);
    }
  }, {
    key: "checkWordSize",
    value: function checkWordSize(word) {
      if (word.length > 4) {
        if (word.length >= 6) {
          this.textEl.style.fontSize = '300px';
        } else {
          this.textEl.style.fontSize = '400px';
        }
      } else {
        this.textEl.style.fontSize = '500px';
      }
    }
  }, {
    key: "setImageEvent",
    value: function setImageEvent() {
      var _this2 = this;

      this.currentImg.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this2.currentImg.classList.add(css_name_1.YOIL_CSS.yoil_ani_alpha_down);

        _this2.currentText.classList.add(css_name_1.YOIL_CSS.yoil_ani_alpha_up);

        _this2.currentImg.style.pointerEvents = 'none';
        var eventSoundPath = './sound/ww/effect/eff03.mp3';
        _this2.soundStatus = 0
        /* STATUS_SOUND.ClienImg */
        ;

        _this2.soundPlayer.soundPlay(eventSoundPath);
      });
    }
  }, {
    key: "changeImage",
    value: function changeImage() {
      this.currentImg.style.backgroundImage = "URL('./images/ww/buildingword/".concat((0, util_1.get10Check)(this.info.getBookNumber()), "/S").concat(this.info.getContentInnerNumber(), "/img_").concat((0, util_1.get10Check)(this.currentWordNum + 1), ".jpg')");
    }
  }, {
    key: "setExitBtn",
    value: function setExitBtn() {
      var exitBtn = document.querySelector('.top_exit');
      exitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        var router = router_1["default"].getInstance();
        var infoObj = program_info_1.ProgramInfo.getInstance();
        router.moveContent(infoObj.getBackUrl());
      });
    }
  }, {
    key: "destory",
    value: function destory() {
      window.removeEventListener('wordChange', this.changeWordList.bind(this));
    }
  }]);
  return ContentWwBuildingWord;
}();

exports.ContentWwBuildingWord = ContentWwBuildingWord;

},{"../../../common/css-name":26,"../../../common/event/media-events":27,"../../../common/media/sound/sound-player":29,"../../../common/pc-mobile":31,"../../../common/util/util":32,"../../../data/get-data":62,"../../../info/program-info":66,"../../../router/router":71,"./BwWordList":53,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/regenerator":22}],55:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuizSound = void 0;

var sound_player_1 = require("../../../common/media/sound/sound-player");

var util_1 = require("../../../common/util/util");

var QuizSound = /*#__PURE__*/function () {
  function QuizSound(bookNumberStr, innerNumber) {
    (0, _classCallCheck2["default"])(this, QuizSound);
    this.bookNumberStr = bookNumberStr;
    this.innerNumber = innerNumber;
    this.sndPlayer = new sound_player_1.YoilSoundPlayer();
  }

  (0, _createClass2["default"])(QuizSound, [{
    key: "btnClk",
    value: function btnClk() {
      this.sndPlayer.soundPlay(this.getEffSoundPath('eff02.mp3'));
    }
  }, {
    key: "playQuizSound",
    value: function playQuizSound(currentQuiz) {
      var sndNameStr = "quizDirection_".concat(currentQuiz, ".mp3");
      var QUIZ_PATH = "".concat(this.getInnerSndPath(), "/").concat(sndNameStr);
      this.sndPlayer.soundPlay(QUIZ_PATH);
    }
  }, {
    key: "soundStop",
    value: function soundStop() {
      this.sndPlayer.soundStop();
    }
  }, {
    key: "tryAgain",
    value: function tryAgain() {
      this.sndPlayer.soundPlay(this.getEffSoundPath('tryAgain.mp3'));
    }
  }, {
    key: "good",
    value: function good() {
      var soundLst = ['good', 'goodjob', 'great'];
      var targetSnd = soundLst[(0, util_1.getRandomNum)(0, 2)];
      var gooPath = this.getEffSoundPath("".concat(targetSnd, ".mp3"));
      this.sndPlayer.soundPlay(gooPath);
    }
  }, {
    key: "endQuizAnswer",
    value: function endQuizAnswer(quizNum) {
      var END_PATH = "".concat(this.getInnerSndPath(), "/quizWord_").concat(quizNum, ".mp3");
      this.sndPlayer.soundPlay(END_PATH);
    }
  }, {
    key: "endAllQuiz",
    value: function endAllQuiz() {
      var endAllQuiz = this.getEffSoundPath('excellent.mp3');
      this.sndPlayer.soundPlay(endAllQuiz);
    }
  }, {
    key: "getInnerSndPath",
    value: function getInnerSndPath() {
      return "./sound/ww/quiz/".concat(this.bookNumberStr, "/S").concat(this.innerNumber);
    }
  }, {
    key: "getEffSoundPath",
    value: function getEffSoundPath(sndName) {
      return "./sound/ww/effect/".concat(sndName);
    }
  }]);
  return QuizSound;
}();

exports.QuizSound = QuizSound;

},{"../../../common/media/sound/sound-player":29,"../../../common/util/util":32,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],56:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWwQuiz = void 0;

var anime = require("animejs");

var media_events_1 = require("../../../common/event/media-events");

var pc_mobile_1 = require("../../../common/pc-mobile");

var util_1 = require("../../../common/util/util");

var get_data_1 = require("../../../data/get-data");

var program_info_1 = require("../../../info/program-info");

var router_1 = require("../../../router/router");

var quiz_sound_1 = require("./quiz-sound");

var ContentWwQuiz = /*#__PURE__*/function () {
  function ContentWwQuiz() {
    (0, _classCallCheck2["default"])(this, ContentWwQuiz);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
    this.bookNumberStr = (0, util_1.get10Check)(this.infoObj.getBookNumber());
    this.innerNumber = this.infoObj.getContentInnerNumber();
    this.currentQuiz = 0;
  }

  (0, _createClass2["default"])(ContentWwQuiz, [{
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var dataInfo, quizData;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataInfo = new get_data_1.BookData();
                _context.next = 3;
                return dataInfo.getContentData();

              case 3:
                quizData = _context.sent;
                this.soundPlayer = new quiz_sound_1.QuizSound(this.bookNumberStr, this.innerNumber);
                this.quizLst = quizData.quiz;
                this.stageStatus = 0
                /* STAGE_STATUS.PutQuiz */
                ;
                this.addEvent();
                this.putQuiz();
                this.putExampleCard();
                this.setExitBtn();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getImagePath",
    value: function getImagePath(imgNameStr) {
      return "url('./images/ww/quiz/".concat(this.bookNumberStr, "/S").concat(this.innerNumber, "/").concat(imgNameStr, "')");
    }
  }, {
    key: "getCurrentQuiz",
    value: function getCurrentQuiz() {
      return this.currentQuiz + 1;
    }
  }, {
    key: "addEvent",
    value: function addEvent() {
      var _this = this;

      window.addEventListener(media_events_1.YoilEvent.SOUND_COMPLETE, this.soundComplete.bind(this));
      var btns = this.getAnswerList();
      btns.forEach(function (el) {
        el.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          _this.soundPlayer.btnClk();

          var clkValue = +el.querySelector('.list_inner').getAttribute('value');

          _this.answerCheck(clkValue, el);
        });
      });
    }
  }, {
    key: "getAnswerList",
    value: function getAnswerList() {
      if (this.answerList) {} else {
        this.answerList = document.querySelectorAll('.answers_list');
      }

      return this.answerList;
    }
  }, {
    key: "answerCheck",
    value: function answerCheck(clkValue, targetEl) {
      var answerNum = this.getCurrentQuiz();
      this.noneEventBtns();

      if (clkValue === answerNum) {
        this.putAnswer(targetEl);
        this.soundPlayer.good();
      } else {
        this.putNotAnswer();
      }
    }
  }, {
    key: "noneEventBtns",
    value: function noneEventBtns() {
      var btns = this.getAnswerList();
      btns.forEach(function (el) {
        el.style.pointerEvents = 'none';
      });
    }
  }, {
    key: "putAnswer",
    value: function putAnswer(targetEl) {
      var _this2 = this;

      this.stageStatus = 2
      /* STAGE_STATUS.EndQuiz */
      ;
      this.currentAni = anime({
        targets: targetEl,
        rotateY: '90deg',
        easing: 'linear',
        duration: 300,
        complete: function complete() {
          var answerEl = targetEl.querySelector('.list_answer');
          answerEl.style.opacity = '1';
          _this2.currentAni = anime({
            targets: targetEl,
            rotateY: '0deg',
            easing: 'linear',
            duration: 300
          });
        }
      });
    }
  }, {
    key: "putNotAnswer",
    value: function putNotAnswer() {
      this.soundPlayer.tryAgain();
      this.stageStatus = 1
      /* STAGE_STATUS.QuizFalse */
      ;
      var targetImg = document.querySelector('.content_tryagain');
      targetImg.style.opacity = '1';
      var animeTarget = document.querySelector('.tryagain_img');
      animeTarget.style.transform = 'translateX(0)';
      this.currentAni = anime({
        targets: animeTarget,
        translateX: 30,
        easing: 'spring(1, 80, 0, 0)'
      });
    }
  }, {
    key: "activeEventBtns",
    value: function activeEventBtns() {
      var btns = this.getAnswerList();
      btns.forEach(function (el) {
        el.style.pointerEvents = 'auto';
      });
    }
  }, {
    key: "putQuiz",
    value: function putQuiz() {
      this.putQuizTitle();
      this.putQuizImage();
      this.putQuizCard();
    }
  }, {
    key: "putQuizTitle",
    value: function putQuizTitle() {
      var quizTitle = document.querySelector('.content_title');
      quizTitle.innerHTML = this.quizLst[this.currentQuiz];
    }
  }, {
    key: "putQuizImage",
    value: function putQuizImage() {
      var quizDiv = document.querySelector('.quiz');
      quizDiv.style.backgroundImage = this.getImagePath("q_0".concat(this.getCurrentQuiz(), ".jpg"));
    }
  }, {
    key: "putQuizCard",
    value: function putQuizCard() {
      var _this3 = this;

      var quizBox = document.querySelector('.content_quiz');
      quizBox.style.transform;
      this.currentAni = anime({
        targets: quizBox,
        translateY: 238,
        opacity: 1,
        duration: 2000,
        delay: 500,
        complete: function complete() {
          _this3.stageStatus = 0
          /* STAGE_STATUS.PutQuiz */
          ;

          _this3.soundPlayer.playQuizSound(_this3.getCurrentQuiz());
        }
      });
    }
  }, {
    key: "putExampleCard",
    value: function putExampleCard() {
      var _this4 = this;

      var exampleNumbers = [1, 2, 3];
      exampleNumbers.sort(function () {
        return Math.random() - 0.5;
      });
      var cardLsts = document.querySelectorAll('.list_inner');
      var answerCards = document.querySelectorAll('.list_answer');
      cardLsts.forEach(function (el, value) {
        var targetImgNum = exampleNumbers[value];
        el.setAttribute('value', "".concat(targetImgNum));
        el.style.backgroundImage = _this4.getImagePath("ex_0".concat(targetImgNum, ".jpg"));
        var answerCard = answerCards[value];
        var answerImgNum = exampleNumbers[value];
        answerCard.style.backgroundImage = _this4.getImagePath("answer_0".concat(answerImgNum, ".jpg"));
      });
    }
  }, {
    key: "setExitBtn",
    value: function setExitBtn() {
      var exitBtn = document.querySelector('.top_exit');
      exitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        var router = router_1["default"].getInstance();
        var infoObj = program_info_1.ProgramInfo.getInstance();
        router.moveContent(infoObj.getBackUrl());
      });
    }
  }, {
    key: "soundComplete",
    value: function soundComplete() {
      console.log('this.stageStatus', this.stageStatus);

      switch (this.stageStatus) {
        case 0
        /* STAGE_STATUS.PutQuiz */
        :
          this.quitQuizWindow();
          break;

        case 1
        /* STAGE_STATUS.QuizFalse */
        :
          this.currentAni.pause();
          this.quizFalse();
          this.activeEventBtns();
          break;

        case 2
        /* STAGE_STATUS.EndQuiz */
        :
          this.stageStatus = 3
          /* STAGE_STATUS.NextQuiz */
          ;
          this.soundPlayer.endQuizAnswer(this.getCurrentQuiz());
          return;

        case 3
        /* STAGE_STATUS.NextQuiz */
        :
          this.nextQuiz();
          break;
      }

      this.stageStatus = -1;
    }
  }, {
    key: "nextQuiz",
    value: function nextQuiz() {
      var _this5 = this;

      this.currentQuiz++;

      if (this.currentQuiz === 3) {
        var answerLst = this.getAnswerList();
        answerLst.forEach(function (el) {
          var answerCard = el.querySelector('.list_answer');

          if (answerCard.style.opacity !== '1') {
            _this5.putAnswer(el);
          }
        });
        this.soundPlayer.endAllQuiz();
      } else {
        var answerCards = document.querySelectorAll('.list_answer');
        answerCards.forEach(function (el) {
          el.style.opacity = '0';
        });
        var exampleCards = document.querySelectorAll('.list_inner');
        exampleCards.forEach(function (el) {
          el.style.opacity = '0';
        });
        var maskSp = document.querySelector('.content_mask');
        maskSp.style.pointerEvents = 'auto';
        maskSp.style.opacity = '1';
        this.putQuiz();
        this.putExampleCard();
      }
    }
  }, {
    key: "quitQuizWindow",
    value: function quitQuizWindow() {
      var _this6 = this;

      this.currentAni = anime({
        targets: document.querySelector('.content_quiz'),
        easing: 'linear',
        duration: 300,
        translateY: -100,
        opacity: 0,
        complete: function complete() {
          maskOut();
        }
      });

      var maskOut = function maskOut() {
        var maskSp = document.querySelector('.content_mask');
        maskSp.style.pointerEvents = 'none';
        _this6.currentAni = anime({
          targets: maskSp,
          easing: 'linear',
          opacity: 0,
          duration: 100,
          complete: function complete() {
            _this6.viewExamples();
          }
        });
      };
    }
  }, {
    key: "quizFalse",
    value: function quizFalse() {
      var targetImg = document.querySelector('.content_tryagain');
      targetImg.style.opacity = '0';
    }
  }, {
    key: "viewExamples",
    value: function viewExamples() {
      this.activeEventBtns();
      var examples = document.querySelectorAll('.list_inner');
      examples.forEach(function (el) {
        anime({
          targets: el,
          opacity: 1,
          easing: 'linear',
          duration: 500
        });
      });
    }
  }, {
    key: "destory",
    value: function destory() {
      if (this.currentAni) {
        this.currentAni.pause();
      }

      this.stageStatus = -1;
      this.soundPlayer.soundStop();
      window.removeEventListener(media_events_1.YoilEvent.SOUND_COMPLETE, this.soundComplete.bind(this));
    }
  }]);
  return ContentWwQuiz;
}();

exports.ContentWwQuiz = ContentWwQuiz;

},{"../../../common/event/media-events":27,"../../../common/pc-mobile":31,"../../../common/util/util":32,"../../../data/get-data":62,"../../../info/program-info":66,"../../../router/router":71,"./quiz-sound":55,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/regenerator":22,"animejs":23}],57:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWwWrite = void 0;

var pc_mobile_1 = require("../../../common/pc-mobile");

var program_info_1 = require("../../../info/program-info");

var get_data_1 = require("../../../data/get-data");

var router_1 = require("../../../router/router");

var BwWordList_1 = require("../building-word/BwWordList");

var css_name_1 = require("../../../common/css-name");

var ContentWwWrite = /*#__PURE__*/function () {
  function ContentWwWrite() {
    (0, _classCallCheck2["default"])(this, ContentWwWrite);
    this.painting = false;
    this.SIZE_WIDTH = 1804;
    this.SIZE_HEIGHT = 1054;
    this.currentWordNum = 0;
  }

  (0, _createClass2["default"])(ContentWwWrite, [{
    key: "init",
    value: function init() {
      this.listBoard = document.querySelector('.list_board');
      window.addEventListener('wordChange', this.changeWordList.bind(this));
      this.getData();
      this.setBtns();
      this.setupBoard();
      this.setArrow();
      this.setExitBtn();
    }
  }, {
    key: "changeWordList",
    value: function changeWordList(e) {
      this.currentWordNum = e.detail;
      this.changeStage();
    }
  }, {
    key: "getData",
    value: function getData() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var infoObj, bookNumber, innerContent, dataInfo, writeData;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                infoObj = program_info_1.ProgramInfo.getInstance();
                bookNumber = infoObj.getBookNumber();
                innerContent = infoObj.getContentInnerNumber();
                dataInfo = new get_data_1.BookData();
                _context.next = 6;
                return dataInfo.getNormalContentData('./json/ww/write/ww-write.json');

              case 6:
                writeData = _context.sent;
                this.wordData = writeData["book".concat(bookNumber)]["S".concat(innerContent)];
                this.wordTotal = this.wordData.length - 1;
                this.wordList = new BwWordList_1.BwWordList({
                  word: this.wordData,
                  color: []
                });
                this.wordList.init();
                this.changeStage();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setBtns",
    value: function setBtns() {
      this.setEraserBtn();
    }
  }, {
    key: "clickClassChecker",
    value: function clickClassChecker(targetBtn) {
      if (targetBtn.classList.contains('click')) {
        targetBtn.classList.remove('click');
      } else {
        targetBtn.classList.add('click');

        if (this.ctx) {
          this.ctx.globalCompositeOperation = 'source-over';
        }
      }
    }
  }, {
    key: "setEraserBtn",
    value: function setEraserBtn() {
      var _this = this;

      var eraserBtn = document.querySelector('.btns_erase');
      eraserBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this.resetCanvas();
      });
    }
  }, {
    key: "resetCanvas",
    value: function resetCanvas() {
      this.ctx.globalCompositeOperation = 'destination-out';
      this.ctx.fillStyle = '#ffffff';
      this.ctx.fillRect(0, 0, this.SIZE_WIDTH, this.SIZE_HEIGHT);
      this.ctx.globalCompositeOperation = 'source-over';
    }
  }, {
    key: "setupBoard",
    value: function setupBoard() {
      this.canvas = document.querySelector('.canvas');
      this.ctx = this.canvas.getContext('2d');
      this.canvas.width = this.SIZE_WIDTH;
      this.canvas.height = this.SIZE_HEIGHT;
      this.ctx.strokeStyle = '#1f74c1';
      this.ctx.lineWidth = 20;
      this.ctx.fillStyle = 'rgba(0, 0, 0, 0)'; // this.ctx.fillRect(0, 0, this.SIZE_WIDTH, this.SIZE_HEIGHT);

      this.canvas.addEventListener(pc_mobile_1.StaticData.MOVE, this.onMouseMove.bind(this));
      this.canvas.addEventListener(pc_mobile_1.StaticData.PRESS, this.startPainting.bind(this));
      this.canvas.addEventListener(pc_mobile_1.StaticData.UP, this.stopPainting.bind(this));
      this.canvas.addEventListener(pc_mobile_1.StaticData.LEAVE, this.stopPainting.bind(this));
    }
  }, {
    key: "stopPainting",
    value: function stopPainting() {
      this.painting = false;
    }
  }, {
    key: "startPainting",
    value: function startPainting(event) {
      if ((0, pc_mobile_1.pcOrMobile)() === 'MOBILE') {
        var rect = {
          left: event.target.offsetLeft,
          top: event.target.offsetTop
        };
        var x = event.touches[0].pageX;
        var y = event.touches[0].pageY;
        this.ctx.beginPath();
        this.ctx.moveTo(x, y);
      }

      this.painting = true;
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(event) {
      var x = event.offsetX;
      var y = event.offsetY;

      if ((0, pc_mobile_1.pcOrMobile)() === 'MOBILE') {
        event.preventDefault();
        var rect = {
          left: event.target.offsetLeft,
          top: event.target.offsetTop
        };
        x = event.touches[0].pageX;
        y = event.touches[0].pageY;
      }

      if (this.painting) {
        this.ctx.lineTo(x, y);
        this.ctx.stroke();
      } else {
        this.ctx.beginPath();
        this.ctx.moveTo(x, y);
      }
    }
  }, {
    key: "setArrow",
    value: function setArrow() {
      var _this2 = this;

      this.arrowLeft = document.querySelector('.board_arrow-left');
      this.arrowRight = document.querySelector('.board_arrow-right');
      this.arrowLeft.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this2.currentWordNum--;

        _this2.changeStage();
      });
      this.arrowRight.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this2.currentWordNum++;

        _this2.changeStage();
      });
    }
  }, {
    key: "changeStage",
    value: function changeStage() {
      this.wordList.setCurrentWord(this.currentWordNum);
      this.resetCanvas();
      this.putWord();
      this.checkArrow();
    }
  }, {
    key: "putWord",
    value: function putWord() {
      var textDiv = document.querySelector('.text');
      textDiv.innerHTML = this.wordData[this.currentWordNum];
    }
  }, {
    key: "checkArrow",
    value: function checkArrow() {
      var HIDE_CL = css_name_1.YOIL_CSS.yoil_display_alpha_hide;

      if (this.currentWordNum === 0) {
        this.arrowLeft.classList.add(HIDE_CL);
        this.arrowRight.classList.remove(HIDE_CL);
        return;
      }

      if (this.currentWordNum === this.wordTotal) {
        this.arrowLeft.classList.remove(HIDE_CL);
        this.arrowRight.classList.add(HIDE_CL);
        return;
      }

      this.arrowLeft.classList.remove(HIDE_CL);
      this.arrowRight.classList.remove(HIDE_CL);
    }
  }, {
    key: "handleCM",
    value: function handleCM(event) {
      event.preventDefault();
    }
  }, {
    key: "setExitBtn",
    value: function setExitBtn() {
      var exitBtn = document.querySelector('.top_exit');
      exitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        var router = router_1["default"].getInstance();
        var infoObj = program_info_1.ProgramInfo.getInstance();
        router.moveContent(infoObj.getBackUrl());
      });
    }
  }, {
    key: "destory",
    value: function destory() {}
  }]);
  return ContentWwWrite;
}();

exports.ContentWwWrite = ContentWwWrite;

},{"../../../common/css-name":26,"../../../common/pc-mobile":31,"../../../data/get-data":62,"../../../info/program-info":66,"../../../router/router":71,"../building-word/BwWordList":53,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/regenerator":22}],58:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentWwMain = void 0;

var pc_mobile_1 = require("../../common/pc-mobile");

var util_1 = require("../../common/util/util");

var info_routerPath_1 = require("../../router/info-routerPath");

var program_info_1 = require("../../info/program-info");

var router_1 = require("../../router/router");

var ContentWwMain = /*#__PURE__*/function () {
  function ContentWwMain() {
    (0, _classCallCheck2["default"])(this, ContentWwMain);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
    this.router = router_1["default"].getInstance();
  }

  (0, _createClass2["default"])(ContentWwMain, [{
    key: "init",
    value: function init() {
      this.setBackImg();
      this.setExitBtn();
    }
  }, {
    key: "setBackImg",
    value: function setBackImg() {
      var _this = this;

      var btnLst = document.querySelectorAll('.main_content');
      var router = router_1["default"].getInstance();
      var paramLst = this.infoObj.getParam();
      btnLst.forEach(function (targetDoc, key) {
        targetDoc.innerHTML = _this.getImgHtml(key + 1);
        targetDoc.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
          var contentName = targetDoc.getAttribute('value');

          _this.infoObj.setCurrentContent(contentName);

          _this.infoObj.setVideoUrl(_this.getVideoUrl());

          router.moveContent("ww/".concat(paramLst[1], "/").concat(paramLst[2], "/").concat(contentName));
        });
      });
      var audioBtn = document.querySelector('.other_sound');
      audioBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        router.moveContent("ww/".concat(paramLst[1], "/").concat(paramLst[2], "/audio"));
      });
    } // 각 버튼에 이미지 삽입

  }, {
    key: "getImgHtml",
    value: function getImgHtml(key) {
      var numStr = (0, util_1.get10Check)(this.infoObj.getBookNumber());
      var contentInnerNumber = this.infoObj.getContentInnerNumber();
      var imgHtml = "<img src=\"./images/ww/main/".concat(numStr, "/S").concat(contentInnerNumber, "/btn_").concat((0, util_1.get10Check)(key), ".png\"/>");
      return imgHtml;
    }
  }, {
    key: "getVideoUrl",
    value: function getVideoUrl() {
      var bookNum = this.infoObj.getBookNumber();
      var section = this.infoObj.getContentInnerNumber();
      var content = this.infoObj.getCurrentContent();

      switch (content) {
        case 'animation':
          content = 'animation';
          break;

        case 'song':
        case 'rhymeBook':
        case 'storyBook':
        case 'chant':
          content = content + '_AR';
          break;
      }

      return "./video/ww/".concat((0, util_1.get10Check)(bookNum), "/S").concat(section, "/").concat(content, ".mp4");
    }
  }, {
    key: "setExitBtn",
    value: function setExitBtn() {
      var _this2 = this;

      var exitBtn = document.querySelector('.top_exit');
      exitBtn.addEventListener(pc_mobile_1.StaticData.CLICK, function () {
        _this2.router.moveContent(info_routerPath_1.wwRouterpath.ww + '?first=false');
      });
    }
  }, {
    key: "destory",
    value: function destory() {}
  }]);
  return ContentWwMain;
}();

exports.ContentWwMain = ContentWwMain;

},{"../../common/pc-mobile":31,"../../common/util/util":32,"../../info/program-info":66,"../../router/info-routerPath":67,"../../router/router":71,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],59:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bwwBookList = void 0;
exports.bwwBookList = {
  vol1: {
    book: ['mmm...mmm...milk']
  },
  vol2: {
    book: ['Caterpillar Gets a Home']
  },
  vol3: {
    book: ['Duck at Bat']
  },
  vol4: {
    book: ['Bear_s Sled']
  },
  vol5: {
    book: ['Duck Plays the Piano']
  },
  vol6: {
    book: ['Totally Terrific Duck']
  },
  vol7: {
    book: ['A String is the Thing']
  },
  vol8: {
    book: ['You Can Never Have Too Many OOs']
  },
  vol9: {
    book: ['X Marks the Spot']
  },
  vol10: {
    book: ["Duck Saves Spider's Web"]
  },
  vol11: {
    book: ["Dog's Having a Party"]
  },
  vol12: {
    book: ['J-J-Jelly']
  },
  vol13: {
    book: ['Kite Flight']
  }
};

},{}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wftaBookList = void 0;
exports.wftaBookList = {
  vol1: {
    book: ['The White Lamb', 'The Three Wishes', 'The Vinegar Boy']
  },
  vol2: {
    book: ['The Horse Chase', 'The Chocolate Thief', 'Boots and the Giant']
  },
  vol3: {
    book: ['A Wise Judge', 'The White Cat', "The Minotaur's Maze"]
  },
  vol4: {
    book: ['The Sphinx', 'The Fisherman and the Genie', 'The Wizard Khizr']
  },
  vol5: {
    book: ["Who's There", 'The Flying Tortoise', 'How the Crocodile Got a Bumpy Back']
  },
  vol6: {
    book: ['Mayrah', 'How the Kangaroo Got a Pouch', 'Bamapama']
  },
  vol7: {
    book: ['The Smiling Rabbit', 'The Frog and the Condors Girl', 'Looking for the Magic Lake']
  },
  vol8: {
    book: ['The Fly and the River', 'The Rabbit and the Hare', 'Wind Horse']
  },
  vol9: {
    book: ['The Colobok', 'The Snow Girl', 'Masha and the Bear']
  },
  vol10: {
    book: ['The Salmon Boy', "Ayvek's Magical Friend", 'The Polar Bear Cub']
  },
  vol11: {
    book: ['The Boy and the Cat', "The Emperor's Flowers", 'The White Tiger']
  },
  vol12: {
    book: ['The Tricky Tiger', 'The Magic Bowl', 'The Missing Treasure']
  }
};

},{}],61:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wwBookList = void 0;
exports.wwBookList = {
  vol1: {
    book: ['Catch that C!', 'Shuffleword', 'Who Can Read?', 'Playing Spies']
  },
  vol2: {
    book: ['Bit by Bit', "Pig's Present", 'Happy Birthday, Dog!', 'The Rainbow Birthday Cake']
  },
  vol3: {
    book: ['Chef Sheep', 'Superhero Sheep', 'Snug as a Bug', 'Robots to the Rescue']
  },
  vol4: {
    book: ['Wee Little Whale', 'The Birds', "Dog's Camping Adventure", 'Pie, Pie, Pie!']
  },
  vol5: {
    book: ['W Drought', 'Back on Track', "Pig\u2019s Big Moonlight Feast", 'Castle in the Sea']
  },
  vol6: {
    book: ['Runaway O', 'Flying Ant', 'Rocket to the Moon', 'Waterlogged']
  },
  vol7: {
    book: ['The Lost Letter L', 'Play Ball!', 'Get Your Coat', 'Pl-Pl-Plane']
  },
  vol8: {
    book: ['One Hat Fits All', 'A Kooky Spooky Halloween', 'The Race to Mystery Island', "Sheep's Halloween Custume"]
  },
  vol9: {
    book: ['M is for Map', 'Sh-Sh-Shark!', 'Princess Sheep', 'Mail Mix Up']
  },
  vol10: {
    book: ['V is for Vacation', 'The Christmas Star', 'A Christmas Present for Dog', 'Tick Tock Space Clock']
  },
  vol11: {
    book: ["Duck's First Sleepover Party", 'Nightlight', 'Dancing Dog', "Boppin\u2019 with the Bug Band"]
  },
  vol12: {
    book: ['Dog Wants To Play Ball', 'A Star Is Born', 'The Daning Duck Show', 'Pirate Ship']
  }
};

},{}],62:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookData = void 0;

var data_interface_1 = require("../info/data-interface");

var program_info_1 = require("../info/program-info");

var bww_book_list_1 = require("./book-data/bww-book-list");

var wfta_book_list_1 = require("./book-data/wfta-book-list");

var ww_book_list_1 = require("./book-data/ww-book-list");

var BookData = /*#__PURE__*/function () {
  function BookData() {
    (0, _classCallCheck2["default"])(this, BookData);
    this.infoObj = program_info_1.ProgramInfo.getInstance();
  }

  (0, _createClass2["default"])(BookData, [{
    key: "setContentType",
    value: function setContentType(contentTypeStr) {
      this.contentTypeStr = contentTypeStr;
    }
  }, {
    key: "getList",
    value: function getList() {
      switch (this.contentTypeStr) {
        case data_interface_1.BookType.WFTA:
          return this.bookList(wfta_book_list_1.wftaBookList);

        case data_interface_1.BookType.WW:
          return this.bookList(ww_book_list_1.wwBookList);

        case data_interface_1.BookType.BWW:
          return this.bookList(bww_book_list_1.bwwBookList);
      }
    }
  }, {
    key: "bookList",
    value: function bookList(bookData) {
      var dataBook = [];

      for (var _i = 0, _Object$entries = Object.entries(bookData); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
            _key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        var book = value.book;
        dataBook.push(book);
      }

      return dataBook;
    }
  }, {
    key: "getContentData",
    value: function getContentData() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var currentContent, jsonData, json;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentContent = this.infoObj.getContentInnerNumber();
                _context.next = 3;
                return fetch(this.getJsonPathUrl());

              case 3:
                jsonData = _context.sent;
                _context.next = 6;
                return jsonData.json();

              case 6:
                json = _context.sent;
                return _context.abrupt("return", json['S' + currentContent]);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getNormalContentData",
    value: function getNormalContentData(pathUrl) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var jsonData, json;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch(pathUrl);

              case 2:
                jsonData = _context2.sent;
                _context2.next = 5;
                return jsonData.json();

              case 5:
                json = _context2.sent;
                return _context2.abrupt("return", json);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "getJsonPathUrl",
    value: function getJsonPathUrl() {
      var contentType = this.infoObj.getContentType();
      var currentContent = this.infoObj.getCurrentContent();
      return "./json/".concat(contentType, "/").concat(currentContent, "/").concat(contentType, "-").concat(currentContent, "-").concat(this.infoObj.getBookNumber(), ".json");
    }
  }]);
  return BookData;
}();

exports.BookData = BookData;

},{"../info/data-interface":65,"../info/program-info":66,"./book-data/bww-book-list":59,"./book-data/wfta-book-list":60,"./book-data/ww-book-list":61,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/slicedToArray":17,"@babel/runtime/regenerator":22}],63:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});

var css_name_1 = require("./common/css-name");

var pc_mobile_1 = require("./common/pc-mobile");

var content_starter_1 = require("./content-starter");

var router_1 = require("./router/router");

var Index = /*#__PURE__*/function () {
  function Index() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, Index);
    window['testMode'] = true;
    window.addEventListener('resize', function (event) {
      _this.resizeCheck();
    });
    this.router = router_1["default"].getInstance();
    this.router.init(this);
    this.resizeCheck();
    this.contentStarter = new content_starter_1.ContentStarter();
  }

  (0, _createClass2["default"])(Index, [{
    key: "resizeCheck",
    value: function resizeCheck() {
      // y:1200 = x: 1
      // y*1 / 1200x
      // x = y * 1 / 1200
      var percent = window.innerWidth / 2000;

      if ((0, pc_mobile_1.pcOrMobile)() === 'PC' || (0, pc_mobile_1.isIphone)() || (0, pc_mobile_1.isHeightSize)()) {
        percent = window.innerHeight / 1200;
      }

      if ((0, pc_mobile_1.isIpad)() === true) {
        percent = window.innerWidth / 2000;
      }

      var contentsTag = document.querySelector('.contents');
      contentsTag.style.transform = "scale(".concat(percent, ")");
      contentsTag.style.transformOrigin = 'top center';
      var copyWriter = document.querySelector('.copywriter');
      copyWriter.style.transform = "scale(".concat(percent, ")");
      var afterScaleHeight = contentsTag.getBoundingClientRect().height;
      var topMargin = (window.innerHeight - afterScaleHeight) / 2.0;
      console.log(topMargin);
      contentsTag.style.marginTop = "".concat(topMargin, "px");
    }
  }, {
    key: "startContent",
    value: function startContent(contentStr) {
      if (this.contentObj) {
        this.contentObj.destory();
      }

      var copyWriter = document.querySelector('.copywriter');
      copyWriter.classList.remove(css_name_1.YOIL_CSS.yoil_display_hide);

      if (this.isCoptyWriteHide(contentStr)) {
        copyWriter.classList.add(css_name_1.YOIL_CSS.yoil_display_hide);
      }

      this.contentObj = this.contentStarter.getContentObject(contentStr);
      this.contentObj.init();
    }
    /**
     * 카피라이트 보여줄지 말지 구분
     * @param  {string} contentNameStr 컨텐츠 이름
     * @returns {boolean} 카피라이트를 감출지 말지를 결정
     */

  }, {
    key: "isCoptyWriteHide",
    value: function isCoptyWriteHide(contentNameStr) {
      return contentNameStr === 'video-common' || contentNameStr === 'ebook-common' || contentNameStr === 'comic-common' || contentNameStr === 'audio-common' || contentNameStr === 'ww-buildingword' || contentNameStr === 'ww-quiz' || contentNameStr === 'ww-write' || contentNameStr === 'wfta-phonics' || contentNameStr === 'wfta-dictionary' || contentNameStr === 'wfta-character' || contentNameStr === 'wfta-map';
    }
  }]);
  return Index;
}();

exports["default"] = Index;
window.addEventListener('DOMContentLoaded', function () {
  var runProgram = new Index();
});

},{"./common/css-name":26,"./common/pc-mobile":31,"./content-starter":33,"./router/router":71,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],64:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCommunication = void 0;

var ReactCommunication = /*#__PURE__*/function () {
  function ReactCommunication(singleton) {// this.react = window['ReactNativeWebView'];
    // if (this.react === undefined) {
    //     this.react = window.parent;
    // }
    // window.addEventListener('react', this.fromReact.bind(this));
    // window.addEventListener('message', (userData) => {
    //     if (userData.data.type) {
    //         this.fromReact(
    //             new CustomEvent('react', {
    //                 detail: {
    //                     dataType: 'books',
    //                     data: userData.data.userBooks,
    //                 },
    //             })
    //         );
    //     }
    // });

    (0, _classCallCheck2["default"])(this, ReactCommunication);
  }

  (0, _createClass2["default"])(ReactCommunication, [{
    key: "fromReact",
    value: function fromReact(event) {
      var dataType = event.detail.dataType;
      var data;

      switch (dataType) {
        case 'books':
          data = Array.from(event.detail.data);
          console.log('data', data);
          this.resolve(data);
          break;

        case 'reflash':
          this.reflashObj.init();
          break;
      }
    }
  }, {
    key: "getBooks",
    value: function getBooks() {
      var _this = this;

      if (!this.react) return;

      if (window['isNativeApp']) {
        this.react.postMessage('getUser');
      } else {
        this.react.postMessage('getUser', '*');
      }

      return new Promise(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
      });
    }
  }, {
    key: "insertUserBook",
    value: function insertUserBook() {// this.react.postMessage('addBook');
    }
  }, {
    key: "getReact",
    value: function getReact() {
      return this.react;
    }
  }, {
    key: "setReflashObj",
    value: function setReflashObj(reflashObj) {
      this.reflashObj = reflashObj;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (this.instance) {
        return this.instance;
      }

      this.instance = new ReactCommunication(new Singleton());
      return this.instance;
    }
  }]);
  return ReactCommunication;
}();

exports.ReactCommunication = ReactCommunication;

var Singleton = function Singleton() {
  (0, _classCallCheck2["default"])(this, Singleton);
};

},{"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],65:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WwContents = exports.BwwContents = exports.WftaContents = exports.CommonContents = exports.BookType = void 0;
var BookType;

(function (BookType) {
  BookType["WFTA"] = "wfta";
  BookType["WW"] = "ww";
  BookType["BWW"] = "bww";
})(BookType = exports.BookType || (exports.BookType = {}));

var CommonContents;

(function (CommonContents) {
  CommonContents["Ebook"] = "ebook";
})(CommonContents = exports.CommonContents || (exports.CommonContents = {}));

var WftaContents;

(function (WftaContents) {
  WftaContents["Animation"] = "animation";
  WftaContents["Mv"] = "mv";
  WftaContents["Act"] = "act";
  WftaContents["Map"] = "map";
  WftaContents["Character"] = "character";
  WftaContents["Phonics"] = "phonics";
  WftaContents["Dictionary"] = "dictionary";
  WftaContents["NextBook"] = "nextbook";
  WftaContents["Audio"] = "audio";
})(WftaContents = exports.WftaContents || (exports.WftaContents = {}));

var BwwContents;

(function (BwwContents) {
  BwwContents["Word"] = "word";
  BwwContents["Talking"] = "talking";
  BwwContents["Story"] = "story";
  BwwContents["Song"] = "song";
  BwwContents["StoryBook"] = "storybook";
  BwwContents["Movie"] = "movie";
})(BwwContents = exports.BwwContents || (exports.BwwContents = {}));

var WwContents;

(function (WwContents) {
  WwContents["Animation"] = "animation";
  WwContents["ComicBook"] = "comicbook";
  WwContents["Quiz"] = "quiz";
  WwContents["Write"] = "write";
  WwContents["Buildingword"] = "buildingword";
  WwContents["Song"] = "song";
  WwContents["Chant"] = "chant";
  WwContents["Storybook"] = "storybook";
  WwContents["Rhymebook"] = "rhymebook";
  WwContents["Audio"] = "audio";
})(WwContents = exports.WwContents || (exports.WwContents = {}));

},{}],66:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramInfo = void 0;

var util_1 = require("../common/util/util");

var get_data_1 = require("../data/get-data");

var data_interface_1 = require("./data-interface");

var ProgramInfo = /*#__PURE__*/function () {
  function ProgramInfo(singleton) {
    (0, _classCallCheck2["default"])(this, ProgramInfo);
    this.userBooks = {
      wfta: [],
      ww: [],
      bww: []
    };
  }

  (0, _createClass2["default"])(ProgramInfo, [{
    key: "setContentType",
    // 책 종류 설정
    value: function setContentType() {
      if (this.contentType) {
        this.contentType = null;
      }

      this.contentType = this.getContentType();
      this.bookData = new get_data_1.BookData();
      this.bookData.setContentType(this.contentType);
    } // 컨텐츠 종류를 돌려준다.

  }, {
    key: "getContentType",
    value: function getContentType() {
      if (this.contentType) {
        return this.contentType;
      }

      var param = this.getParam()[0].split('#')[1];
      var paramLst = param.split('?');

      if (paramLst.length > 1) {
        param = paramLst[0];
      }

      return data_interface_1.BookType[param.toUpperCase()];
    } // 책 번호 설정

  }, {
    key: "setBookNumber",
    value: function setBookNumber(monthNum) {
      this.bookNumber = monthNum;
    } // 책 번호 돌려준다.

  }, {
    key: "getBookNumber",
    value: function getBookNumber() {
      var params = +this.getParam()[1];

      if (isNaN(params)) {
        return this.bookNumber;
      }

      this.bookNumber = +params;
      return this.bookNumber;
    } // 내부 컨텐츠 번호 설정

  }, {
    key: "setContentInnerNumber",
    value: function setContentInnerNumber(num) {
      if (this.getContentType() === data_interface_1.BookType.BWW) {
        this.contentInnerNumber = this.getBookNumber();
        return;
      }

      this.contentInnerNumber = num;
    } //내부 컨텐츠 번호를 돌려준다.

  }, {
    key: "getContentInnerNumber",
    value: function getContentInnerNumber() {
      var params = this.getParam();
      var innerNumber = params[2];
      this.setContentInnerNumber(+innerNumber);
      return this.contentInnerNumber;
    } // 현재의 컨텐츠 설정

  }, {
    key: "setCurrentContent",
    value: function setCurrentContent(content) {
      this.currentContent = content;
    } // 현재 컨텐츠 돌려준다.

  }, {
    key: "getCurrentContent",
    value: function getCurrentContent() {
      if (this.currentContent) {
        return this.currentContent;
      }

      var params = this.getParam();
      var content = params[params.length - 1];
      this.setCurrentContent(content);
      return content;
    } // url 파라미터 돌려준다.

  }, {
    key: "getParam",
    value: function getParam() {
      var url = new URL(location.href);
      return url.hash.split('/');
    }
  }, {
    key: "getVariable",
    value: function getVariable(word) {
      var variable = location.href.split('?')[1];
      var urlParams = new URLSearchParams(variable);
      return urlParams.get(word);
    } // 재생 비디오 설정

  }, {
    key: "setVideoUrl",
    value: function setVideoUrl(url) {
      this.videoUrl = url;
    } // 재생 비디오 돌려준다.

  }, {
    key: "getVideoUrl",
    value: function getVideoUrl() {
      if (this.videoUrl) {
        return this.videoUrl;
      }

      var videoUrl = "./video/".concat(this.getContentType());

      if (this.getContentType() === data_interface_1.BookType.BWW) {
        videoUrl = "".concat(videoUrl, "/content").concat(this.getBookNumber(), "/").concat(this.getCurrentContent(), ".mp4");
      }

      if (this.getContentType() === data_interface_1.BookType.WW || this.getContentType() === data_interface_1.BookType.WFTA) {
        videoUrl = "".concat(videoUrl, "/").concat((0, util_1.get10Check)(this.getBookNumber()), "/S").concat(this.getContentInnerNumber(), "/").concat(this.getCurrentContent(), ".mp4");
      }

      return videoUrl;
    }
  }, {
    key: "getVideoName",
    value: function getVideoName() {
      if (this.videoUrl) {
        var nameLst = this.videoUrl.split('/');
        var fileName = nameLst[nameLst.length - 1].split('.')[0];
        return fileName;
      }

      return '';
    }
  }, {
    key: "getMrArCheck",
    value: function getMrArCheck() {
      var fileStr = this.getVideoName();
      var mrAr = fileStr.split('_')[1];
      return mrAr;
    }
  }, {
    key: "getBackUrl",
    value: function getBackUrl() {
      var params = this.getParam();
      params.splice(params.length - 1, 1);
      var backUrl = params.join('/');
      return backUrl;
    } // 책의 이름을 돌려준다.

  }, {
    key: "getBookName",
    value: function getBookName() {
      if (this.bookData === undefined) {
        this.setContentType();
      }

      var bookList = this.bookData.getList();
      var bookVolume = this.getBookNumber() - 1;
      var bookInnverNumber = this.getContentInnerNumber() - 1;
      console.log('bookList', bookList);

      if (isNaN(bookInnverNumber)) {
        return bookList[bookVolume];
      }

      return bookList[bookVolume][bookInnverNumber];
    }
  }, {
    key: "getBookList",
    value: function getBookList() {
      if (this.bookData === undefined) {
        this.setContentType();
      }

      return this.bookData.getList();
    }
  }, {
    key: "getBookTitle",
    value: function getBookTitle() {
      return this.getBookList()[this.getBookNumber() - 1][this.getContentInnerNumber() - 1];
    }
  }, {
    key: "setContentBackData",
    value: function setContentBackData(select) {
      this.contentBackBool = select;
    }
  }, {
    key: "getContentBackData",
    value: function getContentBackData() {
      return this.contentBackBool;
    }
  }, {
    key: "setUserBooks",
    value: function setUserBooks(books) {
      var _this = this;

      books.forEach(function (bookData) {
        var bookTypeStr = bookData.bookType;

        _this.userBooks[bookTypeStr].push(bookData);
      });
    }
  }, {
    key: "getUserBooks",
    value: function getUserBooks() {
      var targetType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (targetType) {
        return this.userBooks[targetType];
      }

      return this.userBooks[this.getContentType().toLowerCase()];
    }
  }, {
    key: "getMonthImgPath",
    value: function getMonthImgPath(bookNumber) {
      var monthLst = ['01_March', '02_April', '03_May', '04_June', '05_July', '06_August', '07_September', '08_October', '09_November', '10_December', '11_January', '12_February'];
      return "./images/common/list/".concat(monthLst[bookNumber - 1], ".jpg");
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (this.instance) {
        return this.instance;
      }

      this.instance = new ProgramInfo(new Singleton());
      return this.instance;
    }
  }]);
  return ProgramInfo;
}();

exports.ProgramInfo = ProgramInfo;

var Singleton = function Singleton() {
  (0, _classCallCheck2["default"])(this, Singleton);
};

},{"../common/util/util":32,"../data/get-data":62,"./data-interface":65,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10}],67:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerPath = exports.wwRouterpath = exports.bwwRouterPath = exports.wftaRouterPath = void 0;

var data_interface_1 = require("../info/data-interface");

exports.wftaRouterPath = {
  wfta: 'wfta',
  wftaContent: 'wfta/:num/:num',
  wftaAni: "wfta/:num/:num/".concat(data_interface_1.WftaContents.Animation),
  wftaEbook: "wfta/:num/:num/".concat(data_interface_1.CommonContents.Ebook),
  wftaMv: "wfta/:num/:num/".concat(data_interface_1.WftaContents.Mv),
  wftaAct: "wfta/:num/:num/".concat(data_interface_1.WftaContents.Act),
  wftaMap: "wfta/:num/:num/".concat(data_interface_1.WftaContents.Map),
  wftaCharacter: "wfta/:num/:num/".concat(data_interface_1.WftaContents.Character),
  wftaCharacter_video: "wfta/:num/:num/".concat(data_interface_1.WftaContents.Character, "/video"),
  wftaPhonics: "wfta/:num/:num/".concat(data_interface_1.WftaContents.Phonics),
  wftaDictionary: "wfta/:num/:num/".concat(data_interface_1.WftaContents.Dictionary),
  wftaNextBook: "wfta/:num/:num/".concat(data_interface_1.WftaContents.NextBook),
  wftaAudio: "wfta/:num/:num/".concat(data_interface_1.WftaContents.Audio)
};
exports.bwwRouterPath = {
  bww: "bww",
  bwwContent: "bww/:num",
  bwwWord: "bww/:num/".concat(data_interface_1.BwwContents.Word),
  bwwTalking: "bww/:num/".concat(data_interface_1.BwwContents.Talking),
  bwwStory: "bww/:num/".concat(data_interface_1.BwwContents.Story),
  bwwSong: "bww/:num/".concat(data_interface_1.BwwContents.Song),
  bwwStoryBook: "bww/:num/".concat(data_interface_1.BwwContents.StoryBook),
  bwwMovie: "bww/:num/".concat(data_interface_1.BwwContents.Movie)
};
exports.wwRouterpath = {
  ww: 'ww',
  wwContent: 'ww/:num/:num',
  wwAni: "ww/:num/:num/".concat(data_interface_1.WwContents.Animation),
  wwEbook: "ww/:num/:num/".concat(data_interface_1.CommonContents.Ebook),
  wwComicBook: "ww/:num/:num/".concat(data_interface_1.WwContents.ComicBook),
  wwQuiz: "ww/:num/:num/".concat(data_interface_1.WwContents.Quiz),
  wwWrite: "ww/:num/:num/".concat(data_interface_1.WwContents.Write),
  wwBuildingWord: "ww/:num/:num/".concat(data_interface_1.WwContents.Buildingword),
  wwSong: "ww/:num/:num/".concat(data_interface_1.WwContents.Song),
  wwChant: "ww/:num/:num/".concat(data_interface_1.WwContents.Chant),
  wwStoryBook: "ww/:num/:num/".concat(data_interface_1.WwContents.Storybook),
  wwRhymeBook: "ww/:num/:num/".concat(data_interface_1.WwContents.Rhymebook),
  wwAudio: "ww/:num/:num/".concat(data_interface_1.WwContents.Audio)
};
exports.routerPath = Object.assign(Object.assign(Object.assign({
  index: ''
}, exports.wftaRouterPath), exports.wwRouterpath), exports.bwwRouterPath);

},{"../info/data-interface":65}],68:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bwwRouterPage = void 0;

var info_routerPath_1 = require("../info-routerPath");

var bwwRouterPage = function bwwRouterPage() {
  return [{
    path: info_routerPath_1.routerPath.bww,
    content: './contents/bww/bww.html'
  }, {
    path: info_routerPath_1.routerPath.bwwContent,
    content: './contents/bww/bww-content/bww-main.html'
  }, {
    path: info_routerPath_1.routerPath.bwwWord,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.bwwTalking,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.bwwStory,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.bwwSong,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.bwwStoryBook,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.bwwMovie,
    content: './contents/common/video-common.html'
  }];
};

exports.bwwRouterPage = bwwRouterPage;

},{"../info-routerPath":67}],69:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wftaRouterPage = void 0;

var info_routerPath_1 = require("../info-routerPath");

var wftaRouterPage = function wftaRouterPage() {
  return [{
    path: info_routerPath_1.routerPath.wfta,
    content: './contents/wfta/wfta.html'
  }, {
    path: info_routerPath_1.routerPath.wftaContent,
    content: './contents/wfta/wfta-content/wfta-main.html'
  }, {
    path: info_routerPath_1.routerPath.wftaAni,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.wftaEbook,
    content: './contents/common/ebook-common.html'
  }, {
    path: info_routerPath_1.routerPath.wftaMv,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.wftaAct,
    content: './contents/common/comic-common.html'
  }, {
    path: info_routerPath_1.routerPath.wftaMap,
    content: './contents/wfta/wfta-content/wfta-map.html'
  }, {
    path: info_routerPath_1.routerPath.wftaCharacter,
    content: './contents/wfta/wfta-content/wfta-character.html'
  }, {
    path: info_routerPath_1.routerPath.wftaCharacter_video,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.wftaPhonics,
    content: './contents/wfta/wfta-content/wfta-phonics.html'
  }, {
    path: info_routerPath_1.routerPath.wftaDictionary,
    content: './contents/wfta/wfta-content/wfta-dictionary.html'
  }, {
    path: info_routerPath_1.routerPath.wftaAudio,
    content: './contents/common/audio-common.html'
  }];
};

exports.wftaRouterPage = wftaRouterPage;

},{"../info-routerPath":67}],70:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wwRouterPage = void 0;

var info_routerPath_1 = require("../info-routerPath");

var wwRouterPage = function wwRouterPage() {
  return [{
    path: info_routerPath_1.routerPath.ww,
    content: './contents/ww/ww.html'
  }, {
    path: info_routerPath_1.routerPath.wwContent,
    content: './contents/ww/ww-main.html'
  }, {
    path: info_routerPath_1.routerPath.wwAni,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.wwEbook,
    content: './contents/common/ebook-common.html'
  }, {
    path: info_routerPath_1.routerPath.wwComicBook,
    content: './contents/common/comic-common.html'
  }, {
    path: info_routerPath_1.routerPath.wwQuiz,
    content: './contents/ww/ww-content/ww-quiz.html'
  }, {
    path: info_routerPath_1.routerPath.wwWrite,
    content: './contents/ww/ww-content/ww-write.html'
  }, {
    path: info_routerPath_1.routerPath.wwBuildingWord,
    content: './contents/ww/ww-content/ww-buildingword.html'
  }, {
    path: info_routerPath_1.routerPath.wwSong,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.wwChant,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.wwStoryBook,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.wwRhymeBook,
    content: './contents/common/video-common.html'
  }, {
    path: info_routerPath_1.routerPath.wwAudio,
    content: './contents/common/audio-common.html'
  }];
};

exports.wwRouterPage = wwRouterPage;

},{"../info-routerPath":67}],71:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Router = require("vanilla-router");

var info_routerPath_1 = require("./info-routerPath");

var router_page_bww_1 = require("./router-paths/router-page-bww");

var router_page_wfta_1 = require("./router-paths/router-page-wfta");

var router_page_ww_1 = require("./router-paths/router-page-ww");

var VanillaRouter = /*#__PURE__*/function () {
  function VanillaRouter(singleton) {
    (0, _classCallCheck2["default"])(this, VanillaRouter);
  }

  (0, _createClass2["default"])(VanillaRouter, [{
    key: "init",
    value: function init(indexObj) {
      this.indexObj = indexObj;
      this.router = new Router({
        mode: 'hash',
        page404: function page404(path) {
          console.log('"/' + path + '" Page not found');
        }
      });
      this.addRouter(this.getPathObject());
      this.router.addUriListener();
      this.router.check();
    }
  }, {
    key: "moveContent",
    value: function moveContent(pathStr) {
      this.router.navigateTo(pathStr);
    }
  }, {
    key: "addRouter",
    value: function addRouter(urls) {
      var _this = this;

      var contentsTag = document.querySelector('.contents');
      urls.forEach(function (contentPathObj) {
        _this.router.add(contentPathObj.path, function () {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
            var contentpath, htmlText;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    contentpath = contentPathObj.content;
                    _context.next = 3;
                    return this.getTargetHtmlData(contentpath);

                  case 3:
                    htmlText = _context.sent;
                    contentsTag.innerHTML = htmlText;
                    this.indexObj.startContent(this.getStartContent(contentpath));

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));
        });
      });
    }
  }, {
    key: "getPathObject",
    value: function getPathObject() {
      return [{
        path: info_routerPath_1.routerPath.index,
        content: './contents/content-select.html'
      }].concat((0, _toConsumableArray2["default"])((0, router_page_wfta_1.wftaRouterPage)()), (0, _toConsumableArray2["default"])((0, router_page_bww_1.bwwRouterPage)()), (0, _toConsumableArray2["default"])((0, router_page_ww_1.wwRouterPage)()));
    }
  }, {
    key: "getStartContent",
    value: function getStartContent(contentpath) {
      var splitLst = contentpath.split('/');
      var targetStr = splitLst[splitLst.length - 1];
      return targetStr.split('.')[0];
    }
  }, {
    key: "getTargetHtmlData",
    value: function getTargetHtmlData(targetHtml) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch(targetHtml);

              case 2:
                response = _context2.sent;
                _context2.next = 5;
                return response.text();

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (this.thisObj) {
        return this.thisObj;
      }

      this.thisObj = new VanillaRouter(new Singleton());
      return this.thisObj;
    }
  }]);
  return VanillaRouter;
}();

exports["default"] = VanillaRouter;

var Singleton = function Singleton() {
  (0, _classCallCheck2["default"])(this, Singleton);
};

},{"./info-routerPath":67,"./router-paths/router-page-bww":68,"./router-paths/router-page-wfta":69,"./router-paths/router-page-ww":70,"@babel/runtime/helpers/classCallCheck":5,"@babel/runtime/helpers/createClass":6,"@babel/runtime/helpers/interopRequireDefault":10,"@babel/runtime/helpers/toConsumableArray":19,"@babel/runtime/regenerator":22,"vanilla-router":25}]},{},[63]);
